define('viewmodels/configuration/RisksAreasfactors',['knockout', 'plugins/router', 'services/navigation', 'services/logger', 'durandal/app', 'durandal/system', 'services/appsecurity', 'viewmodels/GeneralSettings', 'services/utils', 'viewmodels/configuration/InherentSetup'], function (ko, router, navigation, logger, app, system, appsecurity, ObjGeneralSettings, utils, InherentSetup) {
    var title = 'Heat Map';

    var HmViewModel = {
        activate: activate,
        attached: attached,
        detached: detached,
        title: title,
        utils: utils,
        appsecurity: appsecurity,
        InherentSetup: InherentSetup,
        addPopUpCss: ko.observable(true),
        editPopUpCss: ko.observable(true),
        EditAreaVisible: ko.observable(false),
        EditFactorVisible: ko.observable(false),
        EditSubFactorVisible: ko.observable(false),
        CurrentRiskFactorType: ko.observable(),
        SubFactorAssessmentTypeList: ko.observableArray([]),
        SelectedAssessmentTypeSubFactor: ko.observable(),
        SelectedAssessmentTypeSubFactorEdit: ko.observable(),
        RiskAreaSortOrder: ko.observable(),
        RiskFactorSortOrder: ko.observable(),
        RiskSubFactorSortOrder: ko.observable(),
        RiskAreaId: ko.observable(),
        ScaleList: ko.observableArray([]),
        SaveRiskSubFactorSortOrder: SaveRiskSubFactorSortOrder,
        DownFunctionalityRiskArea: DownFunctionalityRiskArea,
        UpFunctionalityRiskArea: UpFunctionalityRiskArea,
        UpFunctionalityRiskFactor: UpFunctionalityRiskFactor,
        UpFunctionalityRiskSubFactor: UpFunctionalityRiskSubFactor,
        SaveRiskFactorSortOrder: SaveRiskFactorSortOrder,
        CancelRiskFactorSortOrder: CancelRiskFactorSortOrder,
        CancelRiskSubFactorSortOrder: CancelRiskSubFactorSortOrder,

        DownFunctionalityRiskFactor: DownFunctionalityRiskFactor,
        DownFunctionalityRiskSubFactor: DownFunctionalityRiskSubFactor,
        OpenRiskSubFactorOrderPopup: OpenRiskSubFactorOrderPopup,
        popUpTitle: ko.observable(),
        editableRiskArea: ko.observable(),
        RiskFactorList: ko.observableArray(),
        SelectedRiskAreaDetails: ko.observableArray(),
        SurveyDetailsList: ko.observableArray(),
        RiskAreaList: ko.observableArray(),
        RiskAreaReorderList: ko.observableArray(),
        RiskAreaReorderListDup: ko.observableArray(),
        RiskFactorReorderList: ko.observableArray(),
        RiskFactorReorderListDup: ko.observableArray(),
        RiskSubFactorReorderList: ko.observableArray(),
        RiskSubFactorReorderListDup: ko.observableArray(),
        FactorAssessmentTypeList: ko.observableArray(),
        FactorAssessmentTypeListModified: ko.observableArray(),
        SaveRiskAreaSortOrder: SaveRiskAreaSortOrder,
        CancelRiskAreaSortOrder: CancelRiskAreaSortOrder,
        OpenRiskAreaOrderPopup: OpenRiskAreaOrderPopup,
        OpenRiskFactorOrderPopup: OpenRiskFactorOrderPopup,
        deleteRiskAreafunction: deleteRiskAreafunction,
        deleteRiskArea: deleteRiskArea,
        ShowFactorPopUp: ShowFactorPopUp,
        editableRiskFactor: ko.observable(),
        saveRiskFactorPopUpButton: saveRiskFactorPopUpButton,
        editFunctionalityRF: editFunctionalityRF,
        deleteFunctionalityRF: deleteFunctionalityRF,
        CalculationCheckboxdisabled: ko.observable(),

        trclick: trclick,
        RiskSubFactorsList: ko.observableArray(),
        addRiskSubFactorFunctionality: addRiskSubFactorFunctionality,
        deleteRiskSubFactorFunctionality: deleteRiskSubFactorFunctionality,
        editRiskSubFactorFunctionality: editRiskSubFactorFunctionality,
        RiskFactorId: ko.observable(),
        AMLRiskLevel: ko.observable(),
        SANCRiskLevel: ko.observable(),
        editableRiskSubFactor: ko.observable(),
        AMLRiskLevelDrpDwnList: ko.observableArray(),
        RiskScoreDrpDwnList: ko.observableArray(),
        SanctionRiskLevelDrpDwnList: ko.observableArray(),
        saveRsfButton: saveRsfButton,
        //cancelRsfButton: cancelRsfButton,
        rsfPopUpTitle: ko.observable(),
        valueAML: ko.observable(),
        valueSANC: ko.observable(),
        valueAMLScore: ko.observable(),
        valueSANCScore: ko.observable(),
        ControlsAccess: ko.observable(false),
        AssessmentTypeFactor: ko.observable(),
        AssessmentTypeSubFactor: ko.observable(),
        AssessmentTypeSubFactorParent: ko.observable(),
        AssessmentTypeSubFactorDisabled: ko.observable(true),
        AssessmentTypeFactorDisabled: ko.observable(true),
        AssessmentTypeAreaDisabled: ko.observable(true),
        CurrentRiskAreaId: ko.observable(),
        CurrentRiskAreaType: ko.observable(),
        AMLNumbering: ko.observable(),
        SANCNumbering: ko.observable(),
        AMLRSFNumbering: ko.observable(),
        SANCRSFNumbering: ko.observable(),
        AMLScoreVisible: ko.observable(false),
        SANCScoreVisible: ko.observable(false),
        SelectedAssessmentType: ko.observableArray([]),
        SelectedLanguageType: ko.observableArray([]),
        AssessmentTypeList: ko.observable(),//addedd to host the assessment type data
        CurrentScreenName: ko.observable(''),
        getIRSdata: getIRSdata,
        // added for subfactor risk socre
        setTriggerAttach: true,
        FreezeConfigurationsByScreen: FreezeConfigurationsByScreen,
        RiskAreaTypeUI: ko.observable(),
        OpenConfigureResponseTypePopup: OpenConfigureResponseTypePopup,
        deleteResponseItem: deleteResponseItem,
        deleteResponseButton: deleteResponseButton,
        SaveResponseType: SaveResponseType,
        editableResponseType: ko.observable(),
        Avgtyperdbchanged: Avgtyperdbchanged,
        responsepapplicabilityclick: responsepapplicabilityclick,
        GetQuanResponseColumnDetails: GetQuanResponseColumnDetails,
        ValidateResponses: ValidateResponses,
        WeightedAverageType: ko.observable(false),
        ActionChanged: ActionChanged,
        ApplicabilityRelHeaderEvent: ApplicabilityRelHeaderEvent,
        SelectedAssessmentTypeFactor: ko.observableArray([]),
        SelectedAssessmentTypeFactorEdit: ko.observableArray([]),
        ObjGeneralSettings: ObjGeneralSettings,
        LanguageList: ko.observableArray(),
        LanguageAdded: LanguageAdded,
        RiskAreaSubList: ko.observableArray(),
        LanguageDropdownVisible: ko.observable(true),
        editableResponseTypes: ko.observableArray(),
        isGlobalFlag: ko.observable(),
        AddResponseType: AddResponseType,
        ApplicabilityChanged: ApplicabilityChanged,
        AssessmentType: ko.observable(),
        AssessmentTypeColumnList: ko.observableArray(),
        FactorWeightedAverageType: ko.observable(),
        assessmentSelected: ko.observable(false),
        editableResponseTypesForFactor: ko.observableArray(),
        AvgtyperdbchangedFactor: AvgtyperdbchangedFactor,
        LanguageddFactorVisible: ko.observable(true),
        SelectedLanguageFactorType: ko.observableArray([]),
        LanguageFactorAdded: LanguageFactorAdded,
        FactorRiskAreaList: ko.observableArray(),
        ObjFactorRiskAreaList: ko.observableArray(),
        GetFactorQuanResponseAndLanguages: GetFactorQuanResponseAndLanguages,
        GetRiskFactorLangList: GetRiskFactorLangList,
        UpdateRiskAreaLangList: ko.observableArray(),
        SelectedLanguageSubFactorType: ko.observableArray([]),
        LanguageSubFactorAdded: LanguageSubFactorAdded,
        SubFactorRiskAreaList: ko.observableArray(),//sub factor
        SubFactorAddAreaList: ko.observableArray(),//sub factor
        InherentRiskLevelList: ko.observableArray(),
        InherentRiskLevelListDup: ko.observableArray(),
        calculationFactor: ko.observable(true),
        InputChangedArea: InputChangedArea,
        InputChangedFactor: InputChangedFactor,
        InputChangedSubFactor: InputChangedSubFactor,
        isGlobalFlagChange: isGlobalFlagChange,
        SimpleAverageType: ko.observable(false),
        UploadFileSize: ko.observable(1073741824),
        RiskAreaName: ko.observable(),
        QuestionTypeChangedSubFactor: QuestionTypeChangedSubFactor,
        HeaderSubFactorType: ko.observable(),
        resetRadioButtons: resetRadioButtons,
        SubfactorQuestionType: ko.observable(null),
        HeaderTypeSubFactor: ko.observable(false),

        //Inherent Setup
        RATActionChanged: RATActionChanged,
        RATActionChangedEdit: RATActionChangedEdit,
        InherentSetupQuantObj: ko.observableArray([]),
        ZATRATList: ko.observableArray([]),
        ZATRATListDup: ko.observableArray([]),
        ZATRATListLength: ko.observable(),
        ZATDropDownList: ko.observableArray([]),
        SelectedZATDropDownList: ko.observableArray([]),
        SelectedZATRATList: ko.observableArray([]),
        SelectedAssessmentTypeEdit: ko.observableArray([]),
        SelectedZATDropDownListEdit: ko.observableArray([]),
        AssessmentTypeListModified: ko.observableArray([]),
        ZATDropDownListModified: ko.observableArray([]),
        HeaderSubFactorsList: ko.observableArray([]),
        HeaderSubFactorsDropDownList: ko.observableArray([]),
        AddAreaFlag: ko.observable(),
        AreaLeveljstree: ko.observable(),
        HideFilterDiv: HideFilterDiv,
        ShowFilterDiv: ShowFilterDiv,
        SelectedAreaName: ko.observable(),
        BreadCrumbArray: ko.observableArray([]),
        ToggleNavigationMenu1: ToggleNavigationMenu1,
        ToggleNavigationMenu2: ToggleNavigationMenu2,
        CollapseAllTreeView: CollapseAllTreeView,
        ExpandAllTreeView: ExpandAllTreeView,
        QuestionGuideline: ko.observable(),
        OptionsTypeList: ko.observableArray([]),
        showNonQuantitativeOption: ko.observable(false),
        currentResponseOptionType: ko.observableArray([]),
        hasChildNodes: ko.observable(false),
        GetRiskLevels: GetRiskLevels,
        RiskScales: ko.observable(),
        NavigationMenuHideShow: NavigationMenuHideShow,

        LocaleCheckFlag: ko.observable(false)
    };
    HmViewModel.AssessmentTypeSubFactor.subscribe(function (newvalue) {
        if (newvalue) {
            if (HmViewModel.AssessmentTypeSubFactor().toUpperCase() == "BOTH") {
                HmViewModel.AMLScoreVisible(true);
                HmViewModel.SANCScoreVisible(true);
            }
            else if (HmViewModel.AssessmentTypeSubFactor().toUpperCase() == "AML") {
                HmViewModel.AMLScoreVisible(true);
                HmViewModel.SANCScoreVisible(false);
            }
            else if (HmViewModel.AssessmentTypeSubFactor().toUpperCase() == "SANCTIONS" || HmViewModel.AssessmentTypeSubFactor().toUpperCase() == "SANC") {
                HmViewModel.AMLScoreVisible(false);
                HmViewModel.SANCScoreVisible(true);

            }
        }
    });
    return HmViewModel;


    var GetAllRiskAreaAjax = {};
    var GetAllRiskFactorAjax = {};
    var AddRiskAreaAjax = {};
    var GetAllRiskSubFactorsAjax = {};
    var isEdit, isRsfEdit = false;


    function activate(DataObj) {
        try {

            $('#adddivtab').on('click', function () {
            });
            HmViewModel.InherentSetupQuantObj(DataObj.InherentSetupQuantObj);

            if (HmViewModel.ObjGeneralSettings === undefined || HmViewModel.ObjGeneralSettings.LocalizedTextList() === undefined || ((HmViewModel.ObjGeneralSettings.LocalizedTextList() !== undefined || HmViewModel.ObjGeneralSettings.LocalizedTextList() !== null) && HmViewModel.ObjGeneralSettings.LocalizedTextList().length === 0)) {
                HmViewModel.ObjGeneralSettings.GetLocalizedData().then(function () {
                    if (HmViewModel.ObjGeneralSettings.LocalizedTextList() == undefined || HmViewModel.ObjGeneralSettings.LocalizedTextList() == null || HmViewModel.ObjGeneralSettings.LocalizedTextList().length <= 0 || HmViewModel.ObjGeneralSettings.LocalizedIndexList() == undefined || HmViewModel.ObjGeneralSettings.LocalizedIndexList() == null)
                        HmViewModel.LocaleCheckFlag(false);
                    else
                        HmViewModel.LocaleCheckFlag(true);
                });
            } else
                HmViewModel.LocaleCheckFlag(true);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: activate() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    };

    function detached() {
        try {
            $($(document.getElementsByClassName('list-group-item')).get(4)).removeClass('active');
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: detached() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    };

    function attached() {
        try {

            if (HmViewModel.ObjGeneralSettings === undefined || HmViewModel.ObjGeneralSettings.LocalizedTextList() === undefined || ((HmViewModel.ObjGeneralSettings.LocalizedTextList() !== undefined || HmViewModel.ObjGeneralSettings.LocalizedTextList() !== null) && HmViewModel.ObjGeneralSettings.LocalizedTextList().length === 0)) {
                HmViewModel.ObjGeneralSettings.GetLocalizedData().then(function () {
                    if (HmViewModel.ObjGeneralSettings.LocalizedTextList() == undefined || HmViewModel.ObjGeneralSettings.LocalizedTextList() == null || HmViewModel.ObjGeneralSettings.LocalizedTextList().length <= 0 || HmViewModel.ObjGeneralSettings.LocalizedIndexList() == undefined || HmViewModel.ObjGeneralSettings.LocalizedIndexList() == null)
                        HmViewModel.LocaleCheckFlag(false);
                    else
                        HmViewModel.LocaleCheckFlag(true);
                });
            }

            $('#error').hide();
            $("#divNavSwitch2").hide();
            $('#loadingMainImgDiv').show();
            if (appsecurity.isConfigurationFreeze() === undefined) {
                appsecurity.GetConfigurationFreezeFlag().then(function () {
                    if (appsecurity.WriteAccess() == true && !appsecurity.isConfigurationFreeze()) {
                        HmViewModel.ControlsAccess(true);
                    }
                    else {
                        HmViewModel.ControlsAccess(false);
                    }
                });
            }
            else if (appsecurity.WriteAccess() && !appsecurity.isConfigurationFreeze()) {
                HmViewModel.ControlsAccess(true);
            }
            else {
                HmViewModel.ControlsAccess(false);
            }
            var url = window.location.pathname;
            HmViewModel.CurrentScreenName(url.substring(url.lastIndexOf('/') + 1));
            GetAllSurveyCategories();
            //GetConfigurationFreezeStatusByScreen();
            $($(document.getElementsByClassName('list-group-item')).get(4)).addClass('active');
            $($(document.getElementsByClassName('nav navbar-nav navbar-left')).get(4)).addClass('active');
            GetAllAssessmentTypes();

            $("#adddivtabdiv").tabs();
            // added for getting risk score level
            GetAllInherentLevels();
            getIRSdata();

            GetRiskLevels();
            GetQuanResponseColumnDetails();
            GetAllOptionsType();
            NavigationMenuHideShow('Show');

            // CKEDITOR.replace('addGuideline');
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: attached() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    };

    function GetRiskLevels() {
        try {
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            $.ajax({
                url: "/api/Configuration/GetRiskLevels",
                type: "GET",
                headers: headers,
                data: { "AssessmentId": HmViewModel.InherentSetupQuantObj().SurveyCategoryId(), "RiskType": "I" }
            })
                .success(function (JsonResult, status) {
                    if (JsonResult == 0 || JsonResult == null) {

                    }
                    else {

                        if (JsonResult.CombinedRiskLevelList.length > 0) {
                            var mappedFirstList = $.map(JsonResult.CombinedRiskLevelList, function (result) {
                                return new RiskModel({ RiskLevelId: result.RiskLevelId, RiskLevelName: result.RiskLevelName });
                            });
                            HmViewModel.RiskScales(mappedFirstList);
                            //for (var i = 0; i < HmViewModel.ControlResponselvlList().length; i++) {
                            //    $("#RiskScaleOptions" + HmViewModel.ControlResponselvlList()[i].Id()).multiselect();
                            //}
                        }

                    }
                })
                .fail(function (JsonResult, status) {
                    if (error.status == 401) {
                        app.showMessage(((!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name), (!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage') == -1) ? 'Error in Edit Operation' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage')].Name, ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: GetMasterLevels() method in RiskLevel.js';
                        logger.logMessage(msg);
                    }
                });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source:ajax call in GetMasterLevels() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }

    function RiskModel(item) {
        try {
            var self = this;
            self.RiskLevelId = item.RiskLevelId;
            self.RiskLevelName = item.RiskLevelName;
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RiskModel() method in ControlSetup.js';
            logger.logMessage(msg);
        }
    }

    function ToggleNavigationMenu1() {
        var chk2 = $('#NavigationToggle2');
        chk2.prop("checked", false);
        $("#FilterAreaAccordion").toggleClass("collapsedTreeview");
        $("#bottomDivAreaType").toggleClass("col-lg-12 col-lg-9");
        $("#bottomDivAreaType").toggleClass("col-md-12 col-md-9");
        $("#bottomDivAreaType").toggleClass("col-sm-12 col-sm-9");
        $("#bottomDivAreaType").toggleClass("col-xs-12 col-xs-9");
        $("#divNavSwitch2").show();
        $("#divjsTree").hide();
    }
    function ToggleNavigationMenu2() {
        var chk1 = $('#NavigationToggle1');
        chk1.prop("checked", true);
        $("#FilterAreaAccordion").toggleClass("collapsedTreeview");
        $("#bottomDivAreaType").toggleClass("col-lg-12 col-lg-9");
        $("#bottomDivAreaType").toggleClass("col-md-12 col-md-9");
        $("#bottomDivAreaType").toggleClass("col-sm-12 col-sm-9");
        $("#bottomDivAreaType").toggleClass("col-xs-12 col-xs-9");
        $("#divNavSwitch2").hide();
        $("#divjsTree").show();
    }
    function CollapseAllTreeView() {
        if ($('#spanExpandAll').text() == ((!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ExpandButton') == -1) ? 'Expand' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ExpandButton')].Name())) {
            $('#jsTreeAreaLevel').treeview('collapseAll', { silent: true });
            $("#spanExpandAll").text((!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CollapseButton') == -1) ? 'Collapse' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CollapseButton')].Name());
        }
        else {
            $('#jsTreeAreaLevel').treeview('expandAll', { silent: true });
            $("#spanExpandAll").text(((!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ExpandButton') == -1) ? 'Expand' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ExpandButton')].Name()));
        }
    }
    function ExpandAllTreeView() {
        $('#jsTreeAreaLevel').treeview('expandAll', { silent: true });
    }
    function RATActionChanged(data, event) {
        try {
            var selectedassessmentsType = [];
            selectedassessmentsType = HmViewModel.SelectedAssessmentType();
            HmViewModel.ZATDropDownList([]);
            var MappedList = [];
            for (var j = 0; j < selectedassessmentsType.length; j++) {
                for (var i = 0; i < HmViewModel.ZATRATList().length; i++) {
                    if (selectedassessmentsType[j] == HmViewModel.ZATRATList()[i].RAT_UID() &&
                        HmViewModel.InherentSetupQuantObj().SurveyCategoryId() != HmViewModel.ZATRATList()[i].ZAT_UID()) {
                        if (MappedList.length == 0)
                            MappedList.push(new ZATRATModel(HmViewModel.ZATRATList()[i].ZAT_UID(), HmViewModel.ZATRATList()[i].ZATName(), HmViewModel.ZATRATList()[i].RAT_UID()));
                        else {
                            var countvar = 0;
                            for (var k = 0; k < MappedList.length; k++) {
                                if (MappedList[k].ZAT_UID() == HmViewModel.ZATRATList()[i].ZAT_UID()) {
                                    countvar++;
                                }
                            }
                            if (countvar == 0)
                                MappedList.push(new ZATRATModel(HmViewModel.ZATRATList()[i].ZAT_UID(), HmViewModel.ZATRATList()[i].ZATName(), HmViewModel.ZATRATList()[i].RAT_UID()));
                        }
                    }
                }
            }
            HmViewModel.ZATDropDownList(MappedList);
            $('#ZATApplicability').multiselect();
            $('#ZATApplicability').multiselect('refresh');
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RATActionChanged() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    }


    function RATActionChangedEdit(data, event) {
        try {
            var selectedassessmentsType = [];
            for (var i = 0; i < HmViewModel.SelectedAssessmentType().length; i++) {
                selectedassessmentsType.push(HmViewModel.SelectedAssessmentType()[i]);
            }
            for (var i = 0; i < HmViewModel.SelectedAssessmentTypeEdit().length; i++) {
                selectedassessmentsType.push(HmViewModel.SelectedAssessmentTypeEdit()[i]);
            }
            HmViewModel.ZATDropDownListModified([]);
            var MappedList = [];
            for (var j = 0; j < selectedassessmentsType.length; j++) {
                for (var i = 0; i < HmViewModel.ZATRATList().length; i++) {
                    if (selectedassessmentsType[j] == HmViewModel.ZATRATList()[i].RAT_UID() &&
                        HmViewModel.InherentSetupQuantObj().SurveyCategoryId() != HmViewModel.ZATRATList()[i].ZAT_UID()) {
                        if (MappedList.length == 0 &&
                            HmViewModel.SelectedZATDropDownListEdit().indexOf(HmViewModel.ZATRATList()[i].ZAT_UID()) < 0)
                            MappedList.push(new ZATRATModel(HmViewModel.ZATRATList()[i].ZAT_UID(), HmViewModel.ZATRATList()[i].ZATName(), HmViewModel.ZATRATList()[i].RAT_UID()));
                        else {
                            var countvar = 0;
                            for (var k = 0; k < MappedList.length; k++) {
                                if (MappedList[k].ZAT_UID() == HmViewModel.ZATRATList()[i].ZAT_UID()) {
                                    countvar++;
                                }
                            }
                            if (countvar == 0 &&
                                HmViewModel.SelectedZATDropDownListEdit().indexOf(HmViewModel.ZATRATList()[i].ZAT_UID()) < 0)
                                MappedList.push(new ZATRATModel(HmViewModel.ZATRATList()[i].ZAT_UID(), HmViewModel.ZATRATList()[i].ZATName(), HmViewModel.ZATRATList()[i].RAT_UID()));
                        }
                    }
                }
            }
            HmViewModel.ZATDropDownListModified(MappedList);
            $('#ZATApplicabilityModified').multiselect();
            $('#ZATApplicabilityModified').multiselect('refresh');
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RATActionChangedEdit() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    }
    function ActionChanged(data, event) {
        try {
            if (data.QuestionType() != "H") {
                if (data.RiskMapping() == "")
                    BindDynamicHtmlForDropDowns();
                else {
                    var RiskMapping = data.RiskMapping();
                    RiskMapping = RiskMapping + "|" + HmViewModel.SelectedAssessmentTypeSubFactor().toString().trim();
                    BindDynamicHtmlForDropDownsEdit(RiskMapping.split('|'));
                }
            }
            ApplicabilityRelHeaderEvent(data, event);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ActionChanged() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    }


    function BindDynamicHtmlForDropDowns() {
        try {
            var selectedassessments = [];
            if (HmViewModel.SelectedAssessmentTypeSubFactorEdit() != undefined) {
                for (var i = 0; i < HmViewModel.SelectedAssessmentTypeSubFactorEdit().length; i++) {
                    selectedassessments.push(HmViewModel.SelectedAssessmentTypeSubFactorEdit()[i]);
                }
            }
            if (HmViewModel.SelectedAssessmentTypeSubFactor() != undefined) {
                for (var i = 0; i < HmViewModel.SelectedAssessmentTypeSubFactor().length; i++) {
                    selectedassessments.push(HmViewModel.SelectedAssessmentTypeSubFactor()[i]);
                }
            }
            $('#DynamicScoreDiv').empty();
            var DynamicHTMl = "";
            for (var j = 0; j < selectedassessments.length; j++) {
                for (var i = 0; i < HmViewModel.AssessmentTypeList().length; i++) {
                    if (parseInt(selectedassessments[j]) == HmViewModel.AssessmentTypeList()[i].AssessmentId()) {

                        DynamicHTMl += '<label class="control-label"><span>' + HmViewModel.AssessmentTypeList()[i].AssessmentName() + ' Score</span></label>' +
                            '<select id="' + HmViewModel.AssessmentTypeList()[i].AssessmentId() + '" data-bind="foreach:{data: InherentRiskLevelList, as: \'List1\'}" class="classdoesntexist form-control">' +
                            '<!-- ko if: (List1.AssessmentTypeId ==' + parseInt(selectedassessments[j]) + '|| List1.AssessmentTypeId == 99999)-->' +
                            '<!-- ko if: !(List1.isQuantitative ==0)-->' +
                            '<optgroup data-bind="attr: {label: RiskLevelName}, foreach: MappedRiskLevels">' +
                            '<option data-bind="text: RiskLevelDescription,value:RiskLevelId"></option>' +
                            '</optgroup>' +
                            '<!--/ko -->' +
                            '<!--/ko -->' +
                            '</select>';
                    }
                }
            }
            document.getElementById('DynamicScoreDiv').innerHTML = DynamicHTMl
            ko.cleanNode(document.getElementById('DynamicScoreDiv'));
            ko.applyBindings(HmViewModel, document.getElementById("DynamicScoreDiv"));

            if (HmViewModel.SelectedLanguageSubFactorType().length > 2 || selectedassessments.length > 2) {

                $("#frmSubFactorScroll").css({ "height": "auto", "max-height": "50rem", "overflow-y": "scroll", "overflow-x": "hidden" });
                $("modalContent").css({ "height": "auto", "max-height": "65rem" });
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: BindDynamicHtmlForDropDowns() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    }

    function ApplicabilityRelHeaderEvent(data, event) {
        try {
            var selectedassessments = [];
            if (HmViewModel.SelectedAssessmentTypeSubFactor() != undefined) {
                for (var i = 0; i < HmViewModel.SelectedAssessmentTypeSubFactor().length; i++) {
                    selectedassessments.push(HmViewModel.SelectedAssessmentTypeSubFactor()[i].toString().trim());
                }
            }
            if (HmViewModel.SelectedAssessmentTypeSubFactorEdit() != undefined) {
                for (var i = 0; i < HmViewModel.SelectedAssessmentTypeSubFactorEdit().length; i++) {
                    selectedassessments.push(HmViewModel.SelectedAssessmentTypeSubFactorEdit()[i].toString().trim());
                }
            }
            selectedassessments.sort();
            var selectedassessmentsString = "";
            for (var i = 0; i < selectedassessments.length; i++) {
                if (i == 0)
                    selectedassessmentsString += selectedassessments[i].toString().trim();
                else
                    selectedassessmentsString += ',' + selectedassessments[i].toString().trim();
            }
            var MappedHeaderList = [];
            var TempHeaderUID = data.HeaderUID();
            HmViewModel.HeaderSubFactorsDropDownList([]);

            for (var h = 0; h < HmViewModel.HeaderSubFactorsList().length; h++) {
                var ApplicableRATIds = HmViewModel.HeaderSubFactorsList()[h].ApplicableRATId().split(',');
                ApplicableRATIds.sort();
                var ApplicableRATIdString = "";
                for (var i = 0; i < ApplicableRATIds.length; i++) {
                    if (i == 0)
                        ApplicableRATIdString += ApplicableRATIds[i].toString().trim();
                    else
                        ApplicableRATIdString += ',' + ApplicableRATIds[i].toString().trim();
                }
                if ((selectedassessmentsString.toString() == ApplicableRATIdString.toString() ||
                    ApplicableRATIdString.toString().includes(selectedassessmentsString.toString())) &&
                    data.RiskSubfactorId() != HmViewModel.HeaderSubFactorsList()[h].HeaderSubFactorId()) {
                    MappedHeaderList.push(HmViewModel.HeaderSubFactorsList()[h]);
                }
            }

            HmViewModel.HeaderSubFactorsDropDownList(MappedHeaderList);
            HmViewModel.HeaderSubFactorsDropDownList.valueHasMutated();
            data.HeaderUID(TempHeaderUID);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ApplicabilityRelHeaderEvent() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    }


    //Function to bind the applicability Dropdown Dynamically starts here
    function GetAllAssessmentTypes() {
        try {
            $.ajax({
                url: "/api/Configuration/GetAssessmentTypesByCategory",
                type: "GET",
                headers: appsecurity.getSecurityHeaders(),
                data: { "ZATId": HmViewModel.InherentSetupQuantObj().SurveyCategoryId() }
            })
                .success(function (jsonResult, error) {
                    var AssessmentIdArray = [];
                    HmViewModel.AssessmentTypeList([]);
                    if (jsonResult != null) {


                        var MappedAssessmentList = $.map(jsonResult, function (result) {
                            AssessmentIdArray.push(result.AssessmentId);
                            return new AssessmentListModel(result);
                        });
                        HmViewModel.AssessmentTypeList(MappedAssessmentList);
                        InitiateAreaLevelTree(AssessmentIdArray.join());
                    }
                })
                .fail(function (jsonResult, error) {
                    logger.logError(((!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('FetchAssessmentsError') == -1) ? 'An error has occurred while fetching the type assessments. Please contact your Administrator.' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('FetchAssessmentsError')].Name()), 'Error', system.getModuleId(HmViewModel), true);
                });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: GetAllAssessmentTypes() method in RiskAreasfactors.js';
            logger.logMessage(msg);
        }
    }
    //Function to bind the applicability Dropdown ends here
    //Structure to get the new tree structure starts here
    function InitiateAreaLevelTree(AssessmentIdList) {
        var csrfToken = $("input[name='__RequestVerificationToken']").val();
        var headers = appsecurity.getSecurityHeaders();
        headers.__RequestVerificationToken = csrfToken;
        getJsTreeAreaLevel = {
            url: "/api/Configuration/GetEALData",
            type: "GET",
            data: {
                RiskAreType: 'QTDR',
                SurveyCategoryID: HmViewModel.InherentSetupQuantObj().SurveyCategoryId().toString(),
                AssessmentTypes: AssessmentIdList,
                ScreenType: 'QTDR'
            },
            headers: headers
        };
        $.ajax(getJsTreeAreaLevel)
            .success(ajaxSuccess)
            .fail(ajaxFail);

        function ajaxSuccess(jsonResult, status) {

            $('#loadingMainImgDiv').hide();
            $('#error').hide();
            if (jsonResult != null) {
                //implement js tree logic here
                HmViewModel.AreaLeveljstree(jsonResult.AreaLevelsData);
                var MappedJsTreeList = $.map(jsonResult.AreaLevelsData["#"], function (result) {
                    return new jsTreeModel(result);
                });

                $('#jsTreeAreaLevel').treeview({
                    data: MappedJsTreeList,
                    onNodeSelected: nodeClickEvent
                });

                var hasChildNodes = ko.utils.arrayFilter(MappedJsTreeList, function (i) { if (i.dead_node != 1) { return i; } }).length > 0
                HmViewModel.hasChildNodes(hasChildNodes);
                //for initial load expand for treeview
                $("#jsTreeAreaLevel ul:first li:first").trigger("click");
            }

        }

        function nodeClickEvent(event, node) {
            // Your logic goes here
            if (node.dead_node == 1) {
                //select node explicitly in case of recursive calling activity.
                $('#jsTreeAreaLevel').treeview('selectNode', [node.nodeId, { silent: true }]);

                HmViewModel.CurrentRiskAreaId(parseInt(node.id));
                $('#loadingMainImgDivFactors').show();
                HmViewModel.SelectedAreaName(node.text);
                HmViewModel.CurrentRiskAreaType(node.assessmentTypeList());
                GetRiskFactors(parseInt(node.id));

            } else {
                //recursively opening until the dead_node arrives.
                if (!(node.state.expanded))
                    nodeClickEvent(event, node.nodes[0]);
                $('#jsTreeAreaLevel').treeview((!(node.state.expanded) ? 'expandNode' : 'collapseNode'), [node.nodeId]);
                $('#jsTreeAreaLevel').treeview('unselectNode', [node.nodeId, { silent: true }]);


            }
        }

        function ajaxFail(error, status) {

            try {
                if (error.status == 401) {
                    app.showMessage(((!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name), (!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage') == -1) ? 'Error in Edit Operation' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage')].Name, ["OK"], false, {
                        buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login'
                    })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllRiskAreas() method in QualitativeSetup.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllRiskAreas() method in QualitativeSetup.js';
                logger.logMessage(msg);
            }
        }

    }

    function NavigationMenuHideShow(data) {
        try {
            if (data == "Hide") {
                // Hides Area NavigationMenu
                $('#HideNavMenu').hide();
                $('#ShowNavMenu').show();
                $('#FilterAreaAccordion').hide();
                $("#tabdiv").removeClass("col-lg-9").addClass("col-lg-12");
                $(".rabrd").addClass("raBreadcrumb");

            }
            else {
                // Shows Area NavigationMenu
                $('#HideNavMenu').show();
                $('#ShowNavMenu').hide();
                $('#FilterAreaAccordion').show();
                $("#tabdiv").removeClass("col-lg-12").addClass("col-lg-9");
                $(".rabrd").removeClass("raBreadcrumb");
            }

            //if (AMLQsViewModel.ClickedRiskAreaType() === 'QUAL')
            //    RestructureQualitative();
            //else
            //    RestructureQuan();

        } catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajaxFail in NavigationMenuHideShow() method in AmlInherentRiskAssessment.js';
            logger.logMessage(msg);
        }
    }
    //ends here
    function HideFilterDiv() {
        $("#FilterAreaAccordion").hide();

        $("#FilterAreaAccordion").removeClass("col-lg-3");
        $("#FilterAreaAccordion").removeClass("col-md-3");
        $("#FilterAreaAccordion").removeClass("col-sm-3");
        $("#FilterAreaAccordion").removeClass("col-xs-3");

        $("#btnShowFilterDiv").show();


    }

    function ShowFilterDiv() {
        $("#FilterAreaAccordion").show();

        $("#btnShowFilterDiv").hide();
        $("#FilterAreaAccordion").addClass("col-lg-3");
        $("#FilterAreaAccordion").addClass("col-md-3");
        $("#FilterAreaAccordion").addClass("col-sm-3");
        $("#FilterAreaAccordion").addClass("col-xs-3");



    }




    //Function to bind the survey categories Dropdown Dynamically starts here
    function GetAllSurveyCategories() {
        try {
            var headers = appsecurity.getSecurityHeaders();
            $.ajax({
                url: "/api/Configuration/GetAllSurveyCategories",
                type: "GET",
                headers: headers
            })
                .success(function (jsonResult, error) {
                    if (jsonResult != null && jsonResult.length > 0) {
                        HmViewModel.ZATRATListLength(jsonResult.length);
                        HmViewModel.ZATRATList([]);
                        for (var i = 0; i < jsonResult.length; i++) {

                            var splitID = $.map(jsonResult[i].AssessmentTypeId.split(","), $.trim);
                            for (var j = 0; j < splitID.length; j++) {
                                HmViewModel.ZATRATList().push(new ZATRATModel(jsonResult[i].SurveyCategoryId, jsonResult[i].SurveyCategoryName, splitID[j]));
                            }

                        }
                        HmViewModel.ZATRATListDup(HmViewModel.ZATRATList());
                    }

                    else
                        logger.logError(
                            //'Some error occured while deleting the assessment type. Please contact your Administrator.'
                            ((!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AssessmentTypeDeleteFail') == -1) ? 'Some error occured while deleting the assessment type. Please contact your Administrator.' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AssessmentTypeDeleteFail')].Name())
                            , 'Error', system.getModuleId(ViewModel), true);

                })
                .fail(function (error, status) {
                    logger.logError(((!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('FetchAssessmentsError') == -1) ? 'An error has occurred while fetching the type assessments. Please contact your Administrator.' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('FetchAssessmentsError')].Name()), 'Error', system.getModuleId(ViewModel), true);
                })
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in DeleteAssessmentType() method in RisksAreasfactors.js';
            logger.logMessage(msg);
        }

    }
    //Function to bind the survey categories Dropdown ends here


    //Average type radio button click
    function Avgtyperdbchanged(data, event) {
        try {
            //Toggle the weighted average flag
            document.getElementById(event.currentTarget.id).checked = true;
            if (event.currentTarget.value == "SimpleAverage") {
                HmViewModel.WeightedAverageType(false);
            }
            else {
                HmViewModel.WeightedAverageType(true);
            }
            return true;

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SaveResponseType() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    }

    function QuestionTypeChangedSubFactor(data, event) {
        try {

            HmViewModel.SubfactorQuestionType(HmViewModel.HeaderSubFactorType());
            $('#DynamicScoreDiv').empty();
            HmViewModel.SelectedAssessmentTypeSubFactor([]);
            $('#EdiFactorAssessment').hide();
            $('#SubFactorAppTypeID').multiselect();
            if (HmViewModel.SubfactorQuestionType() == 'T') {
                var mappedassessment = $.map(HmViewModel.AssessmentTypeList(), function (result) {
                    for (var i = 0; i < HmViewModel.currentResponseOptionType().length; i++) {
                        if (HmViewModel.currentResponseOptionType()[i].AssessmentType() == parseInt(result.AssessmentId()) && HmViewModel.currentResponseOptionType()[i].OptionTypeShortName() == 'T') {
                            var RiskAreaModelObj = new FilteredAssessmentListModel(result);
                            return RiskAreaModelObj;
                        }
                    }

                });
                HmViewModel.SubFactorAssessmentTypeList(mappedassessment);
            }
            else {
                var mappedassessmentnormal = $.map(HmViewModel.AssessmentTypeList(), function (result) {
                    for (var i = 0; i < HmViewModel.CurrentRiskFactorType().length; i++) {
                        if (HmViewModel.CurrentRiskFactorType()[i].ID == parseInt(result.AssessmentId())) {
                            var RiskAreaModelObj = new FilteredAssessmentListModel(result);
                            return RiskAreaModelObj;
                        }
                    }

                });
                HmViewModel.SubFactorAssessmentTypeList(mappedassessmentnormal);
            }
            $('#SubFactorAppTypeID').multiselect('refresh');
            if (HmViewModel.SubfactorQuestionType() == 'H') {
                BindDynamicHtmlForDropDowns();
                ApplicabilityRelHeaderEvent(data, event);
            }

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: QuestionTypeChangedSubFactor() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    }

    function resetRadioButtons(data, event) {
        try {
            HmViewModel.HeaderSubFactorType("off");
            HmViewModel.SubfactorQuestionType(null);
            HmViewModel.SelectedAssessmentTypeSubFactor([]);
            $('#EdiFactorAssessment').hide();
            $('#SubFactorAppTypeID').multiselect();
            $('#SubFactorAppTypeID').multiselect('refresh');
            BindDynamicHtmlForDropDowns();
            ApplicabilityRelHeaderEvent(data, event);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: resetRadioButtons() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    }
    function LanguageAdded() {
        try {
            $('#DynamicRiskAreaNameDiv').empty();
            var RiskAreaNameHTMl = "";

            $('#DynamicCommentsDiv').empty();
            var CommentsHTMl = "";

            for (var j = 0; j < HmViewModel.SelectedLanguageType().length; j++) {
                for (var i = 0; i < HmViewModel.ObjGeneralSettings.LanguageList().length; i++) {
                    if (parseInt(HmViewModel.SelectedLanguageType()[j]) == HmViewModel.ObjGeneralSettings.LanguageList()[i].LANGUAGE_ID._latestValue) {

                        let RiskAreaPlaceholder = (!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('RiskAreaNamePlaceholder') == -1) ? 'Risk Area Name in ' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('RiskAreaNamePlaceholder')].Name();
                        let RiskAreaNotesPlaceholder = (!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('RiskAreaNotesPlaceholder') == -1) ? 'Risk Area Name in ' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('RiskAreaNotesPlaceholder')].Name();

                        RiskAreaNameHTMl += '<div class="new-form-group">' +
                            '<label class="control-label pt-0">Risk Area Name (' + HmViewModel.ObjGeneralSettings.LanguageList()[i].LANGUAGENAME() + ') </label>' +
                            '<div class="">' +
                            '<input id="riskareaname' + HmViewModel.SelectedLanguageType()[j] + '" class="form-control" placeholder="' + RiskAreaPlaceholder + " " + HmViewModel.ObjGeneralSettings.LanguageList()[i].LANGUAGENAME._latestValue + '" data-bind="value: RiskAreaSubList().RiskAreaName" type="text" />' +
                            '</div>' +
                            '</div>';

                        CommentsHTMl += '<div class="new-form-group">' +
                            '<label class="control-label pt-0">Comments (' + HmViewModel.ObjGeneralSettings.LanguageList()[i].LANGUAGENAME() + ')</label>' +
                            '<div class="">' +
                            '<textarea id="EditRaTextArea' + HmViewModel.SelectedLanguageType()[j] + '" class="form-control" rows="5" placeholder="' + RiskAreaNotesPlaceholder + " " + HmViewModel.ObjGeneralSettings.LanguageList()[i].LANGUAGENAME._latestValue + '" data-bind="value:RiskAreaSubList().RiskAreaNotes" name="Notes" ></textarea>' +
                            '</div>' +
                            '</div>';
                    }
                }
            }
            if (RiskAreaNameHTMl != "" && CommentsHTMl != "") {
                $("#frmAreaRiskScroll").css({ "height": "auto", "max-height": "50rem", "overflow-y": "scroll", "overflow-x": "hidden" });
                $("modalContent").css({ "height": "auto", "max-height": "65rem" });
            }
            document.getElementById('DynamicRiskAreaNameDiv').innerHTML = RiskAreaNameHTMl;
            ko.cleanNode(document.getElementById('DynamicRiskAreaNameDiv'));
            ko.applyBindings(HmViewModel, document.getElementById("DynamicRiskAreaNameDiv"));

            document.getElementById('DynamicCommentsDiv').innerHTML = CommentsHTMl;
            ko.cleanNode(document.getElementById('DynamicCommentsDiv'));
            ko.applyBindings(HmViewModel, document.getElementById("DynamicCommentsDiv"));
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: LanguageAdded() method in RiskAreasFactor.js';
            logger.logMessage(msg);
        }
    }

    function GetConfigurationFreezeStatusByScreen() {
        try {
            $.ajax({
                url: "/api/Configuration/GetConfigurationFreezeStatusByScreen",
                type: "GET",
                data: { "CurrentScreenName": HmViewModel.CurrentScreenName() },
                async: false,
                headers: appsecurity.getSecurityHeaders()
            })
                .success(ajaxSuccess)
                .fail(ajaxFail);
        } catch (e) {
            var msg = 'Exception: ' + e + ' | Source:ajax call from GetConfigurationFreezeStatusByScreen() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult != null) {
                    if (appsecurity.WriteAccess())
                        jsonResult ? HmViewModel.ControlsAccess(false) : HmViewModel.ControlsAccess(true);
                }
                else
                    logger.logError(((!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('FreezingConfigurationsError') == -1) ? 'An error occurred while freezing Configurations. Please contact your Administrator.' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('FreezingConfigurationsError')].Name()), 'Error', system.getModuleId(HmViewModel), true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess from GetConfigurationFreezeStatusByScreen() method in RiskArea&Factor.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage(((!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name), "Error in Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetConfigurationFreezeStatusByScreen() method in BusinessUnit.js';
                    logger.logMessage(msg);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail from GetConfigurationFreezeStatusByScreen() method in RiskArea&Factor.js';
                logger.logMessage(msg);
            }
        }
    }

    function FreezeConfigurationsByScreen() {
        try {
            app.showMessage(
                //'Are you sure you want to freeze the Configurations? Once frozen, settings cannot be updated.'
                (!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('FreezingConfigurationsConfirm') == -1) ? 'Are you sure you want to freeze the configurations? Once frozen, settings cannot be updated.' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('FreezingConfigurationsConfirm')].Name()
                //, 'Freeze Configuration Settings'
                , (!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('FreezeConfigurationSettings') == -1) ? 'Freeze Configuration Settings' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('FreezeConfigurationSettings')].Name()
                , [((!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('FreezeButton') == -1) ? 'Freeze' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('FreezeButton')].Name), (!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CancelButton') == -1) ? 'Cancel' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CancelButton')].Name], false, { primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "fa fa-times btn btn-default", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-plus text-default' })
                .then(function (option) {
                    if (option == ((!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('FreezeButton') == -1) ? 'Freeze' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('FreezeButton')].Name.toString())) {
                        SetConfigurationFreezeByScreen();
                    }
                });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: FreezeConfigurationsByScreen() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    }

    function SetConfigurationFreezeByScreen() {
        try {
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            $.ajax({
                url: "/api/Configuration/SetConfigurationFreezeByScreen",
                headers: headers,
                type: "POST",
                data: { Status: 1, CurrentScreenName: HmViewModel.CurrentScreenName() }
            })
                .success(ajaxSuccess)
                .fail(ajaxFail);
        } catch (e) {
            var msg = 'Exception: ' + e + ' | Source:ajax call from SetConfigurationFreezeByScreen() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult == "1") {
                    HmViewModel.ControlsAccess(false);
                    logger.logSuccess(
                        //'Configurations are frozen successfully.'
                        (!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('FreezingConfigurationsSuccess') == -1) ? 'Configurations are frozen successfully.' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('FreezingConfigurationsSuccess')].Name()
                        , 'Success', system.getModuleId(HmViewModel), true);
                    location.reload(true);
                }
                else if (jsonResult == "0") {
                    HmViewModel.ControlsAccess(true);
                    logger.logError(((!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('FreezingConfigurationsError') == -1) ? 'An error occurred while freezing Configurations. Please contact your Administrator.' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('FreezingConfigurationsError')].Name()), 'Error', system.getModuleId(HmViewModel), true);
                }
                else if (isNaN(jsonResult) && jsonResult.substring(0, 3) == "INC") {
                    logger.logError(jsonResult + ' - An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(HmViewModel), true);
                }
                else {
                    logger.logError(((!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('FreezingConfigurationsError') == -1) ? 'An error occurred while freezing Configurations. Please contact your Administrator.' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('FreezingConfigurationsError')].Name()), 'Error', system.getModuleId(HmViewModel), true);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess from SetConfigurationFreezeByScreen() method in RiskArea&Factor.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage(((!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name), (!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage') == -1) ? 'Error in Edit Operation' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage')].Name, ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in SetConfigurationFreezeByScreen() method in BusinessUnit.js';
                    logger.logMessage(msg);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail from SetConfigurationFreezeByScreen() method in RiskArea&Factor.js';
                logger.logMessage(msg);
            }
        }
    }

    //To disable the transactions checkbox - survey launch flag
    function GetAllSurveyType(GetAllSurveyTypeAjax) {
        try {
            return $.ajax(GetAllSurveyTypeAjax)
                .success(ajaxSuccess)
                .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax caLL in GetAllSurveyType() in RisksAreasfactors.js';
            logger.logMessage(msg);

        }

        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult != null) {
                    var mappedSurvey = $.map(jsonResult, function (result) {
                        var SurveyModelObj = new SurveyModel(result);
                        addNewDivTab(SurveyModelObj);
                        return SurveyModelObj;
                    });
                    HmViewModel.SurveyDetailsList(mappedSurvey);
                    for (i = 0; i < HmViewModel.SurveyDetailsList().length; i++)
                        if (HmViewModel.SurveyDetailsList()[i].surveyType() == "QTDR") {
                            if (HmViewModel.SurveyDetailsList()[i].SurveyStatus()) {
                                $('#responseapplicability3').attr('disabled', true);
                            }
                            else {
                                $('#responseapplicability3').attr('disabled', false);
                            }
                        }

                }
                else
                    logger.logError('An error has occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(HmViewModel), true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetAllSurveyType() in RisksAreasfactors.js';
                logger.logMessage(msg);

            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage(((!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name), (!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage') == -1) ? 'Error in Edit Operation' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage')].Name, ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllSurveyType() method in RisksAreasfactors.js';
                    logger.logMessage(msg);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllSurveyType() method in RisksAreasfactors.js';
                logger.logMessage(msg);
            }
        }
    }

    //subfactor cancel button
    //function cancelRsfButton() {
    //    try {

    //    }
    //    catch (e) {
    //        var msg = 'Exception: ' + e + ' | Source: cancelRsfButton() method in RiskArea&Factor.js';
    //        logger.logMessage(msg);
    //    }
    //}

    //subfactor popup save button
    function saveRsfButton(data) {
        try {
            //HmViewModel.QuestionGuideline(CKEDITOR.instances["subFactorGuideline"].getData());
            $('#valErrorSubfactor').hide();
            $('#valErrorSubfactor').text('');
            var duplicateCheck = 0;

            if (data.RiskSubfactorName() == "") {
                $('#valErrorSubfactor').show();
                $('#valErrorSubfactor').text(
                    //'Risk Sub-Factor name is required.'
                    ((!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('RiskSub-Factornamerequired') == -1) ? 'Risk Sub-Factor name is required.' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('RiskSub-Factornamerequired')].Name())
                );
            }
            else if (data.RiskSubfactorName().length > 500) {
                $('#valErrorSubfactor').show();
                $('#valErrorSubfactor').text(
                    //'Risk Sub-Factor name cannot exceed 200 characters. Please enter a valid Risk Sub-Factor.'
                    ((!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('RiskSub-Factornameexceed200') == -1) ? 'Risk Sub-Factor name cannot exceed 200 characters. Please enter a valid Risk Sub-Factor.' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('RiskSub-Factornameexceed200')].Name())
                );
            }
            else if (data.AssessmentType()=="" && HmViewModel.SelectedAssessmentTypeSubFactor().length == 0)
            {
                $('#valErrorSubfactor').show();
                $('#valErrorSubfactor').text(
                    //'Risk Sub-Factor name cannot exceed 200 characters. Please enter a valid Risk Sub-Factor.'
                    ((!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('RiskSub-Factorapplicability') == -1) ? 'RiskSub-Factor Applicabilty cannot be blank.' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('RiskSub-Factorapplicability')].Name())
                );
            }
            else if (!(HmViewModel.QuestionGuideline() != "undefined") ? HmViewModel.QuestionGuideline().length > 4000 : 0) {
                $('#valErrorSubfactor').show();
                $('#valErrorSubfactor').text(
                    //'Risk Sub-Factor Guideline cannot exceed 4000 characters. Please enter a valid Guideline.'
                    ((!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('RiskSub-FactorGuidelineexceed4000') == -1) ? 'Risk Sub-Factor Guideline cannot exceed 4000 characters. Please enter a valid Guideline.' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('RiskSub-FactorGuidelineexceed4000')].Name())
                );
            }
            else {
                if (!isRsfEdit) {
                    if (duplicateCheck == 1) {

                        let SubFactorAlreadyExistsText = (!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SubFactorAlreadyExistsText') == -1) ? 'already exists. Please enter a different Risk Sub-Factor.' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SubFactorAlreadyExistsText')].Name();
                        $('#valErrorSubfactor').show();
                        $('#valErrorSubfactor').text(data.RiskSubfactorName() + " " + SubFactorAlreadyExistsText);
                    }
                    else {
                        addRiskSubFactor(data);
                        if ($('#valErrorSubfactor').text() == "") {
                            $('#frmSubFactor').modal('hide');
                            $('body').removeClass('modal-open');
                            $('.modal-backdrop').remove();
                        }
                        GetQuanHeadersByRiskFactor([0, data.RiskFactorId()]); //passed as 2nd element of a list cz the func is being used already.
                        ApplicabilityRelHeaderEvent(data);
                    }
                }
                else {
                    if (duplicateCheck == 1) {
                        let SubFactorAlreadyExistsText = (!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SubFactorAlreadyExistsText') == -1) ? 'already exists. Please enter a different Risk Sub-Factor.' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SubFactorAlreadyExistsText')].Name();
                        $('#valErrorSubfactor').show();
                        $('#valErrorSubfactor').text(data.RiskSubfactorName() + " " + SubFactorAlreadyExistsText);
                    }
                    else {
                        updateRiskSubFactor(data);
                        if ($('#valErrorSubfactor').text() == "") {
                            $('#frmSubFactor').modal('hide');
                            $('body').removeClass('modal-open');
                            $('.modal-backdrop').remove();
                        }
                    }
                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: saveRsfButton() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    }

    //for updating risk sub factor
    function updateRiskSubFactor(data) {
        try {

            var editedData = data;
            var RiskLevel = "";
            var RiskMapping = "";
            var selectedassessmetId = "";
            $('#valErrorSubfactor').hide();
            var ATIds = [];
            if (HmViewModel.SelectedAssessmentTypeSubFactorEdit() != undefined) {
                for (var i = 0; i < HmViewModel.SelectedAssessmentTypeSubFactorEdit().length; i++) {
                    ATIds.push(HmViewModel.SelectedAssessmentTypeSubFactorEdit()[i].toString().trim());
                }
            }
            if (HmViewModel.SelectedAssessmentTypeSubFactor() != undefined) {
                for (var i = 0; i < HmViewModel.SelectedAssessmentTypeSubFactor().length; i++) {
                    ATIds.push(HmViewModel.SelectedAssessmentTypeSubFactor()[i].toString().trim());
                }
            }
            ATIds.sort();

            var ATIDString = "";
            var ATNameString = "";
            var ATArray = [];
            for (var j = 0; j < HmViewModel.AssessmentTypeList().length; j++) {
                var countVar = 0;
                for (var i = 0; i < ATIds.length; i++) {
                    if (HmViewModel.AssessmentTypeList()[j].AssessmentId() == ATIds[i]) {
                        countVar++;
                    }
                }
                if (countVar == 1)
                    ATArray.push(HmViewModel.AssessmentTypeList()[j]);
            }

            for (var l = 0; l < ATArray.length; l++) {
                if (l == 0) {
                    ATIDString += ATArray[l].AssessmentId();
                    ATNameString += ATArray[l].AssessmentDisplayName();
                }
                else {
                    ATIDString += "," + ATArray[l].AssessmentId();
                    ATNameString += ", " + ATArray[l].AssessmentDisplayName();

                }

            }
            for (var i = 0; i < ATArray.length; i++) {
                if (i == 0) {
                    if ($('#' + ATArray[i].AssessmentId()).val() == undefined || $('#' + ATArray[i].AssessmentId()).val() == 0) {
                        RiskLevel += ATArray[i].AssessmentDisplayName() + ":" + $('#' + ATArray[i].AssessmentId() + 'RiskLevel option:selected').text().replace(/[0-9]/g, "").replace(" -", "");
                        RiskMapping += ATArray[i].AssessmentId() + ', ' + RiskMapping + $('#' + ATArray[i].AssessmentId() + 'RiskLevel').val();
                        selectedassessmetId += $('#' + ATArray[i].AssessmentId() + 'RiskLevel').val() + ', ' + selectedassessmetId + ATArray[i].AssessmentId();
                    }
                    else {
                        RiskLevel += ATArray[i].AssessmentDisplayName() + ":" + $('#' + ATArray[i].AssessmentId() + ' option:selected').text().replace(/[0-9]/g, "").replace(" -", "");
                        RiskMapping += ATArray[i].AssessmentId() + ', ' + RiskMapping + $('#' + ATArray[i].AssessmentId()).val();
                        selectedassessmetId += $('#' + ATArray[i].AssessmentId()).val() + ', ' + selectedassessmetId + ATArray[i].AssessmentId();
                    }
                }
                else {
                    if ($('#' + ATArray[i].AssessmentId()).val() == undefined || $('#' + ATArray[i].AssessmentId()).val() == 0) {
                        RiskLevel += ", " + ATArray[i].AssessmentDisplayName() + ":" + $('#' + ATArray[i].AssessmentId() + 'RiskLevel option:selected').text().replace(/[0-9]/g, "").replace(" -", "");
                        RiskMapping += "|" + ATArray[i].AssessmentId() + ', ' + $('#' + ATArray[i].AssessmentId() + 'RiskLevel').val();
                        selectedassessmetId += "|" + $('#' + ATArray[i].AssessmentId() + 'RiskLevel').val() + ', ' + ATArray[i].AssessmentId();
                    }
                    else {
                        RiskLevel += ", " + ATArray[i].AssessmentDisplayName() + ":" + $('#' + ATArray[i].AssessmentId() + ' option:selected').text().replace(/[0-9]/g, "").replace(" -", "");
                        RiskMapping += "|" + ATArray[i].AssessmentId() + ', ' + $('#' + ATArray[i].AssessmentId()).val();
                        selectedassessmetId += "|" + $('#' + ATArray[i].AssessmentId()).val() + ', ' + ATArray[i].AssessmentId();
                    }
                }
            }

            if (selectedassessmetId == "" || selectedassessmetId == ',undefined') {
                selectedassessmetId = "";
                var assessmentTypeList = data.AssessmentType().split(',');
                for (var k = 0; k < assessmentTypeList.length; k++) {
                    for (var j = 0; j < HmViewModel.AssessmentTypeList().length; j++) {
                        if (HmViewModel.AssessmentTypeList()[j].AssessmentDisplayName() == assessmentTypeList[k]) {
                            if (k == 0) {
                                selectedassessmetId += HmViewModel.AssessmentTypeList()[j].AssessmentId();
                            }
                            else {
                                selectedassessmetId += "|" + HmViewModel.AssessmentTypeList()[j].AssessmentId();
                            }
                        }
                    }
                }
            }
            data.AssessmentTypeId(ATIDString);
            data.AssessmentType(ATNameString);
            data.RiskLevel(RiskLevel);
            if (data.QuestionType() == "H")
                data.RiskLevel("NA");
            data.RiskMapping(RiskMapping);
            if (data.RiskAreaSubList() != null && data.RiskAreaSubList().length > 0) {

                for (var i = 0; i < data.RiskAreaSubList().length; i++) {
                    data.RiskAreaSubList()[i].RiskAreaName = $('#subfactorname' + data.RiskAreaSubList()[i].LanguageType.toString()).val();
                    //validate language text boxes
                    if (data.RiskAreaSubList()[i].RiskAreaName == "") {
                        $('#valErrorSubfactor').show();

                        let SubFactorNameIn = (!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SubFactorNameIn') == -1) ? 'Sub-Factor Name in' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SubFactorNameIn')].Name();
                        let SubFactorNameIsRequired = (!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SubFactorNameIsRequired') == -1) ? 'is required.' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SubFactorNameIsRequired')].Name();
                        $('#valErrorSubfactor').text(SubFactorNameIn + " " + GetLanguageName(data.RiskAreaSubList()[i].LanguageType.toString()) + " " + SubFactorNameIsRequired);
                        return;
                    } else {
                        $('#valErrorSubfactor').text('');
                    }
                }
            }
            if ($('#valErrorSubfactor').text() == "") {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/Configuration/UpdateRiskSubFactor",
                    type: "POST",
                    data: {
                        RiskFactorId: data.RiskFactorId(), RiskSubFactorId: data.RiskSubfactorId(), RiskSubFactorName: data.RiskSubfactorName(),
                        AssessmentType: selectedassessmetId, RiskAreaSubList: data.RiskAreaSubList(), RiskLevel: data.RiskLevel(),
                        RiskMapping: data.RiskMapping(), QuestionType: data.QuestionType(), HeaderUID: data.HeaderUID(), QuestionGuideline: HmViewModel.QuestionGuideline()
                        ,CalculationApplicabilityFlag: data.CalculationApplicabilityFlag()

                    },
                    headers: headers
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail)
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in updateRiskSubFactor() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult != null) {
                    if (jsonResult == "2") {
                        let TryDifferentSubFactorName = (!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('TryDifferentSubFactorName') == -1) ? 'already exists. Please try updating with a different Name.' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('TryDifferentSubFactorName')].Name();
                        logger.logError(data.RiskSubfactorName() + " " + TryDifferentSubFactorName, 'Error', system.getModuleId(HmViewModel), true);
                    }
                    else if (jsonResult == "1") {
                        var rowIndex = data.TargetRow();
                        HmViewModel.RiskSubFactorsList()[rowIndex].RiskSubfactorId(data.RiskSubfactorId());
                        HmViewModel.RiskSubFactorsList()[rowIndex].RiskSubfactorName(data.RiskSubfactorName());
                        HmViewModel.RiskSubFactorsList()[rowIndex].QuestionGuideline(HmViewModel.QuestionGuideline());
                        // RiskScoreDrpDwnList()[HmViewModel.valueAML()];
                        if (data.RiskLevel() == "") { data.RiskLevel("NA"); }

                        let EditTitle = (!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditButton') == -1) ? 'Edit' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditButton')].Name();
                        let DeleteTitle = (!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('DeleteButton') == -1) ? 'Delete' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('DeleteButton')].Name();

                        var node = RfSubFactorTableObj.row(rowIndex).data([data.RiskSubfactorId(), data.RiskMapping(), data.RiskSubfactorName(), data.AssessmentType(), data.RiskLevel(), data.QuestionTypeDescription(), data.CalculationApplicabilityFlag() ? "Yes" : "No", '<a href="javascript:void(0)" title="' + EditTitle + '" class="btn-borderless widget-button text-center" data-bind="click: $root.editRiskSubFactorFunctionality,css: { disabled: (!$root.ControlsAccess()) }"><i class="demo-icon icon-file_edit_special"></i></a><a href="javascript:void(0)" title="' + DeleteTitle + '" class="btn-borderless widget-button text-center" data-bind="click: $root.deleteRiskSubFactorFunctionality, css: { disabled: (!$root.ControlsAccess()) }"><i class="demo-icon icon-bin_special"></i></a>']).draw(false);
                        //  RfSubFactorTableObj.draw(false);
                        ko.applyBindingsToNode($(node.node()).find('a').get(0), { click: HmViewModel.editRiskSubFactorFunctionality }, data);
                        ko.applyBindingsToNode($(node.node()).find('a').get(1), { click: HmViewModel.deleteRiskSubFactorFunctionality }, data);
                        for (var i = 0, j = HmViewModel.RiskSubFactorReorderList().length; i < j; i++) {
                            if (HmViewModel.RiskSubFactorReorderList()[i].RiskSubfactorId() == data.RiskSubfactorId()) {
                                HmViewModel.RiskSubFactorReorderList()[i].RiskSubfactorName(data.RiskSubfactorName());
                                HmViewModel.RiskSubFactorReorderListDup()[i].RiskSubfactorName(data.RiskSubfactorName());
                                break;
                            }
                        }
                        logger.logSuccess(
                            //'Risk Sub-Factor updated successfully.'
                            ((!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('RiskSub-FactorUpdateSuccess') == -1) ? 'Risk Sub-Factor updated successfully.' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('RiskSub-FactorUpdateSuccess')].Name())
                            , 'Success', system.getModuleId(HmViewModel), true);
                        var rows = $("#subfactor").dataTable().fnGetNodes();
                        var cells = [];
                        for (var i = 0; i < rows.length; i++) {
                            // Get HTML of 3rd column (for example)
                            var x = $(rows[i]).find("td:eq(3)").html();
                            var y = x.replace('|', '<br/>');
                            $(rows[i]).find("td:eq(3)").html(y);
                        }
                    }
                    else if (jsonResult == "0") {
                        logger.logError(
                            //'Risk Sub-Factor already exists. Please try updating the Risk Sub-Factor with a different name.'
                            ((!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('RiskSubFactorUpdateAlreadyExists') == -1) ? 'Risk Sub-Factor already exists. Please try updating the Risk Sub-Factor with a different name.' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('RiskSubFactorUpdateAlreadyExists')].Name())
                            , 'Error', system.getModuleId(HmViewModel), true);
                    }
                    else if (jsonResult == "-1") {
                        logger.logError(
                            //'An error occurred. Please try again by refreshing the page.'
                            ((!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ErrorRefreshPage') == -1) ? 'An error occurred while updating the Sub Factor.' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ErrorRefreshPage')].Name())
                            , 'Error', system.getModuleId(HmViewModel), true);
                    }
                    else if (isNaN(jsonResult) && jsonResult.substring(0, 3) == "INC") {
                        logger.logError(jsonResult + ' - An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(HmViewModel), true);
                    }
                    else {
                        logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(HmViewModel), true);
                    }
                }
                else {
                    logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(HmViewModel), true);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source:Success in updateRiskSubFactor() method in RiskArea&Factor.js';
                logger.logMessage(msg);
            }
        };
        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage(((!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name), (!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage') == -1) ? 'Error in Edit Operation' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage')].Name, ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in updateRiskSubFactor() method in RiskArea&Factor.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in updateRiskSubFactor() method in RiskArea&Factor.js';
                logger.logMessage(msg);
            }
        };
    }

    //for adding risk sub factor
    function addRiskSubFactor(data) {
        try {
            var selectedassessmetId = "";
            var riskSubFactorObj = "";
            $('#valErrorSubfactor').hide();
            var QuestionType = HmViewModel.SubfactorQuestionType();

            for (var i = 0; i < HmViewModel.SelectedAssessmentTypeSubFactor().length; i++) {
                //To-do: need to update below code and remove hardcoded value
                if (i == 0)
                    selectedassessmetId += $('#' + HmViewModel.SelectedAssessmentTypeSubFactor()[i] + '.classdoesntexist').val() + ',' + selectedassessmetId + HmViewModel.SelectedAssessmentTypeSubFactor()[i];
                //selectedassessmetId += $('#' + HmViewModel.SelectedAssessmentTypeSubFactor()[i]).val() + ',' + selectedassessmetId + HmViewModel.SelectedAssessmentTypeSubFactor()[i];
                else
                    selectedassessmetId += "|" + $('#' + HmViewModel.SelectedAssessmentTypeSubFactor()[i] + '.classdoesntexist').val() + ',' + HmViewModel.SelectedAssessmentTypeSubFactor()[i];
            }
            HmViewModel.SubFactorAddAreaList([]);
            for (var j = 0; j < HmViewModel.SelectedLanguageSubFactorType().length; j++) {
                for (var i = 0; i < HmViewModel.ObjGeneralSettings.LanguageList().length; i++) {
                    if (parseInt(HmViewModel.SelectedLanguageSubFactorType()[j]) == HmViewModel.ObjGeneralSettings.LanguageList()[i].LANGUAGE_ID._latestValue) {
                        selectedItem = HmViewModel.SelectedLanguageSubFactorType()[j];
                        riskSubFactorObj = new RiskAreaSubFactor(selectedItem);
                        //validate language text boxes

                        if (riskSubFactorObj.RiskAreaName == "") {
                            let SubFactorNameIn = (!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SubFactorNameIn') == -1) ? 'Sub-Factor Name in' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SubFactorNameIn')].Name();
                            let SubFactorNameIsRequired = (!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SubFactorNameIsRequired') == -1) ? 'is required.' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SubFactorNameIsRequired')].Name();
                            $('#valErrorSubfactor').show();
                            $('#valErrorSubfactor').text(SubFactorNameIn + " " + HmViewModel.ObjGeneralSettings.LanguageList()[i].LANGUAGENAME() + " " + SubFactorNameIsRequired);
                            return;
                        } else {
                            $('#valErrorSubfactor').text('');
                        }

                        HmViewModel.SubFactorAddAreaList.push(new RiskAreaSubFactor(selectedItem));
                    }
                }
            }
            if ($('#valErrorSubfactor').text() == "") {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/Configuration/AddRiskSubFactor",

                    data: {
                        RiskFactorId: data.RiskFactorId(), RiskSubfactorId: data.RiskSubfactorId(), RiskSubfactorName: data.RiskSubfactorName(),
                        AssessmentType: selectedassessmetId, RiskAreaSubList: HmViewModel.SubFactorAddAreaList(), QuestionType: QuestionType,
                        HeaderUID: data.HeaderUID(), QuestionGuideline: HmViewModel.QuestionGuideline(),
                        CalculationApplicabilityFlag: HmViewModel.editableRiskSubFactor().CalculationApplicabilityFlag()
                    },
                    headers: headers,
                    type: "POST"
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
        } catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in addRiskSubFactor() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(jsonResult, status) {
            try {

                if (jsonResult != null) {

                    if (jsonResult.Incident_Description != null && jsonResult.Incident_Description.substring(0, 3) == "INC") {
                        logger.logError(jsonResult.Incident_Description + ' - An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(HmViewModel), true);
                    }
                    else {
                        if (jsonResult.flag == 1) {
                            GetAllRiskSubFactors(GetAllRiskSubFactorsAjax);
                            logger.logSuccess(
                                //'Risk Sub-Factor added successfully.'
                                ((!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('RiskSub-FactorAddSuccess') == -1) ? 'Risk Sub-Factor added successfully.' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('RiskSub-FactorAddSuccess')].Name())
                                , 'Success', system.getModuleId(HmViewModel), true);
                        }
                        else if (jsonResult.flag == null) {
                            let SubFactorAlreadyExistsText = (!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SubFactorAlreadyExistsText') == -1) ? 'already exists. Please enter a different Risk Sub-Factor.' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SubFactorAlreadyExistsText')].Name();
                            logger.logError(data.RiskSubfactorName() + " " + SubFactorAlreadyExistsText, 'Error', system.getModuleId(HmViewModel), true);
                        }
                    }
                }

                else {
                    logger.logError(
                        //'Failed to add Risk Sub-Factor.'
                        ((!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('RiskSub-FactorAddFail') == -1) ? 'Failed to add Risk Sub-Factor.' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('RiskSub-FactorAddFail')].Name())
                        , 'Error', system.getModuleId(HmViewModel), true);
                };
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in addRiskSubFactor() method in RiskArea&Factor.js';
                logger.logMessage(msg);
            }
        };
        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage(((!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name), (!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage') == -1) ? 'Error in Edit Operation' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage')].Name, ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                } else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in addRiskSubFactor() method in RiskArea&Factor.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in addRiskSubFactor() method in RiskArea&Factor.js';
                logger.logMessage(msg);
            }
        };
    }

    //add risk subfactor button
    function addRiskSubFactorFunctionality(data, event) {
        try {
            HmViewModel.HeaderSubFactorsDropDownList([]);
            HmViewModel.HeaderTypeSubFactor(true);
            HmViewModel.SubfactorQuestionType(null);
            HmViewModel.HeaderSubFactorType("off");
            HmViewModel.LanguageddFactorVisible(true);
            HmViewModel.QuestionGuideline("");
            var current;
            if (HmViewModel.ObjGeneralSettings.LanguageList().length == 0) {
                HmViewModel.ObjGeneralSettings.getLanguages();
            }
            HmViewModel.LanguageList = HmViewModel.ObjGeneralSettings.LanguageList();
            if (HmViewModel.LanguageList[0].LANGUAGE_ID._latestValue == 1) {
                HmViewModel.LanguageList.splice(0, 1);
            }
            HmViewModel.SelectedLanguageSubFactorType([]);
            HmViewModel.SelectedAssessmentTypeSubFactor([]);
            HmViewModel.SelectedAssessmentTypeSubFactorEdit([]);
            for (var s = 0; s < HmViewModel.RiskFactorList().length; s++) {
                if (parseInt(HmViewModel.RiskFactorList()[s].RiskFactorId()) == parseInt(HmViewModel.RiskFactorId())) {
                    HmViewModel.CurrentRiskFactorType(HmViewModel.RiskFactorList()[s].MappedAssessmentType());
                    HmViewModel.currentResponseOptionType(HmViewModel.RiskFactorList()[s].ResponseOptionTypeList);
                    current = s;
                    break;
                }
            }

            var mappedassessment = $.map(HmViewModel.AssessmentTypeList(), function (result) {
                for (var i = 0; i < HmViewModel.CurrentRiskFactorType().length; i++) {
                    if (HmViewModel.CurrentRiskFactorType()[i].ID == parseInt(result.AssessmentId())) {
                        var RiskAreaModelObj = new FilteredAssessmentListModel(result);
                        return RiskAreaModelObj;
                    }
                }

            });
            HmViewModel.showNonQuantitativeOption(false);
            if (HmViewModel.RiskFactorList()[current].ResponseOptionTypeList != null) {
                for (var j = 0; j < HmViewModel.RiskFactorList()[current].ResponseOptionTypeList.length; j++) {
                    if (HmViewModel.RiskFactorList()[current].ResponseOptionTypeList[j].OptionTypeShortName() == "T") {
                        HmViewModel.showNonQuantitativeOption(true);
                        break;
                    }
                }
            }
            HmViewModel.SubFactorAssessmentTypeList(mappedassessment);
            HmViewModel.AssessmentTypeSubFactor(HmViewModel.AssessmentTypeSubFactorParent());
            var RiskAreaSubFactorObj = [];
            RiskAreaSubFactorObj[0] = new RiskAreaSubFactor(-999);
            var newRiskSubFactor = new RiskSubFactorModel({
                RiskFactorId: HmViewModel.RiskFactorId(), RiskSubfactorId: 999, AMLRiskScore: "", SANCRiskScore: "",
                RiskSubfactorName: "", AssessmentType: HmViewModel.AssessmentTypeSubFactor(), RiskAreaSubList: RiskAreaSubFactorObj,
                HeaderUID: -999, CalculationApplicabilityFlag: true
            });
            HmViewModel.editableRiskSubFactor(newRiskSubFactor);
            HmViewModel.rsfPopUpTitle(
                //"Add Risk Sub-Factor Details"
                ((!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AddRiskSub-FactorDetails') == -1) ? 'Add Risk Sub-Factor Details' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AddRiskSub-FactorDetails')].Name())
            );
            //ko.applyBindingsToNode($('#frmSubFactor').find('button').get(2), { click: HmViewModel.cancelRsfButton }, HmViewModel);
            HmViewModel.addPopUpCss(true);
            HmViewModel.editPopUpCss(false);
            HmViewModel.EditSubFactorVisible(false);
            $('#appSubfactor').show();
            $('#EdiFactorAssessment').hide();
            $('#SubFactorAppTypeID').multiselect();
            $('#RASubFactorLanguage').multiselect();
            $('#frmSubFactor').modal('show');
            GetAllInherentLevels();
            //CKEDITOR.replace('subFactorGuideline');
            isRsfEdit = false;
            setTimeout("$('#subfactorname').focus();", 200);

        } catch (e) {
            var msg = 'Exception: ' + e + ' | Source: addRiskSubFactorFunctionality() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    }

    function RiskAreaSubFactor(item) {
        try {
            var self = this;
            self.RiskAreaName = $('#subfactorname' + item).val();
            self.LanguageType = item;
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RiskAreaSubFactor() method in QualitativeSetup.js';
            logger.logMessage(msg);
        }
    };
    //editing risk sub factor
    function editRiskSubFactorFunctionality(data, event) {
        try {
            HmViewModel.SelectedAssessmentTypeSubFactor([]);
            HmViewModel.SubFactorAssessmentTypeList([]);
            HmViewModel.QuestionGuideline(data.QuestionGuideline());
            var selectedATIds = data.AssessmentTypeId().split(',');
            for (var i = 0; i < selectedATIds.length; i++) {
                selectedATIds[i] = selectedATIds[i].trim();
            }
            HmViewModel.SelectedAssessmentTypeSubFactorEdit(selectedATIds);
            ApplicabilityRelHeaderEvent(data, event);
            HmViewModel.HeaderTypeSubFactor(false);
            HmViewModel.LanguageddFactorVisible(false);
            HmViewModel.CalculationCheckboxdisabled(false);
            for (var i = 0, j = HmViewModel.RiskSubFactorsList().length; i < j; i++) {
                if (data.RiskSubfactorId() == HmViewModel.RiskSubFactorsList()[i].RiskSubfactorId())
                    data.TargetRow(i);
            }
            var newRsfObservable = new RiskSubFactorModel({
                RiskFactorId: data.RiskFactorId(), RiskSubfactorId: data.RiskSubfactorId(), RiskSubfactorName: data.RiskSubfactorName(),
                AssessmentType: data.AssessmentType(), RiskMapping: data.RiskMapping(), RiskAreaSubList: data.RiskAreaSubList(),
                QuestionType: data.QuestionType(), QuestionTypeDescription: data.QuestionTypeDescription(), HeaderUID: data.HeaderUID(),
                CalculationApplicabilityFlag: data.CalculationApplicabilityFlag()
            });
            newRsfObservable.TargetRow(data.TargetRow());
            HmViewModel.editableRiskSubFactor(newRsfObservable);
            //Add dynamic language inputs
            if (data.RiskAreaSubList() != null && data.RiskAreaSubList().length > 0) {
                AddDynamicSubFactorElements(data.RiskAreaSubList());

                $.each(data.RiskAreaSubList(), function (key, value) {
                    $('#subfactorname' + value.LanguageType.toString()).val(value.RiskAreaName);
                });
                $("#frmSubFactorScroll").css({ "height": "29rem", "overflow-y": "scroll", "overflow-x": "hidden" });
            }
            for (var s = 0; s < HmViewModel.RiskFactorList().length; s++) {
                if (parseInt(HmViewModel.RiskFactorList()[s].RiskFactorId()) == parseInt(HmViewModel.RiskFactorId())) {
                    HmViewModel.CurrentRiskFactorType(HmViewModel.RiskFactorList()[s].MappedAssessmentType())
                    break;
                }
            }

            var mappedassessment = $.map(HmViewModel.AssessmentTypeList(), function (result) {
                for (var i = 0; i < HmViewModel.CurrentRiskFactorType().length; i++) {
                    if (HmViewModel.CurrentRiskFactorType()[i].ID == parseInt(result.AssessmentId()) &&
                        HmViewModel.SelectedAssessmentTypeSubFactorEdit().indexOf(HmViewModel.AssessmentTypeList()[i].AssessmentId()) < 0) {
                        var RiskAreaModelObj = new FilteredAssessmentListModel(result);
                        return RiskAreaModelObj;
                    }
                }

            });
            HmViewModel.SubFactorAssessmentTypeList(mappedassessment);
            if (HmViewModel.SelectedAssessmentTypeSubFactorEdit().length == HmViewModel.CurrentRiskFactorType().length) {
                $('#SubFactorAppTypeID').hide();
            }
            else {
                $('#SubFactorAppTypeID').show();
                $('#SubFactorAppTypeID').multiselect();
                $('#SubFactorAppTypeID').multiselect('refresh');
            }
            $('#EdiFactorAssessment').empty();
            document.getElementById('EdiFactorAssessment').innerHTML = data.AssessmentType();
            HmViewModel.AssessmentTypeSubFactor(data.AssessmentType());
            HmViewModel.rsfPopUpTitle(
                //"Edit Risk Sub-Factor Details"
                ((!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditRiskSub-FactorDetails') == -1) ? 'Edit Risk Sub-Factor Details' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditRiskSub-FactorDetails')].Name())
            );
            ko.applyBindingsToNode($('#frmSubFactor').find('input').get(0), { value: HmViewModel.editableRiskSubFactor().RiskSubfactorName }, HmViewModel);

            HmViewModel.addPopUpCss(false);
            HmViewModel.editPopUpCss(true);

            if (data.QuestionType() != "H")
                BindDynamicHtmlForDropDownsEdit(data.RiskMapping().split('|'));
            HmViewModel.AssessmentTypeSubFactorDisabled(true);
            HmViewModel.EditSubFactorVisible(true),
                $('#frmSubFactor').modal('show');
            //CKEDITOR.replace('subFactorGuideline');
            isRsfEdit = true;
            setTimeout("$('#subfactorname').focus();", 200);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source:  editRiskSubFactorFunctionality() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    }

    function LanguageSubFactorAdded() {
        try {
            var selectedLanguage = HmViewModel.SelectedLanguageSubFactorType();
            $('#DynamicSubFactorDiv').empty();
            var ResponseHTMl = "";

            for (var j = 0; j < HmViewModel.SelectedLanguageSubFactorType().length; j++) {
                for (var i = 0; i < HmViewModel.ObjGeneralSettings.LanguageList().length; i++) {
                    if (parseInt(HmViewModel.SelectedLanguageSubFactorType()[j]) == HmViewModel.ObjGeneralSettings.LanguageList()[i].LANGUAGE_ID._latestValue) {

                        let RiskSubFactorNameIn = (!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('RiskSub-FactorNamein') == -1) ? 'Risk Sub-Factor Name in' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('RiskSub-FactorNamein')].Name();

                        ResponseHTMl += '<div class="new-form-group">' +
                            '<label class="control-label pt-0 no-padding">Sub-Factor Name (' + HmViewModel.ObjGeneralSettings.LanguageList()[i].LANGUAGENAME() + ') </label>' +
                            '<div class="">' +
                            '<input id="subfactorname' + HmViewModel.SelectedLanguageSubFactorType()[j] + '" class="form-control" placeholder="' + RiskSubFactorNameIn + " " + HmViewModel.ObjGeneralSettings.LanguageList()[i].LANGUAGENAME._latestValue + '" data-bind="value: SubFactorRiskAreaList().RiskSubfactorName" type="text" />' +
                            '</div>' +
                            '</div>';
                    }
                }
            }
            document.getElementById('DynamicSubFactorDiv').innerHTML = ResponseHTMl;
            ko.cleanNode(document.getElementById('DynamicSubFactorDiv'));
            ko.applyBindings(HmViewModel, document.getElementById("DynamicSubFactorDiv"));

            if (selectedLanguage.length > 2 || HmViewModel.SelectedAssessmentTypeSubFactor().length > 2) {
                $("#frmSubFactorScroll").css({ "height": "auto", "max-height": "50rem", "overflow-y": "scroll", "overflow-x": "hidden" });
                $("modalContent").css({ "height": "auto", "max-height": "65rem" });
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: LanguageSubFactorAdded() method in  RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    }

    function AddDynamicSubFactorElements(item) {
        try {
            $('#DynamicSubFactorDiv').empty();
            var ResponseHTMl = "";

            $.each(item, function (key, value) {
                ResponseHTMl += '<div class="new-form-group">' +
                    '<label class="control-label pt-0">Sub-Factor Name (' + GetLanguageName(value.LanguageType) + ')</label>' +
                    '<div class="">' +
                    '<input id="subfactorname' + value.LanguageType + '" class="form-control" data-bind="value: SubFactorRiskAreaList().RiskSubfactorName" type="text" />' +
                    '</div>' +
                    '</div>';
            });

            document.getElementById('DynamicSubFactorDiv').innerHTML = ResponseHTMl;
            ko.cleanNode(document.getElementById('DynamicSubFactorDiv'));
            ko.applyBindings(HmViewModel, document.getElementById("DynamicSubFactorDiv"));

            if (item.length > 2) {
                $("#frmSubFactorScroll").css({ "height": "29rem", "overflow-y": "scroll", "overflow-x": "hidden" });
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: AddDynamicSubFactorElements() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    }

    function BindDynamicHtmlForDropDownsEdit(data) {
        try {
            var DynamicHTMl = "";
            var arr = [];
            for (var k = 0; k < data.length; k++) {
                var splitID = data[k].split(',')

                for (var g = 0; g < HmViewModel.AssessmentTypeList().length; g++) {
                    if (parseInt(splitID[0].toString().trim()) == HmViewModel.AssessmentTypeList()[g].AssessmentId()) {
                        DynamicHTMl += '<div class="" id="appSubfactor_RiskLevel">' +
                            '<label class="control-label">' + HmViewModel.AssessmentTypeList()[g].AssessmentName() + ' Score</label>' +
                            '<select id="' + HmViewModel.AssessmentTypeList()[g].AssessmentId().replace(" ", "") + 'RiskLevel" data-bind="foreach:{data: InherentRiskLevelList, as: \'List1\'}" class="form-control">' +
                            '<!-- ko if: (List1.AssessmentTypeId ==' + splitID[0] + '|| List1.AssessmentTypeId == 99999)-->' +
                            '<!-- ko if: !(List1.isQuantitative ==0)-->' +
                            '<optgroup data-bind="attr: {label: RiskLevelName}, foreach: MappedRiskLevels">' +
                            '<option data-bind="text: RiskLevelDescription,value:RiskLevelId"></option>' +
                            '</optgroup>' +
                            '<!--/ko -->' +
                            '<!--/ko -->' +
                            '</select>' +
                            '</div>';
                    }
                }

            }


            document.getElementById('DynamicScoreDiv').innerHTML = DynamicHTMl
            ko.cleanNode(document.getElementById('DynamicScoreDiv'));
            ko.applyBindings(HmViewModel, document.getElementById("DynamicScoreDiv"));
            for (var k = 0; k < data.length; k++) {
                var splitIDMap = data[k].split(',');
                if (splitIDMap[1] != undefined)
                    $('#' + parseInt(splitIDMap[0].replace(" ", "")) + 'RiskLevel').val(parseInt(splitIDMap[1].replace(" ", "")));
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: BindDynamicHtmlForDropDownsEdit() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    }
    //deleting subfactor button click
    function deleteRiskSubFactorFunctionality(data, event) {
        try {
            var selectedRow = $(event.currentTarget).closest("tr").get(0);
            data.TargetRow(selectedRow._DT_RowIndex);
            app.showMessage(
                //'Are you sure you want to delete this Risk Sub-Factor? Once deleted, it cannot be undone.'
                ((!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('DeleteRiskSubFactorConfirm') == -1) ? 'Are you sure you want to delete this Risk Sub-Factor? Once deleted, it cannot be undone.' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('DeleteRiskSubFactorConfirm')].Name())
                , 'Delete Risk Sub-Factor', [(!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ConfirmButton') == -1) ? 'Confirm' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ConfirmButton')].Name, (!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CancelButton') == -1) ? 'Cancel' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CancelButton')].Name])
                .then(function (option) {
                    var confirmText = ((!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ConfirmButton') == -1) ? 'Confirm' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ConfirmButton')].Name()).toString();
                    if (option == confirmText) {
                        deleteRiskSubFactor(data, event);
                    }
                });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: deleteRiskSubFactorFunctionality() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    }

    //deleting risk subfactor
    function deleteRiskSubFactor(data, event) {
        try {
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            $.ajax({
                url: "/api/Configuration/DeleteSubRiskFactor",
                dataType: "json",
                contentType: "application/json; charset=utf-8",
                data: ko.toJSON({
                    RiskSubfactorId: data.RiskSubfactorId()
                }),
                headers: headers,
                type: "POST"
            })
                .success(ajaxSuccess)
                .fail(ajaxFail)
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call deleteRiskSubFactor() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult != null) {
                    if (jsonResult == "1") {
                        var targetRow = $(event.currentTarget).closest("tr").get(0);
                        data.TargetRow(targetRow._DT_RowIndex);
                        RfSubFactorTableObj.row(targetRow).remove().draw(false);
                        HmViewModel.RiskSubFactorsList.splice(data.TargetRow(), 1);
                        GetAllRiskSubFactors(GetAllRiskSubFactorsAjax);
                        logger.logSuccess(
                            //'Risk Sub-Factor deleted successfully.'
                            ((!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('DeleteRiskSubFactorSuccess') == -1) ? 'Risk Sub-Factor deleted successfully.' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('DeleteRiskSubFactorSuccess')].Name())
                            , 'Success', system.getModuleId(HmViewModel), true);
                    }
                    else if (jsonResult == "0") {
                        logger.logError(
                            //'Risk Sub-Factor does not exist or has already been deleted. Please try reloading the page and try again.'
                            ((!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('DeleteRiskSubFactorAlreadyExists') == -1) ? 'Risk Sub-Factor does not exist or has already been deleted. Please try reloading the page and try again.' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('DeleteRiskSubFactorAlreadyExists')].Name())
                            , 'Error', system.getModuleId(HmViewModel), true);
                    }
                    else if (jsonResult == "-1") {
                        logger.logError(
                            //'An error occurred. Please try again by refreshing the page.'
                            ((!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ErrorRefreshPage') == -1) ? 'An error occurred. Please try again by refreshing the page.' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ErrorRefreshPage')].Name())
                            , 'Error', system.getModuleId(HmViewModel), true);
                    }
                    else if (isNaN(jsonResult) && jsonResult.substring(0, 3) == "INC") {
                        logger.logError(jsonResult + ' - An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(HmViewModel), true);
                    }
                    else {
                        logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(HmViewModel), true);
                    }
                }
                else {
                    logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(HmViewModel), true);
                };
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in deleteRiskSubFactor() method in RiskArea&Factor.js';
                logger.logMessage(msg);
            }
        }
        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage(((!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name), (!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage') == -1) ? 'Error in Edit Operation' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage')].Name, ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                } else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in deleteRiskSubFactor() method in RiskArea&Factor.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in deleteRiskSubFactor() method in RiskArea&Factor.js';
                logger.logMessage(msg);
            }
        };
    }

    //deleting Risk Factor
    function deleteFunctionalityRF(data, event) {
        try {
            app.showMessage(
                //'Are you sure you want to delete this Risk Factor? Once deleted, it cannot be undone.'
                ((!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('DeleteRiskFactorConfirm') == -1) ? 'Are you sure you want to delete this Risk Factor? Once deleted, it cannot be undone.' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('DeleteRiskFactorConfirm')].Name())
                , 'Delete Risk Factor', [(!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ConfirmButton') == -1) ? 'Confirm' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ConfirmButton')].Name, (!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CancelButton') == -1) ? 'Cancel' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CancelButton')].Name])
                .then(function (option) {
                    var confirmText = ((!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ConfirmButton') == -1) ? 'Confirm' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ConfirmButton')].Name()).toString();
                    if (option == confirmText) {
                        deleteRiskFactor(data, event);
                    }
                });

        } catch (e) {
            var msg = 'Exception: ' + e + ' | Source:deleteFunctionality() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    }

    function deleteRiskFactor(data, event) {
        try {
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            $.ajax({
                url: "/api/Configuration/DeleteRiskFactor",
                dataType: "json",
                contentType: "application/json; charset=utf-8",
                data: ko.toJSON({
                    RiskFactorID: data.RiskFactorId()
                }),
                headers: headers,
                type: "POST"
            })
                .success(ajaxSuccess)
                .fail(ajaxFail);
        } catch (e) {
            var msg = 'Exception: ' + e + ' | Source:ajax call in deleteRiskFactor() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(result, status) {
            try {
                if (result != null) {
                    if (result == "1") {
                        var targetRow = $(event.currentTarget).closest("tr").get(0);
                        data.TargetRow(targetRow._DT_RowIndex);
                        RfTableObj.row(targetRow).remove().draw(false);
                        HmViewModel.RiskFactorList.splice(data.TargetRow(), 1);
                        for (var i = 0; i < HmViewModel.RiskFactorReorderList().length; i++) {
                            if (data.RiskFactorId() == HmViewModel.RiskFactorReorderList()[i].RiskFactorId()) {
                                HmViewModel.RiskFactorReorderList.remove(HmViewModel.RiskFactorReorderList()[i]);
                                break;
                            }
                        }
                        HmViewModel.RiskFactorSortOrder(HmViewModel.RiskFactorSortOrder() - 1);
                        for (var i = 0; i < HmViewModel.RiskFactorReorderListDup().length; i++) {
                            if (data.RiskFactorId() == HmViewModel.RiskFactorReorderListDup()[i].RiskFactorId()) {
                                HmViewModel.RiskFactorReorderListDup.remove(HmViewModel.RiskFactorReorderListDup()[i]);
                                break;
                            }
                        }
                        for (var i = 0; i < HmViewModel.RiskFactorReorderList().length; i++) {
                            HmViewModel.RiskFactorReorderList()[i].SortOrder(i + 1);
                            HmViewModel.RiskFactorReorderList()[i].SortOrder(i + 1);
                        }
                        for (var i = 0; i < HmViewModel.RiskFactorReorderListDup().length; i++) {
                            HmViewModel.RiskFactorReorderListDup()[i].SortOrder(i + 1);
                            HmViewModel.RiskFactorReorderListDup()[i].SortOrder(i + 1);
                        }
                        logger.logSuccess(
                            //'Risk Factor deleted successfully.'
                            ((!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('DeleteRiskFactorSuccess') == -1) ? 'Risk Factor deleted successfully.' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('DeleteRiskFactorSuccess')].Name())
                            , 'Success', system.getModuleId(HmViewModel), true);
                    }
                    else if (result == "0") {
                        logger.logWarning(
                            //'No such Risk Factor exists. Please refresh the page and perform the delete operation.'
                            ((!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('DeleteRiskFactorNotExists') == -1) ? 'No such Risk Factor exists. Please refresh the page and perform the delete operation.' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('DeleteRiskFactorNotExists')].Name())
                            , 'Warning', system.getModuleId(HmViewModel), true);
                    }
                    else if (isNaN(result) && result.substring(0, 3) == "INC") {
                        logger.logError(result + ' - An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(HmViewModel), true);
                    }
                    else {
                        logger.logError(
                            ((!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('DeleteRiskFactorError') == -1) ? 'An error occurred. Please refresh the page again and perform the delete operation.' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('DeleteRiskFactorError')].Name())
                            , 'Error', system.getModuleId(HmViewModel), true);    }
                    }
                else {
                    logger.logError(
                        //'An error occurred. Please refresh the page again and perform the delete operation.'
                        ((!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('DeleteRiskFactorError') == -1) ? 'An error occurred. Please refresh the page again and perform the delete operation.' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('DeleteRiskFactorError')].Name())
                        , 'Error', system.getModuleId(HmViewModel), true);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source:ajaxSuccess in deleteRiskFactor() method in RiskArea&Factor.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage(((!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name), (!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage') == -1) ? 'Error in Edit Operation' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage')].Name, ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                } else {
                    var msg = 'Exception: ' + error.statusText + ' | Source:ajaxFail in deleteRiskFactor() method in RiskArea&Factor.js';
                    logger.logMessage(msg);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source:ajaxFail in deleteRiskFactor() method in RiskArea&Factor.js';
                logger.logMessage(msg);
            }
        }

    }

    //editing Risk Factor
    function editFunctionalityRF(data, event) {
        try {
            HmViewModel.LanguageddFactorVisible(false);
            HmViewModel.EditFactorVisible(true);
            var Assessment = "";
            var AssessmentIds = [];
            for (var k = 0; k < HmViewModel.AssessmentTypeList().length; k++) {
                for (var f = 0; f < data.MappedAssessmentType().length; f++) {
                    if (parseInt(HmViewModel.AssessmentTypeList()[k].AssessmentId()) == data.MappedAssessmentType()[f].ID) {
                        if (k == 0)
                            Assessment = HmViewModel.AssessmentTypeList()[k].AssessmentName();
                        else {
                            if (Assessment == "") {
                                Assessment += HmViewModel.AssessmentTypeList()[k].AssessmentName();
                            }
                            else {
                                Assessment += ", " + HmViewModel.AssessmentTypeList()[k].AssessmentName();
                            }
                        }
                        AssessmentIds.push(HmViewModel.AssessmentTypeList()[k].AssessmentId());
                    }
                }
            }
            var selectedRow = $(event.currentTarget).closest("tr").get(0);
            data.TargetRow(selectedRow._DT_RowIndex);
            var newObservable = new RiskFactorModel({});
            newObservable.RiskFactorId(data.RiskFactorId());
            newObservable.RiskFactorName(data.RiskFactorName());
            newObservable.RiskAreaId(data.RiskAreaId());
            newObservable.AssessmentType(data.AssessmentType());
            newObservable.FactorRiskAreaList(data.FactorRiskAreaList());
            HmViewModel.QuestionGuideline(data.QuestionGuideline());
            newObservable.CalculationApplicabilityFlag(data.CalculationApplicabilityFlag());

            //Quan response code
            HmViewModel.editableRiskFactor(newObservable);
            HmViewModel.editableResponseTypes([]);
            HmViewModel.editableResponseTypesForFactor = ([]);
            HmViewModel.assessmentSelected(false);
            HmViewModel.CalculationCheckboxdisabled(false);

            //selected lang list
            if (newObservable.FactorRiskAreaList().length < 1) {
                GetFactorQuanResponseAndLanguages(data.RiskFactorId());
                newObservable.FactorRiskAreaList = HmViewModel.FactorRiskAreaList;
            }
            else {
                HmViewModel.FactorRiskAreaList = newObservable.FactorRiskAreaList();
            }
            newObservable.TargetRow(selectedRow._DT_RowIndex);
            HmViewModel.AssessmentTypeFactor(data.AssessmentType());
            HmViewModel.AssessmentTypeFactorDisabled(true);

            HmViewModel.popUpTitle(
                //"Edit Risk Factor Details"
                ((!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditRiskFactorDetails') == -1) ? 'Edit Risk Factor Details' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditRiskFactorDetails')].Name())
            );
            HmViewModel.addPopUpCss(false);
            HmViewModel.editPopUpCss(true);
            //Add dynamic language inputs
            if (HmViewModel.FactorRiskAreaList != null && HmViewModel.FactorRiskAreaList.length > 0) {
                AddDynamicFactorElements(HmViewModel.FactorRiskAreaList);

                $.each(HmViewModel.FactorRiskAreaList, function (key, value) {
                    $('#questionname' + value.LanguageType.toString()).val(value.RiskAreaName);
                });
            }
            if (HmViewModel.FactorRiskAreaList.length <= 0 && HmViewModel.editableResponseTypesForFactor.length <= 0) {
                $("#modalContent").removeAttr("style");
                $("#outerdiv").removeAttr("style");
            }
            if (HmViewModel.editableResponseTypesForFactor.length <= 0) { $("#outerdiv").removeAttr("style"); }
            $('#frmRiskFactor').modal('show');
            //CKEDITOR.replace('factorGuideline');
            $('#RFApplicabilityDropdown').hide();
            $('#EditFactorAssessment').empty();
            document.getElementById('EditFactorAssessment').innerHTML = Assessment;


            var mappedassessment = $.map(HmViewModel.AssessmentTypeList(), function (result) {
                for (var i = 0; i < HmViewModel.CurrentRiskAreaType().length; i++) {
                    if (HmViewModel.CurrentRiskAreaType()[i] == parseInt(result.AssessmentId())) {
                        var RiskAreaModelObj = new FilteredAssessmentListModel(result);
                        return RiskAreaModelObj;
                    }
                }

            });
            HmViewModel.FactorAssessmentTypeList(mappedassessment);

            var ModifiedATList = [];
            HmViewModel.FactorAssessmentTypeListModified([]);
            for (var j = 0; j < HmViewModel.FactorAssessmentTypeList().length; j++) {
                var countVar = 0;
                for (var i = 0; i < data.MappedAssessmentType().length; i++) {
                    if (HmViewModel.FactorAssessmentTypeList()[j].AssessmentId() == data.MappedAssessmentType()[i].ID) {
                        countVar++;
                    }
                }
                if (countVar == 0)
                    ModifiedATList.push(HmViewModel.FactorAssessmentTypeList()[j]);
            }
            HmViewModel.FactorAssessmentTypeListModified(ModifiedATList);
            HmViewModel.SelectedAssessmentTypeFactor([]);
            HmViewModel.SelectedAssessmentTypeFactorEdit(AssessmentIds);

            if (HmViewModel.FactorAssessmentTypeListModified().length > 0) {
                $('#FactorAppTypeIDModified').multiselect();
                $('#FactorAppTypeIDModified').multiselect('refresh');

            }
            else
                $('#FactorAppTypeIDModified').hide();

            $('#FactorAppTypeID').multiselect();
            $('#FactorAppTypeID').multiselect('refresh');
            isEdit = true;
            setTimeout("$('#frmRiskFactor #factorname').focus();", 200);
            if (!HmViewModel.isGlobalFlag()) {
                GetFactorApplicabilityDetails(data.RiskFactorId()).then(function () {

                })
            }
            else {
                HmViewModel.assessmentSelected(false);
            }

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: editFunctionality() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    }

    //PopUp for adding Riskfactor
    function ShowFactorPopUp(event, a, b) {
        try {
            GetQuanResponseColumnDetails();
            if (HmViewModel.ObjGeneralSettings.LanguageList().length == 0) {
                HmViewModel.ObjGeneralSettings.getLanguages();
            }
            HmViewModel.LanguageList = HmViewModel.ObjGeneralSettings.LanguageList();
            if (HmViewModel.LanguageList[0].LANGUAGE_ID._latestValue == 1) {
                HmViewModel.LanguageList.splice(0, 1);
            }
            HmViewModel.SelectedLanguageFactorType([]);
            HmViewModel.SelectedAssessmentTypeFactor([]);
            HmViewModel.LanguageddFactorVisible(true);
            HmViewModel.CalculationCheckboxdisabled(false);
            HmViewModel.EditFactorVisible(false);
            HmViewModel.QuestionGuideline("");
            var newRiskFactor = new RiskFactorModel({ RiskFactorId: 999, RiskFactorName: "", RiskAreaId: a.currentTarget.value, FactorRiskAreaList: new RiskAreaFactor(""), ZATIdList: "", ZATNames: "", CalculationApplicabilityFlag: true });
            HmViewModel.editableRiskFactor(newRiskFactor);
            var mappedassessment = $.map(HmViewModel.AssessmentTypeList(), function (result) {
                for (var i = 0; i < HmViewModel.CurrentRiskAreaType().length; i++) {
                    if (HmViewModel.CurrentRiskAreaType()[i] == parseInt(result.AssessmentId())) {
                        var RiskAreaModelObj = new FilteredAssessmentListModel(result);
                        return RiskAreaModelObj;
                    }
                }

            });
            HmViewModel.FactorAssessmentTypeList(mappedassessment)
            $('#FactorAppTypeID').multiselect();
            HmViewModel.SelectedAssessmentTypeFactor([]);
            HmViewModel.assessmentSelected(false);
            HmViewModel.AssessmentTypeFactor(HmViewModel.CurrentRiskAreaType());
            HmViewModel.popUpTitle(
                //"Add Risk Factor Details"
                ((!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AddRiskFactorDetails') == -1) ? 'Add Risk Factor Details' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AddRiskFactorDetails')].Name())
            );
            HmViewModel.addPopUpCss(true);
            $('#frmRiskFactor').modal('show');
            //CKEDITOR.replace('factorGuideline');
            isEdit = false;
            $('#RFApplicabilityDropdown').show();
            $('#RAFactorLanguage').multiselect();
            setTimeout("$('#frmRiskFactor #factorname').focus();", 200);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ShowFactorPopUp() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    }

    function AvgtyperdbchangedFactor(data, event) {
        try {
            //Toggle the weighted average flag
            document.getElementById(event.currentTarget.id).checked = true;
            if (event.currentTarget.value == "SimpleAverageFactor") {
                HmViewModel.FactorWeightedAverageType(false);
            }
            else {
                HmViewModel.FactorWeightedAverageType(true);
            }
            return true;

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SaveResponseType() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    }
    // ajax call for risk factor add
    function saveRiskFactorPopUpButton(data) {
        try {
            //HmViewModel.QuestionGuideline(CKEDITOR.instances["factorGuideline"].getData());
            HmViewModel.AssessmentTypeFactor();
            $('#valErrorRF').hide();
            var duplicateCheck = 0;
           for (var i = 0, j = HmViewModel.RiskFactorList().length; i < j; i++)
            {
                if ((HmViewModel.editableRiskFactor().RiskFactorName().toUpperCase() == HmViewModel.RiskFactorList()[i].RiskFactorName().toUpperCase()) && (HmViewModel.editableRiskFactor().TargetRow() != i))
                    duplicateCheck++;
            }
            if (HmViewModel.editableRiskFactor().RiskFactorName() == "")
            {
                $('#valErrorRF').show();
                $('#valErrorRF').text(
                    //'Risk Factor name is required.'
                    ((!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('RiskFactorNameVal') == -1) ? 'Risk Factor name is required.' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('RiskFactorNameVal')].Name())
                );
            }
            else if (HmViewModel.editableRiskFactor().RiskFactorName().length > 500)
            {
                $('#valErrorRF').show();
                $('#valErrorRF').text(
                    //'Risk Factor name cannot exceed 500 characters. Please enter a valid Risk Factor.'
                    ((!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('RiskFactorNameChar500Val') == -1) ? 'Risk Factor name cannot exceed 500 characters. Please enter a valid Risk Factor.' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('RiskFactorNameChar500Val')].Name())
                );
            }
            else if (HmViewModel.QuestionGuideline().length > 4000)
            {
                $('#valErrorRF').show();
                $('#valErrorRF').text(
                    //'Risk Factor Guideline cannot exceed 4000 characters. Please enter a valid Guideline.'
                    ((!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('RiskFactorGuidelineChar500Val') == -1) ? 'Risk Factor Guideline cannot exceed 4000 characters. Please enter a valid Guideline.' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('RiskFactorGuidelineChar500Val')].Name()) );
            }
            else if (HmViewModel.editableRiskFactor().AssessmentType()== "" &&  HmViewModel.SelectedAssessmentTypeFactor().length == 0)
            {
                $('#valErrorRF').show();
                $('#valErrorRF').text(
                    //'Risk Factor Guideline cannot exceed 4000 characters. Please enter a valid Guideline.'
                    ((!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('RiskFactorAssessmentType') == -1) ? 'Risk Factor Applicabilty is Required.' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('RiskFactorAssessmentType')].Name()));
            }
            else
            {
                if (!isEdit)
                {
                    if (duplicateCheck !=1)
                    {
                        addRiskFactor(data);
                        if ($('#valErrorRF').text() == "") {
                            $('#frmRiskFactor').modal('hide');
                            $('body').removeClass('modal-open');
                            $('.modal-backdrop').remove();
                        }
                    }
                    else
                    {
                        $('#valErrorRF').show();
                        $('#valErrorRF').text(HmViewModel.editableRiskFactor().RiskFactorName() + " " + RiskFactorAlreadyExists);
                    }
                }
                else
                {
                    if (duplicateCheck == 1)
                    {
                        $('#valErrorRF').show();
                        $('#valErrorRF').text(HmViewModel.editableRiskFactor().RiskFactorName() + ' already exists. Please enter a different Risk Factor.');
                    }
                    else
                    {
                        update(data);
                        if ($('#valErrorRF').text() == "")
                        {
                            $('#frmRiskFactor').modal('hide');
                            $('body').removeClass('modal-open');
                            $('body').removeClass('modal-open');
                            $('.modal-backdrop').remove();
                        }
                    }
                }
            }

        } catch (e) {
            var msg = 'Exception: ' + e + ' | Source: saveRiskFactorPopUpButton() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }

    }

    function ApplicabilityChanged() {
        try {
            if (!HmViewModel.isGlobalFlag()) {
                var selectedAssessmentType = HmViewModel.SelectedAssessmentTypeFactor();
                if (selectedAssessmentType.length > 0) {
                    HmViewModel.assessmentSelected(true);
                } else {
                    HmViewModel.assessmentSelected(false);
                }
                if (!HmViewModel.SimpleAverageType()) {
                    document.getElementById('WghtdAvgFactor').checked = true;
                }
                else {
                    document.getElementById('SmplAvgFactor').checked = true;
                }
                var AssessmentType = HmViewModel.FactorAssessmentTypeList();
                var responseTypeLenght = HmViewModel.editableResponseTypesForFactor.length;
                HmViewModel.AssessmentTypeColumnList([]);
                HmViewModel.editableResponseTypes([]);
                for (i = 0; i < selectedAssessmentType.length; i++) {
                    for (j = 0; j < AssessmentType.length; j++) {
                        if (selectedAssessmentType[i] == AssessmentType[j].AssessmentId()) {


                            for (k = 0; k < responseTypeLenght; k++) {

                                var responseType = HmViewModel.editableResponseTypes().length + 1;
                                HmViewModel.editableResponseTypes.push(new QuantitativeResponseColumnsModel({
                                    ResponseId: HmViewModel.editableResponseTypesForFactor[k].ResponseId(),
                                    ResponseType: "RESPONSE" + responseType,
                                    description: HmViewModel.editableResponseTypesForFactor[k].description(),
                                    calculationapplicability: HmViewModel.editableResponseTypesForFactor[k].calculationapplicability(),
                                    currencyapplicability: HmViewModel.editableResponseTypesForFactor[k].currencyapplicability(),
                                    weightings: HmViewModel.editableResponseTypesForFactor[k].weightings(),
                                    response: HmViewModel.editableResponseTypesForFactor[k].response(),
                                    Weightedaverageflag: HmViewModel.FactorWeightedAverageType(),
                                    SimpleAverageflag: HmViewModel.SimpleAverageType(),
                                    isGlobalFlag: HmViewModel.isGlobalFlag(),
                                    AssessmentType: AssessmentType[j].AssessmentName(),
                                    AssessmentTypeId: AssessmentType[j].AssessmentId()
                                }));

                                if (HmViewModel.editableResponseTypesForFactor[k].calculationapplicability() == false) {
                                    $("#RESPONSE" + responseType).attr('disabled', 'disabled');
                                }
                            }

                        }
                    }
                }
                if (!HmViewModel.SimpleAverageType()) {
                    HmViewModel.FactorWeightedAverageType(true);
                }
                else {
                    HmViewModel.FactorWeightedAverageType(false);
                }
            }
            else {
                let selectedAssessmentType = HmViewModel.SelectedAssessmentTypeFactor();
                let AssessmentType = HmViewModel.FactorAssessmentTypeList();
                let responseTypeLenght = HmViewModel.editableResponseTypesForFactor.length;
                HmViewModel.AssessmentTypeColumnList([]);
                HmViewModel.editableResponseTypes([]);
                for (i = 0; i < selectedAssessmentType.length; i++) {
                    for (j = 0; j < AssessmentType.length; j++) {
                        if (selectedAssessmentType[i] == AssessmentType[j].AssessmentId()) {


                            for (k = 0; k < responseTypeLenght; k++) {

                                let responseType = HmViewModel.editableResponseTypes().length + 1;
                                HmViewModel.editableResponseTypes.push(new QuantitativeResponseColumnsModel({
                                    ResponseId: HmViewModel.editableResponseTypesForFactor[k].ResponseId(),
                                    ResponseType: "RESPONSE" + responseType,
                                    description: HmViewModel.editableResponseTypesForFactor[k].description(),
                                    calculationapplicability: HmViewModel.editableResponseTypesForFactor[k].calculationapplicability(),
                                    currencyapplicability: HmViewModel.editableResponseTypesForFactor[k].currencyapplicability(),
                                    weightings: HmViewModel.editableResponseTypesForFactor[k].weightings(),
                                    response: HmViewModel.editableResponseTypesForFactor[k].response(),
                                    Weightedaverageflag: HmViewModel.FactorWeightedAverageType(),
                                    isGlobalFlag: HmViewModel.isGlobalFlag(),
                                    AssessmentType: AssessmentType[j].AssessmentName(),
                                    AssessmentTypeId: AssessmentType[j].AssessmentId()
                                }));

                                if (HmViewModel.editableResponseTypesForFactor[k].calculationapplicability() == false) {
                                    $("#RESPONSE" + responseType).attr('disabled', 'disabled');
                                }
                            }

                        }
                    }
                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ApplicabilityChanged() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    }

    function update(data) {
        try {
            //HmViewModel.QuestionGuideline(CKEDITOR.instances["factorGuideline"].getData());
            var selectedAssessmentTypeFactor = [];
            for (let i = 0; i < HmViewModel.SelectedAssessmentTypeFactor().length; i++) {
                selectedAssessmentTypeFactor.push(HmViewModel.SelectedAssessmentTypeFactor()[i]);
            }
            for (let i = 0; i < HmViewModel.SelectedAssessmentTypeFactorEdit().length; i++) {
                selectedAssessmentTypeFactor.push(HmViewModel.SelectedAssessmentTypeFactorEdit()[i]);
            }
            HmViewModel.SelectedAssessmentTypeFactor([]);
            HmViewModel.SelectedAssessmentTypeFactor(selectedAssessmentTypeFactor);
            HmViewModel.SelectedZATRATList([]);
            var MappedZATRATList = [];
            for (var j = 0; j < HmViewModel.SelectedAssessmentTypeFactor().length; j++) {
                for (var k = 0; k < HmViewModel.ZATRATList().length; k++) {
                    if (HmViewModel.ZATRATList()[k].ZAT_UID() == HmViewModel.InherentSetupQuantObj().SurveyCategoryId() &&
                        HmViewModel.ZATRATList()[k].RAT_UID() == HmViewModel.SelectedAssessmentTypeFactor()[j].toString()) {
                        MappedZATRATList.push(new ZATRATModel(HmViewModel.InherentSetupQuantObj().SurveyCategoryId(), null, HmViewModel.SelectedAssessmentTypeFactor()[j]));
                    }
                }
            }

            HmViewModel.SelectedZATRATList(MappedZATRATList);
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            var responseData = $.map(HmViewModel.editableResponseTypes(), function (item) {
                return {
                    ResponseId: item.ResponseId(),
                    Rank: item.Rank(),
                    ResponseType: item.ResponseType(),
                    description: item.description(),
                    calculationapplicability: item.calculationapplicability() == 1 ? true : false,
                    currencyapplicability: item.currencyapplicability(),
                    weightings: item.weightings(),
                    response: item.response(),
                    Weightedaverageflag: HmViewModel.FactorWeightedAverageType(),
                    isGlobalFlag: HmViewModel.isGlobalFlag(),
                    AssessmentType: item.AssessmentType(),
                    AssessmentTypeId: item.AssessmentTypeId()

                };
            });
            HmViewModel.UpdateRiskAreaLangList([]);
            var riskFactorEditObj = "";
            $('#valErrorRF').hide();

            $.each(HmViewModel.FactorRiskAreaList, function (key, value) {
                riskFactorEditObj = new RiskAreaFactor(value.LanguageType);
                if (riskFactorEditObj.RiskAreaName == "") {
                    $('#valErrorRF').show();
                    $('#valErrorRF').text('Risk Factor name in ' + GetLanguageName(value.LanguageType) + ' is required.');
                    return;
                } else {
                    $('#valErrorRF').text('');
                }

                HmViewModel.UpdateRiskAreaLangList.push(riskFactorEditObj);
            });
            if ($('#valErrorRF').text() == "") {
                UpdateRiskFactorAjax = {
                    url: "/api/Configuration/UpdateRiskFactor",
                    type: "POST",
                    data: {
                        RiskFactorId: HmViewModel.editableRiskFactor().RiskFactorId(),
                        RiskFactorName: HmViewModel.editableRiskFactor().RiskFactorName(),
                        RiskAreaId: HmViewModel.editableRiskFactor().RiskAreaId(),
                        RiskAreaName: HmViewModel.editableRiskFactor().RiskAreaName(),
                        AssessmentType: HmViewModel.editableRiskFactor().AssessmentType(),
                        QuantitativeResponseColumns: responseData,
                        RiskAreaSubList: HmViewModel.UpdateRiskAreaLangList(),
                        ZATRATModelObj: HmViewModel.SelectedZATRATList(),
                        QuestionGuideline: HmViewModel.QuestionGuideline(),
                        CalculationApplicabilityFlag: HmViewModel.editableRiskFactor().CalculationApplicabilityFlag()
                    },
                    headers: headers
                };
                $.ajax(UpdateRiskFactorAjax)
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in update() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(result, status) {
            try {
                if (result == "2") {
                    logger.logError(data.RiskFactorName() + 'already exists. Please try updating with a different name.', 'Error', system.getModuleId(HmViewModel), true);
                }
                else if (result == "1") {
                    GetRiskFactors(HmViewModel.CurrentRiskAreaId());
                    logger.logSuccess(
                        //'Risk Factor updated successfully.'
                        ((!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('RiskFactorUpdateSuccess') == -1) ? 'Risk Factor updated successfully.' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('RiskFactorUpdateSuccess')].Name())
                        , 'Success', system.getModuleId(HmViewModel), true);
                }
                else if (result == "0") {
                    logger.logWarning(
                        //'No such Risk Factor exists. Please refresh the page and perform the edit operation.'
                        ((!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('RiskFactorUpdateNotExists') == -1) ? 'No such Risk Factor exists. Please refresh the page and perform the edit operation.' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('RiskFactorUpdateNotExists')].Name())
                        , 'Warning', system.getModuleId(HmViewModel), true);
                }
                else if (result != null) {
                    if (isNaN(result) && result.substring(0, 3) == "INC")
                        logger.logError(result + ' - An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(HmViewModel), true);
                }
                else
                {
                    logger.logError(
                        //'An error occurred. Please refresh the page and perform the edit operation.'
                        ((!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('RiskFactorUpdateRefresh') == -1) ? 'An error occurred while updating the Risk Factor.' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('RiskFactorUpdateRefresh')].Name())
                        , 'Error', system.getModuleId(HmViewModel), true);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in update() method in RiskArea&Factor.js';
                logger.logMessage(msg);
            }
        }


        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage(((!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name), (!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage') == -1) ? 'Error in Edit Operation' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage')].Name, ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                } else {
                    var msg = 'Exception: ' + error.statusText + ' | Source:ajaxFail in update() method in RiskArea&Factor.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source:ajaxFail in update() method in RiskArea&Factor.js';
                logger.logMessage(msg);
            }
        }
    }


    function GetFactorApplicabilityDetails(FactorId) {
        try {
            return $.ajax({
                url: "/api/Configuration/GetAllFactorApplicabilityDetails",
                type: "GET",
                headers: appsecurity.getSecurityHeaders(),
                data: { FactorID: FactorId }
            })
                .success(function (jsonResult, error) {
                    // var responseTypeLenght = HmViewModel.editableResponseTypesForFactor.length;
                    if (jsonResult.length > 0) {
                        HmViewModel.WeightedAverageType(true);
                        var MappedListDetails = $.map(jsonResult, function (result) {
                            if (result.Is_Average_Flag == 1) {
                                HmViewModel.WeightedAverageType(false);
                            }
                            return new QuanResponseColumnDetails(result);
                        });
                        HmViewModel.editableResponseTypes([]);
                        HmViewModel.editableResponseTypes(MappedListDetails);
                    }
                    HmViewModel.assessmentSelected(true);
                    var element = $('#outerdiv')[0];
                    ko.cleanNode(element);
                    ko.applyBindings(HmViewModel, document.getElementById('outerdiv'));

                })
                .fail(function (error, status) {
                    if (error.status == 401) {
                        app.showMessage(((!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name), (!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage') == -1) ? 'Error in Edit Operation' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage')].Name, ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();

                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetActiveRoles() method in UserRole.js';
                        logger.logMessage(msg);
                    }
                });

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source:GetFactorApplicabilityDetails() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    }
    function addRiskFactor(data) {
        try {

            var selectedassessmetId = "";
            var riskFactorObj = "";
            for (var i = 0; i < HmViewModel.SelectedAssessmentTypeFactor().length; i++) {
                if (i == 0)
                    selectedassessmetId += selectedassessmetId + HmViewModel.SelectedAssessmentTypeFactor()[i];
                else
                    selectedassessmetId += "|" + HmViewModel.SelectedAssessmentTypeFactor()[i];
            }
            $('#valErrorRF').hide();
            for (var j = 0; j < HmViewModel.SelectedLanguageFactorType().length; j++) {
                for (var i = 0; i < HmViewModel.ObjGeneralSettings.LanguageList().length; i++) {
                    if (parseInt(HmViewModel.SelectedLanguageFactorType()[j]) == HmViewModel.ObjGeneralSettings.LanguageList()[i].LANGUAGE_ID._latestValue) {
                        selectedItem = HmViewModel.SelectedLanguageFactorType()[j];
                        riskFactorObj = new RiskAreaFactor(selectedItem);
                        //validate language text boxes
                        if (riskFactorObj.RiskAreaName == "") {
                            $('#valErrorRF').show();
                            $('#valErrorRF').text('Risk Factor name in ' + HmViewModel.ObjGeneralSettings.LanguageList()[i].LANGUAGENAME() + ' is required.');
                            return;
                        } else {
                            $('#valErrorRF').text('');
                        }
                        HmViewModel.ObjFactorRiskAreaList.push(riskFactorObj);
                    }
                }
            }
            HmViewModel.SelectedZATRATList([]);
            var MappedZATRATList = [];
            for (var j = 0; j < HmViewModel.SelectedAssessmentTypeFactor().length; j++) {
                for (var k = 0; k < HmViewModel.ZATRATList().length; k++) {
                    if (HmViewModel.ZATRATList()[k].ZAT_UID() == HmViewModel.InherentSetupQuantObj().SurveyCategoryId() &&
                        HmViewModel.ZATRATList()[k].RAT_UID() == HmViewModel.SelectedAssessmentTypeFactor()[j]) {
                        MappedZATRATList.push(new ZATRATModel(HmViewModel.InherentSetupQuantObj().SurveyCategoryId(), null, HmViewModel.SelectedAssessmentTypeFactor()[j]));
                    }
                }
            }

            HmViewModel.SelectedZATRATList(MappedZATRATList);

            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            var responseData = $.map(HmViewModel.editableResponseTypes(), function (item) {
                return {
                    ResponseId: item.ResponseId(),
                    Rank: item.Rank(),
                    ResponseType: item.ResponseType(),
                    description: item.description(),
                    calculationapplicability: item.calculationapplicability(),
                    weightings: item.weightings(),
                    response: item.response(),
                    Weightedaverageflag: HmViewModel.FactorWeightedAverageType(),
                    isGlobalFlag: HmViewModel.isGlobalFlag(),
                    AssessmentType: item.AssessmentType(),
                    AssessmentTypeId: item.AssessmentTypeId(),
                    currencyapplicability: item.currencyapplicability()
                };
            });

            headers.__RequestVerificationToken = csrfToken;
            AddRiskFactorAjax = {
                url: "/api/Configuration/AddRiskFactor",
                type: "POST",
                data: {
                    RiskFactorId: HmViewModel.editableRiskFactor().RiskFactorId(),
                    RiskFactorName: HmViewModel.editableRiskFactor().RiskFactorName(),
                    RiskAreaId: HmViewModel.editableRiskFactor().RiskAreaId(),
                    RiskAreaName: HmViewModel.editableRiskFactor().RiskAreaName(),
                    AssessmentType: selectedassessmetId,
                    QuantitativeResponseColumns: responseData,
                    RiskAreaSubList: HmViewModel.ObjFactorRiskAreaList._latestValue,
                    ZATRATModelObj: HmViewModel.SelectedZATRATList(),
                    QuestionGuideline: HmViewModel.QuestionGuideline(),
                    CalculationApplicabilityFlag: HmViewModel.editableRiskFactor().CalculationApplicabilityFlag()

                },
                headers: headers
            }
            $.ajax(AddRiskFactorAjax)
                .success(ajaxSuccess)
                .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in addRiskFactor() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, status) {
            try {
                HmViewModel.ObjFactorRiskAreaList([]);
                if (jsonResult != null)
                {
                    if (jsonResult.Incident_Description != null && jsonResult.Incident_Description.substring(0, 3) == "INC") {
                        logger.logError(jsonResult.Incident_Description + ' - An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(HmViewModel), true);
                    }
                    else if (jsonResult.RiskFactorId != 0 && jsonResult.RiskFactorNameClean != null)
                    {
                        if (jsonResult.Flag == 1)
                            logger.logSuccess(
                                //'Risk Factor added successfully.'
                                ((!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('RiskFactorAddSuccess') == -1) ? 'Risk Factor added successfully.' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('RiskFactorAddSuccess')].Name())
                                , 'Success', system.getModuleId(HmViewModel), true);
                        var newRiskFactor = new RiskFactorModel(jsonResult);
                        HmViewModel.RiskFactorList.push(newRiskFactor);
                        var newSortorderelement = new RiskFactorSortModel(jsonResult);
                        HmViewModel.RiskFactorSortOrder(HmViewModel.RiskFactorSortOrder() - 1);
                        var newSortorderelementDup = new RiskFactorSortModel(jsonResult);
                        HmViewModel.RiskFactorReorderList.push(newSortorderelement);
                        HmViewModel.RiskFactorReorderListDup.push(newSortorderelementDup);
                        //var node = RfTableObj.row.add(['<div style="display:none"></div>', newRiskFactor.RiskFactorId(), newRiskFactor.RiskFactorName(), newRiskFactor.AssessmentType(), '<a href="javascript:void(0)" title="Edit" class="btn-borderless widget-button" data-bind="click: $root.editFunctionality"><i class="demo-icon icon-file_edit_special"></i></a><a href="javascript:void(0)" title="Delete" class="btn-borderless widget-button" data-bind="click: $root.deleteFunctionality"><i class="demo-icon icon-bin_special"></i></a>']).draw();
                        //var addedRow = $('#tblRiskFactor').find('tr').get(1);
                        //ko.applyBindingsToNode($(node.node()).find('a').get(0), { click: HmViewModel.editFunctionalityRF }, newRiskFactor);
                        //ko.applyBindingsToNode($(node.node()).find('a').get(1), { click: HmViewModel.deleteFunctionalityRF }, newRiskFactor);
                        //ko.applyBindingsToNode($(node.node()).find('td').get(0), { click: HmViewModel.trclick }, HmViewModel);
                        GetRiskFactors(HmViewModel.CurrentRiskAreaId());
                    }

                    else if (jsonResult.Flag == -2)
                    {
                        logger.logError('Invalid text found.', 'Error', system.getModuleId(HmViewModel), true);
                    }
                    else
                    {
                        logger.logError(
                            //'Failed to add Risk Factor.'
                            ((!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('RiskFactorAddFail') == -1) ? 'Failed to add Risk Factor.' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('RiskFactorAddFail')].Name())
                            , 'Error', system.getModuleId(HmViewModel), true);
                    }
                }
                else if (jsonResult.RiskFactorId == null)
                {

                    let RiskFactorAlreadyExists = (!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('RiskFactorAlreadyExists') == -1) ? 'already exists. Please enter a different Risk Factor.' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('RiskFactorAlreadyExists')].Name();

                    logger.logError(data.RiskFactorName() + " " + RiskFactorAlreadyExists, 'Error', system.getModuleId(HmViewModel), true);

                }

                else
                {
                    logger.logError('An error occurred. Please contact your Administrator', 'Error', system.getModuleId(HmViewModel), true);
                }
            }
            catch (e)
            {
                var msg = 'Exception: ' + e + ' | Source:ajaxSuccess in addRiskFactor() method in RiskArea&Factor.js';
                logger.logMessage(msg);
            }
            $('#frmRiskFactor').modal('hide');
            $('body').removeClass('modal-open');
            $('.modal-backdrop').remove();
        };

        function ajaxFail(error, status) {
            try {
                HmViewModel.ObjFactorRiskAreaList([]);
                if (error.status == 401) {
                    app.showMessage(((!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name), (!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage') == -1) ? 'Error in Edit Operation' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage')].Name, ["OK"])
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                } else {
                    var msg = 'Exception: ' + error.statusText + ' | Source:ajaxFail in addRiskFactor() method in RiskArea&Factor.js';
                    logger.logMessage(msg);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source:ajaxFail in addRiskFactor() method in RiskArea&Factor.js';
                logger.logMessage(msg);
            }
        };
    }

    function LanguageFactorAdded() {
        try {
            var selectedLanguage = HmViewModel.SelectedLanguageFactorType();
            $('#DynamicRiskFactorDiv').empty();
            var QuestionNameHTMl = "";

            for (var j = 0; j < HmViewModel.SelectedLanguageFactorType().length; j++) {
                for (var i = 0; i < HmViewModel.ObjGeneralSettings.LanguageList().length; i++) {
                    if (parseInt(HmViewModel.SelectedLanguageFactorType()[j]) == HmViewModel.ObjGeneralSettings.LanguageList()[i].LANGUAGE_ID._latestValue) {

                        let RiskFactorNameIn = (!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('RiskFactorNamein') == -1) ? 'Risk Factor Name in' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('RiskFactorNamein')].Name();

                        QuestionNameHTMl += '<div class="new-form-group padding-right-0">' +
                            '<label class="control-label pt-0">Risk Factor Name (' + HmViewModel.ObjGeneralSettings.LanguageList()[i].LANGUAGENAME() + ') </label>' +
                            '<div>' +
                            '<input id="questionname' + HmViewModel.SelectedLanguageFactorType()[j] + '" class="form-control" placeholder="' + RiskFactorNameIn + " " + HmViewModel.ObjGeneralSettings.LanguageList()[i].LANGUAGENAME._latestValue + '" data-bind="value: FactorRiskAreaList().RiskFactorName" type="text" />' +
                            '</div>' +
                            '</div>';
                    }
                }
            }
            document.getElementById('DynamicRiskFactorDiv').innerHTML = QuestionNameHTMl;
            ko.cleanNode(document.getElementById('DynamicRiskFactorDiv'));
            if (selectedLanguage.length > 2) {
                //$('#DynamicRiskFactorDiv').css({
                //    "margin-left": ".7rem", "margin-bottom": "1rem",
                //    "overflow-y": "scroll", "overflow-x": "hidden", "height": "auto", "max-height": "30rem",
                //    "border": "1px solid lightgray",
                //    "padding-top": "5px !important",
                //    "padding-bottom": "5px !important",
                //    "padding-top": "1rem"
                //});
                $("modalContentSubFactor").css({ "height": "auto", "max-height": "75rem" });

            } else {
                $('#DynamicRiskFactorDiv').removeAttr("Style");
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: LanguageFactorAdded() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    }

    function AddDynamicFactorElements(item) {
        try {
            $('#DynamicRiskFactorDiv').empty();
            var QuestionNameHTMl = "";

            if (item.length > 2) {
                //$('#DynamicRiskFactorDiv').css({
                //    "margin-left": ".7rem", "margin-bottom": "1rem",
                //    "overflow-y": "scroll", "overflow-x": "hidden", "height": "11rem",
                //    "border": "1px solid lightgray",
                //    "padding-top": "5px !important",
                //    "padding-bottom": "5px !important",
                //    "padding-top": "1rem"
                //});
            } else {
                $('#DynamicRiskFactorDiv').removeAttr("Style");
            }

            $.each(item, function (key, value) {
                QuestionNameHTMl += '<div class="new-form-group">' +
                    '<label class="control-label pt-0">Risk Factor Name (' + GetLanguageName(value.LanguageType) + ')</label>' +
                    '<div>' +
                    '<input id="questionname' + value.LanguageType + '" class="form-control" data-bind="value: FactorRiskAreaList().RiskAreaName" type="text" />' +
                    '</div>' +
                    '</div>';
            });

            document.getElementById('DynamicRiskFactorDiv').innerHTML = QuestionNameHTMl;
            ko.cleanNode(document.getElementById('DynamicRiskFactorDiv'));
            ko.applyBindings(HmViewModel, document.getElementById("DynamicRiskFactorDiv"));
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: AddDynamicFactorElements() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    }

    function RiskAreaFactor(item) {
        try {
            var self = this;
            self.RiskAreaName = $('#questionname' + item).val();
            self.LanguageType = item;
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RiskAreaFactor() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    };


    function GetFactorQuanResponseAndLanguages(RiskFactorId) {
        try {
            GetRiskFactorLanListAjax = {
                url: "/api/Configuration/GetFactorQuanAndLanguageList",
                type: "GET",
                headers: appsecurity.getSecurityHeaders(),
                async: false,
                data: { "RiskFactorId": RiskFactorId }
            };
            GetRiskFactorLangList(GetRiskFactorLanListAjax);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: GetFactorQuanResponseAndLanguages() method in RiskAreaAndFactors.js';
            logger.logMessage(msg);
        }
    }

    function GetRiskFactorLangList(GetRiskFactorLanListAjax) {
        try {
            $.ajax(GetRiskFactorLanListAjax)
                .success(ajaxSuccess)
                .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source:ajax call in GetRiskFactorSubList() method in RiskAreaAndFactors.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult != 'undefined' && jsonResult != null) {
                    if (jsonResult.RiskAreaSubList != 'undefined' && jsonResult.RiskAreaSubList != null) {
                        HmViewModel.FactorRiskAreaList = jsonResult.RiskAreaSubList;
                    }
                    if (jsonResult.QuantitativeResponseColumnsList != 'undefined' && jsonResult.QuantitativeResponseColumnsList != null) {
                        var mappedresponseColumnList = $.map(jsonResult.QuantitativeResponseColumnsList, function (result) {
                            return new QuantitativeResponseColumnsModel(result);
                        });
                        HmViewModel.editableResponseTypes(mappedresponseColumnList);
                        HmViewModel.editableResponseTypesForFactor = (mappedresponseColumnList);
                        HmViewModel.WeightedAverageType(HmViewModel.editableResponseTypes()[0].Weightedaverageflag());
                        HmViewModel.isGlobalFlag(HmViewModel.editableResponseTypes()[0].isGlobalFlag());

                        if (HmViewModel.EditFactorVisible()) {
                            if (HmViewModel.editableResponseTypesForFactor.length > 0) {
                                HmViewModel.assessmentSelected(true);
                                $("#ApplicabilityForFactor").attr('disabled', 'disabled')
                                HmViewModel.editableResponseTypes([]);

                                if (HmViewModel.editableResponseTypesForFactor[0].Weightedaverageflag()) {
                                    HmViewModel.FactorWeightedAverageType(true);
                                    document.getElementById("WghtdAvgFactor").checked = true;
                                } else {
                                    HmViewModel.FactorWeightedAverageType(false);
                                    document.getElementById("WghtdAvgFactor").checked = false;
                                    document.getElementById("SmplAvgFactor").checked = true;
                                }
                                for (k = 0; k < HmViewModel.editableResponseTypesForFactor.length; k++) {

                                    var responseType = HmViewModel.editableResponseTypes().length + 1;
                                    HmViewModel.editableResponseTypes.push(new QuantitativeResponseColumnsModel({
                                        ResponseId: HmViewModel.editableResponseTypesForFactor[k].ResponseId(),
                                        ResponseType: HmViewModel.editableResponseTypesForFactor[k].ResponseType(),
                                        description: HmViewModel.editableResponseTypesForFactor[k].description(),
                                        calculationapplicability: HmViewModel.editableResponseTypesForFactor[k].calculationapplicability(),
                                        currencyapplicability: HmViewModel.editableResponseTypesForFactor[k].currencyapplicability(),
                                        weightings: HmViewModel.editableResponseTypesForFactor[k].weightings(),
                                        response: HmViewModel.editableResponseTypesForFactor[k].ResponseType(),
                                        Weightedaverageflag: HmViewModel.editableResponseTypesForFactor[k].Weightedaverageflag(),
                                        isGlobalFlag: HmViewModel.editableResponseTypesForFactor[k].isGlobalFlag(),
                                        AssessmentType: HmViewModel.editableResponseTypesForFactor[k].AssessmentType(),
                                        AssessmentTypeId: HmViewModel.editableResponseTypesForFactor[k].AssessmentTypeId()
                                    }));
                                }

                            }
                        }
                    }
                }
                else {
                    HmViewModel.FactorRiskAreaList([]);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source:ajaxSuccess in GetRiskFactorSubList() method in RiskAreaAndFactors.js';
                logger.logMessage(msg);
            }
        }
        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage(((!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name), (!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage') == -1) ? 'Error in Edit Operation' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage')].Name, ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetRiskFactorSubList() method in RiskAreaAndFactors.js';
                    logger.logMessage(msg);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetRiskFactorSubList() method in RiskAreaAndFactors.js';
                logger.logMessage(msg);
            }
        }
    }
    // for deleting the risk area alert
    function deleteRiskAreafunction(event, a) {
        try {

            var ID = a.currentTarget.id;
            app.showMessage(
                //'Are you sure you want to delete this Risk Area? Once deleted, it cannot be undone.'
                ((!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('RiskAreaDeleteConfirm') == -1) ? 'Are you sure you want to delete this Risk Area? Once deleted, it cannot be undone.' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('RiskAreaDeleteConfirm')].Name())
                ,
                //'Delete Risk Area'
                ((!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('DeleteRiskAreaLabel') == -1) ? 'Delete Risk Area' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('DeleteRiskAreaLabel')].Name())
                , [(!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ConfirmButton') == -1) ? 'Confirm' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ConfirmButton')].Name, (!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CancelButton') == -1) ? 'Cancel' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CancelButton')].Name])
                .then(function (option) {
                    var confirmText = ((!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ConfirmButton') == -1) ? 'Confirm' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ConfirmButton')].Name()).toString();
                    if (option == confirmText) {
                        deleteRiskArea(ID);
                    }
                });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: deleteRiskAreafunction() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    }

    // Deleting the risk area ajax call
    function deleteRiskArea(ID) {
        try {
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            $.ajax({
                url: "/api/Configuration/DeleteRiskArea?SurveyCategoryId=" + HmViewModel.InherentSetupQuantObj().SurveyCategoryId(),
                dataType: "json",
                contentType: "application/json; charset=utf-8",
                data: ko.toJSON({
                    RiskAreaId: ID
                }),
                headers: headers,
                type: "POST"
            })
                .success(ajaxSuccess)
                .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in deleteRiskArea() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(result, status) {
            try {
                if (result != null) {
                    if (result == "1") {
                        GetAllRiskAreas();
                        logger.logSuccess(
                            //'Risk Area deleted successfully.'
                            ((!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('RiskAreaDeleteSuccess') == -1) ? 'Risk Area deleted successfully.' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('RiskAreaDeleteSuccess')].Name())
                            , 'Success', system.getModuleId(HmViewModel), true);
                    }
                    else if (isNaN(result) && result.substring(0, 3) == "INC") {
                        logger.logError(result + ' - An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(HmViewModel), true);
                    }
                    else {
                        logger.logError(
                            //'Failed to delete Risk Area'
                            ((!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('RiskAreaDeleteFail') == -1) ? 'Failed to delete Risk Area' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('RiskAreaDeleteFail')].Name())
                            , 'Error', system.getModuleId(HmViewModel), true);
                    }
                }
                else {
                    logger.logError(
                        //'Failed to delete Risk Area'
                        ((!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('RiskAreaDeleteFail') == -1) ? 'Failed to delete Risk Area' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('RiskAreaDeleteFail')].Name())
                        , 'Error', system.getModuleId(HmViewModel), true);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in deleteRiskArea() method in RiskArea&Factor.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage(
                        //"You have been logged out. Please log in again to complete the Operation."
                        ((!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMsg') == -1) ? 'You have been logged out. Please log in again to complete the Operation.' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMsg')].Name())
                        , (!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage') == -1) ? 'Error in Edit Operation' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage')].Name, ["OK"])
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                } else {
                    var msg = 'Exception: ' + error.statusText + ' | Source:ajaxFail in deleteRiskArea() method in RiskArea&Factor.js';
                    logger.logMessage(msg);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source:ajaxFail in deleteRiskArea() method in RiskArea&Factor.js';
                logger.logMessage(msg);
            }
        }
    }


    //tblriskfactor expand collapse method
    function trclick(data, event) {
        try {
            var tr = $(event.currentTarget).closest('tr');
            var row = RfTableObj.row(tr);
            checkExpandedRow(row, false);
            if (row.child.isShown()) {
                //close the open row
                row.child.hide();
                tr.removeClass('shown');
            }
            else {
                // Open this row
                row.child(format(row.data())).show();
                tr.addClass('shown');
                ko.applyBindingsToNode($('#subfactor').find('tbody').get(0), { foreach: HmViewModel.RiskSubFactorsList }, HmViewModel);
                if (HmViewModel.ControlsAccess())
                    ko.applyBindingsToNode($('#btnsfReorder'), { disabled: true, click: HmViewModel.OpenRiskSubFactorOrderPopup }, HmViewModel);
                ko.applyBindingsToNode($('#addSubFactorBtn'), { click: HmViewModel.addRiskSubFactorFunctionality }, data);
                RfSubFactorTableObj = $("#subfactor").DataTable({

                    responsive: true,
                    stateSave: true,
                    "paging": true,
                    "order": [],

                    "ColumnDefs": [{
                        "targets": [0],
                        "order": [],
                        "visible": false
                    }, {
                        "targets": [1],
                        "order": [],
                        "orderable": false
                    },
                    {
                        "targets": [2],
                        "order": [],
                        "orderable": false

                    },
                    {
                        "targets": [3],
                        "order": [],
                        "orderable": false

                    },
                    {
                        "targets": [6],
                        "order": [],
                        "orderable": false

                    },
                    {
                        "targets": [7],
                        "order": [],
                        "orderable": false,
                        "className": "text-center",
                        "visible": HmViewModel.ControlsAccess()
                    }
                    ]
                })
                var rows = $("#subfactor").dataTable().fnGetNodes();
                var cells = [];
                for (var i = 0; i < rows.length; i++) {
                    // Get HTML of 3rd column (for example)
                    var x = $(rows[i]).find("td:eq(3)").html();
                    var y = x.replace('|', '<br/>');
                    $(rows[i]).find("td:eq(3)").html(y);
                }
                GetQuanHeadersByRiskFactor(row.data());
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: trclick() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    }

    function GetQuanHeadersByRiskFactor(data) {
        try {
            var FactorId = parseInt(data[1]);
            $.ajax({
                url: "/api/Configuration/GetQuanHeadersByRiskFactor",
                type: "GET",
                headers: appsecurity.getSecurityHeaders(),
                data: { "RiskFactorId": FactorId }
            })
                .success(ajaxSuccess)
                .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: GetQuanHeadersByRiskFactor() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(jsonResult, error) {
            try {
                HmViewModel.HeaderSubFactorsList([]);
                if (jsonResult != null && jsonResult.length > 0) {
                    var mappedHeaders = $.map(jsonResult, function (result) {
                        return new RiskSubFactorHeaderModel(result);
                    });
                    HmViewModel.HeaderSubFactorsList(mappedHeaders);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in  GetQuanHeadersByRiskFactor() method in RiskArea&Factor.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage(((!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name), (!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage') == -1) ? 'Error in Edit Operation' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage')].Name, ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                } else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetQuanHeadersByRiskFactor() method in RiskArea&Factor.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxfail in GetQuanHeadersByRiskFactor() method in RiskArea&Factor.js';
                logger.logMessage(msg);
            }
        }
    }

    function checkExpandedRow(row, isPaginating) {
        try {
            var rowsInTable = $('#tblRiskFactor').find('tr');
            if (isPaginating)
                currentRowIndex = -1;
            else
                currentRowIndex = row.index();
            var info = RfTableObj.page.info();
            for (var i = 1, j = (rowsInTable.length); i < j; i++) {
                //if (currentRowIndex != (i - 1)) {
                var tr = $('#tblRiskFactor').find('tr').get(i);
                if (RfTableObj.row(tr).index() != row.index()) {
                    var tableRowIndex = (info.page * info.length) + (i - 1);

                    if ((RfTableObj.row(tableRowIndex).child() != undefined) && (RfTableObj.row(tableRowIndex).child.isShown())) {
                        RfTableObj.row(tableRowIndex).child.remove();
                        tr.removeAttribute('class', 'shown')
                        j = $('#tblRiskFactor').find('tr').length;
                    }
                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: checkExpandedRow() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    }

    // for adding tblsubfactor in the expanded row
    function format(data) {
        try {
            HmViewModel.RiskFactorId(data[1]);
            HmViewModel.AssessmentTypeSubFactorParent(data[5]);
            GetAllRiskSubFactorsAjax = {

                url: "/api/configuration/GetRiskSubFactor",
                type: "GET",
                headers: appsecurity.getSecurityHeaders(),
                data: {
                    "RiskFactorId": HmViewModel.RiskFactorId(),
                    "SurveyCategoryID": HmViewModel.InherentSetupQuantObj().SurveyCategoryId(),
                    "AssessmentTypes": HmViewModel.InherentSetupQuantObj().AssessmentTypeId()
                },
                async: false
            };
            GetAllRiskSubFactors(GetAllRiskSubFactorsAjax);

            let EditTitle = (!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditButton') == -1) ? 'Edit' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditButton')].Name();
            let DeleteTitle = (!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('DeleteButton') == -1) ? 'Delete' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('DeleteButton')].Name();
            let SubFactors = (!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('Sub-Factors') == -1) ? 'Sub-Factors' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('Sub-Factors')].Name();

            var SfHtml = '<div class="child-active" style="margin-left:3em;">' +
                '<div class="panel panel-success panel-margin" style="padding:3px;">' +
                '<div class="panel-heading">' +
                '<h5 class="panel-title riskFactorCellPanel">' + SubFactors;
            if (HmViewModel.ControlsAccess()) {
                let AddRiskSubFactorTitle = (!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AddRiskSubFactorTitle') == -1) ? 'Click to add new Risk SubFactor' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AddRiskSubFactorTitle')].Name();
                let AddSubFactor = (!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AddSubFactor') == -1) ? 'Add Sub-Factor' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AddSubFactor')].Name();
                //AddSubFactor
                SfHtml += '<button id="addSubFactorBtn" class="btn btn-primary btn-sm pull-right addSubFactorBtn font-xxsmall" data-bind="click: $root.addRiskSubFactorFunctionality" title="' + AddRiskSubFactorTitle + '">' +
                    '<i class="fa fa-plus"></i>' + AddSubFactor +
                    '</button>';
            }
            if (HmViewModel.ControlsAccess()) {
                let ReOrderRiskSubFactors = (!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('Re-OrderRiskSub-Factors') == -1) ? 'Re-Order Risk Sub-Factors' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('Re-OrderRiskSub-Factors')].Name();
                SfHtml += '<button style="margin-right:1em"  id="btnsfReorder" class="btn btn-primary btn-sm pull-right addSubFactorBtn font-xxsmall" data-bind="click: $root.OpenRiskSubFactorOrderPopup" title="Click to re order the sequence of Risk Sub-Factor">' +
                    '<i class="fa fa-sort"></i>' + ReOrderRiskSubFactors +
                    '</button>';
            }
            SfHtml += '</h5>' +
                '</div>' +
                '</div>' +
                '<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 subfactor-margin">' +
                '<table id="subfactor" class="dataTable table-bordered" cellspacing="0">' +
                '<thead>' +
                '<tr>' +
                '<th style="display:none">Subfactor ID</th>' +
                '<th style="display:none">'

            //Risk Mapping
            SfHtml += (!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('RiskMapping') == -1) ? 'Risk Mapping' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('RiskMapping')].Name();
            SfHtml += '</th > ' +
                '<th>'
            //Sub - Factor Name
            SfHtml += (!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('Sub-FactorName') == -1) ? 'Sub-Factor Name' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('Sub-FactorName')].Name();
            SfHtml += '</th > ' +
                '<th>'
            //Applicability
            SfHtml += (!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('Applicability') == -1) ? 'Applicability' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('Applicability')].Name();
            SfHtml += '</th > ' +
                '<th style="text-align:left">'
            //Risk Level
            SfHtml += (!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('RiskLevel') == -1) ? 'Risk Level' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('RiskLevel')].Name();
            SfHtml += '</th > ' +
                '<th style="text-align:left">'
            //Sub - Factor Type
            SfHtml += (!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('Sub-FactorType') == -1) ? 'Sub-Factor Type' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('Sub-FactorType')].Name();
            SfHtml += '</th > ' +
                '<th class="actions" style="text-align:center">'
            //Calculation Applicability
            SfHtml += //Response Name
                (!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CalculationApplicability') == -1) ? 'Calculation Applicability' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CalculationApplicability')].Name();
            SfHtml += '</th > ' +
                '<th class="actions" style="text-align:center">'
            //Actions
            SfHtml += (!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('Actions') == -1) ? 'Actions' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('Actions')].Name();

            SfHtml += '</th > ' +
                '</tr>' +
                '</thead>' +
                '<tbody data-bind="foreach: RiskSubFactorsList">' +
                '<tr>' +
                '<td style="display:none" data-bind="text: RiskSubfactorId"></td>' +
                '<td style="display:none" data-bind="text: RiskMapping"></td>' +
                '<td data-bind="text: RiskSubfactorName"></td>' +
                '<td data-bind="text: AssessmentType"></td>' +

                '<td data-bind="text: RiskLevel" style="text-align:left"></td>' +
                '<td data-bind="text: QuestionTypeDescription" style="text-align:left"></td>' +

                '<td data-bind="text: ApplicabilityFlag" style="text-align:left"></td>' +

                //'<td data-bind="if: data.CalculationApplicabilityFlag()=="True">'+
                //'<span style="text - align:left">Yes</span></td>' +
                //'<td data-bind="if: data.CalculationApplicabilityFlag()=="False">'+
                //'<span style = "text - align:left">No</span></td>' +

                '<td class="text-center">' +
                '<a href="javascript:void(0)" title="' + EditTitle + '" class="btn-borderless widget-button" data-bind="click: $root.editRiskSubFactorFunctionality">' +
                '<i class="demo-icon icon-file_edit_special"></i>' +
                '</a>' +
                '<a href="javascript:void(0)" title="' + DeleteTitle + '" class="btn-borderless widget-button" data-bind="click: $root.deleteRiskSubFactorFunctionality">' +
                '<i class="demo-icon icon-bin_special"></i>' +
                '</a>' +
                '</td>' +
                '</tr>' +
                '</tbody>' +
                '</table>' +
                '</div>';

            return SfHtml;
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: format() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    }

    // get all subfactor method
    function GetAllRiskSubFactors(GetAllRiskSubFactorsAjax) {
        try {

            $.ajax(GetAllRiskSubFactorsAjax)
                .success(ajaxSuccess)
                .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source:ajax call in GetAllRiskSubFactors() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(jsonResult, status) {
            try {
                HmViewModel.SelectedLanguageSubFactorType([]);
                HmViewModel.SubFactorRiskAreaList([]);

                HmViewModel.RiskSubFactorsList([]);
                HmViewModel.RiskSubFactorReorderList([]);
                HmViewModel.RiskSubFactorReorderListDup([]);

                var mappedRiskSubFactors = $.map(jsonResult, function (result) {
                    return new RiskSubFactorModel(result);
                });
                HmViewModel.RiskSubFactorSortOrder(0);
                var mappedRiskSubFactorssortorder = $.map(jsonResult, function (result) {
                    return new RiskSubFactorSortModel(result);
                });
                HmViewModel.RiskSubFactorSortOrder(0);
                var mappedRiskSubFactorssortorderDup = $.map(jsonResult, function (result) {
                    return new RiskSubFactorSortModel(result);
                });

                tableObj = $('#subfactor').DataTable();
                tableObj.destroy();
                $("#subfactor tbody tr").remove();
                HmViewModel.RiskSubFactorReorderList(mappedRiskSubFactorssortorder);
                HmViewModel.RiskSubFactorReorderListDup(mappedRiskSubFactorssortorderDup);
                HmViewModel.RiskSubFactorsList(mappedRiskSubFactors);
                RfSubFactorTableObj = $("#subfactor").DataTable({
                    responsive: true,
                    stateSave: true,
                    "paging": true,
                    "order": [],

                    "ColumnDefs": [{
                        "targets": [0],
                        "order": [],
                        "visible": false
                    }, {
                        "targets": [1],
                        "order": [],
                        "orderable": true
                    },
                    {
                        "targets": [2],
                        "order": [],
                        "orderable": true
                    }, {
                        "targets": [3],
                        "order": [],
                        "orderable": true,

                    },
                    {
                        "targets": [4],
                        "order": [],
                        "orderable": false,
                        "className": "text-center",
                        "visible": (HmViewModel.ControlsAccess())
                    }]
                })

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetAllRiskSubFactors() method in RiskArea&Factor.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage(((!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name), (!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage') == -1) ? 'Error in Edit Operation' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage')].Name, ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                } else {
                    var msg = 'Exception: ' + error.statusText + ' | Source:ajaxFail in GetAllRiskSubFactors() method in RiskArea&Factor.js';
                    logger.logMessage(msg);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source:ajaxfail in GetAllRiskSubFactors() method in RiskArea&Factor.js';
                logger.logMessage(msg);
            }
        };
    }

    function GetAllInherentLevels() {
        try {
            $.ajax({
                url: "/api/Configuration/GetAllInherentLevelswithNA",
                type: "GET",
                headers: appsecurity.getSecurityHeaders(),
                data: { AssessmentId: 0, SurveyCategoryId: HmViewModel.InherentSetupQuantObj().SurveyCategoryId() }
            })
                .success(function (jsonResult, Error) {
                    if (jsonResult == 0 || jsonResult == null) {
                    }
                    else {
                        var mappedIRSData = $.map(jsonResult, function (result) {
                            return new RiskLevelModel(result);
                        });
                        var mappedIRSDataDup = $.map(jsonResult, function (result) {
                            return new RiskLevelModel(result);
                        });
                        HmViewModel.InherentRiskLevelListDup(mappedIRSDataDup);
                        HmViewModel.InherentRiskLevelList(mappedIRSData);
                    }
                })
                .fail(function (jsonResult, log) {
                    if (error.status == 401) {
                        app.showMessage(((!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name), (!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage') == -1) ? 'Error in Edit Operation' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage')].Name, ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllInherentLevels() method in RiskArea&Factor.js';
                        logger.logMessage(msg);
                    }
                });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: GetAllInherentLevels() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    }

    function getIRSdata() {
        try {
            $.ajax({
                url: "/api/Configuration/GetIRSData",
                type: "GET",
                async: "false",
                headers: appsecurity.getSecurityHeaders()
            })
                .success(ajaxSuccess)
                .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in  getIRSdata() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(jsonResult, error) {
            try {
                if (jsonResult != null && jsonResult.length > 0) {
                    var mappedScore = $.map(jsonResult, function (result) {
                        if (result.DisplayText != "" && result.DisplayText != null) {
                            return new RiskScoreModel(result);
                        }

                    });
                    HmViewModel.RiskScoreDrpDwnList(mappedScore);
                    HmViewModel.valueAML(HmViewModel.RiskScoreDrpDwnList()[0].Id());
                    HmViewModel.valueSANC(HmViewModel.RiskScoreDrpDwnList()[0].Id());
                }

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in  getIRSdata() method in RiskArea&Factor.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage(((!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name), (!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage') == -1) ? 'Error in Edit Operation' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage')].Name, ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                } else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in getIRSdata() method in RiskArea&Factor.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxfail in getIRSdata() method in RiskArea&Factor.js';
                logger.logMessage(msg);
            }
        }
    }


    function AddDynamicElements(item) {
        $('#DynamicRiskAreaNameDiv').empty();
        var RiskAreaNameHTMl = "";

        $('#DynamicCommentsDiv').empty();
        var CommentsHTMl = "";

        $.each(item, function (key, value) {
            RiskAreaNameHTMl += '<div class="new-form-group">' +
                '<label class="control-label pt-0">Risk Area Name (' + GetLanguageName(value.LanguageType) + ')</label>' +
                '<div class="">' +
                '<input id="riskareaname' + value.LanguageType + '" class="form-control" data-bind="value: RiskAreaSubList().RiskAreaName" type="text" />' +
                '</div>' +
                '</div>';

            CommentsHTMl += '<div class="new-form-group">' +
                '<label class="control-label pt-0">Comments (' + GetLanguageName(value.LanguageType) + ')</label>' +
                '<div class="">' +
                '<textarea id="EditRaTextArea' + value.LanguageType + '" class="form-control" rows="5" data-bind="value:RiskAreaSubList().RiskAreaNotes" name="Notes" ></textarea>' +
                '</div>' +
                '</div>';
        });

        document.getElementById('DynamicRiskAreaNameDiv').innerHTML = RiskAreaNameHTMl;
        ko.cleanNode(document.getElementById('DynamicRiskAreaNameDiv'));
        ko.applyBindings(HmViewModel, document.getElementById("DynamicRiskAreaNameDiv"));

        document.getElementById('DynamicCommentsDiv').innerHTML = CommentsHTMl;
        ko.cleanNode(document.getElementById('DynamicCommentsDiv'));
        ko.applyBindings(HmViewModel, document.getElementById("DynamicCommentsDiv"));


    }

    function OpenRiskAreaOrderPopup() {
        try {
            HmViewModel.popUpTitle("Re-Order Risk Areas");
            HmViewModel.addPopUpCss(true);
            $('#frmRiskAreaReordermodel').modal('show');
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: OpenRiskAreaOrderPopup() method in OpenRIskAreaOrderPopup.js';
            logger.logMessage(msg);
        }
    }

    function OpenConfigureResponseTypePopup() {
        try {
            HmViewModel.EditFactorVisible(false);
            $('#rspError').hide();
            GetQuanResponseColumnDetails().then(function () {
                if (!HmViewModel.SimpleAverageType()) {
                    document.getElementById('WghtdAvg').checked = true;
                    HmViewModel.WeightedAverageType(true);
                }
                else {
                    document.getElementById('SmplAvg').checked = true;
                    HmViewModel.SimpleAverageType(true);
                }
                $('#frmResponseTypemodel').modal('show');
                $('#frmResponseTypemodel .modal-content').css({
                    'height': 'auto'
                });
                GetAllSurveyTypeAjax = {

                    url: "/api/Survey/GetSurveyTypes",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders()
                };

                GetAllSurveyType(GetAllSurveyTypeAjax).then(function () {

                    HmViewModel.popUpTitle("Configure Response Type");
                    HmViewModel.addPopUpCss(true);
                    $('#frmResponseTypemodel').modal('show');
                });

            })
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: OpenRiskAreaOrderPopup() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    }
    function GetAllOptionsType() {
        try {
            $.ajax({
                url: "/api/Configuration/GetAllQuantOptionsType",
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            })
                .success(function (jsonResult, error) {
                    HmViewModel.OptionsTypeList([]);
                    if (jsonResult != null) {
                        HmViewModel.OptionsTypeList(jsonResult);
                    }
                })
                .fail(function (jsonResult, error) {
                    logger.logError(((!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('FetchAssessmentsError') == -1) ? 'An error has occurred while fetching the type assessments. Please contact your Administrator.' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('FetchAssessmentsError')].Name()), 'Error', system.getModuleId(HmViewModel), true);
                });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: GetAllOptionsType() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    }
    function GetQuanResponseColumnDetails() {

        try {
            return $.ajax({
                url: "/api/Configuration/GetQuanResponseColumnDetails",
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            })
                .success(ajaxSuccess)
                .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in GetAllResponseColumnDetails() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, status) {
            try {

                if (jsonResult != null) {
                    var mappedresponseColumnList = $.map(jsonResult, function (result) {
                        return new QuantitativeResponseColumnsModel(result);
                    });
                    HmViewModel.editableResponseTypes([]);
                    HmViewModel.editableResponseTypes(mappedresponseColumnList);
                    for (var i = 0; i < HmViewModel.editableResponseTypes().length; i++) {
                        var arr = HmViewModel.editableResponseTypes()[i].RiskLevelId().split(',');
                        HmViewModel.editableResponseTypes()[i].SelectedComponentIRiskId([]);
                        HmViewModel.editableResponseTypes()[i].SelectedComponentIRiskId(arr); // ["16","17"]

                        var splitID = $.map(HmViewModel.editableResponseTypes()[i].RiskLevelId().split(","), $.trim);
                        $('#RiskScaleOptions' + HmViewModel.editableResponseTypes()[i].ResponseId()).multiselect();
                        $("#RiskScaleOptions" + HmViewModel.editableResponseTypes()[i].ResponseId()).val(splitID);
                        $('#RiskScaleOptions' + HmViewModel.editableResponseTypes()[i].ResponseId()).multiselect('refresh');

                    }
                    HmViewModel.editableResponseTypesForFactor = (mappedresponseColumnList);
                    HmViewModel.SimpleAverageType(HmViewModel.editableResponseTypes()[0].SimpleAverageflag());
                    HmViewModel.isGlobalFlag(HmViewModel.editableResponseTypes()[0].isGlobalFlag());

                    if (HmViewModel.EditFactorVisible()) {
                        if (HmViewModel.editableResponseTypesForFactor.length > 0) {
                            HmViewModel.assessmentSelected(true);
                            $("#ApplicabilityForFactor").attr('disabled', 'disabled')
                            HmViewModel.editableResponseTypes([]);

                            if (HmViewModel.editableResponseTypesForFactor[0].Weightedaverageflag()) {
                                HmViewModel.FactorWeightedAverageType(true);
                                document.getElementById("WghtdAvgFactor").checked = true;
                            }
                            for (k = 0; k < HmViewModel.editableResponseTypesForFactor.length; k++) {

                                //var responseType = HmViewModel.editableResponseTypes().length + 1;
                                HmViewModel.editableResponseTypes.push(new QuantitativeResponseColumnsModel({
                                    ResponseId: HmViewModel.editableResponseTypesForFactor[k].ResponseId(),
                                    ResponseType: HmViewModel.editableResponseTypesForFactor[k].ResponseType(),
                                    description: HmViewModel.editableResponseTypesForFactor[k].description(),
                                    calculationapplicability: HmViewModel.editableResponseTypesForFactor[k].calculationapplicability(),
                                    currencyapplicability: HmViewModel.editableResponseTypesForFactor[k].currencyapplicability(),
                                    weightings: HmViewModel.editableResponseTypesForFactor[k].weightings(),
                                    response: HmViewModel.editableResponseTypesForFactor[k].response(),
                                    SimpleAverageflag: HmViewModel.editableResponseTypesForFactor[k].SimpleAverageflag(),
                                    isGlobalFlag: HmViewModel.editableResponseTypesForFactor[k].isGlobalFlag(),
                                    AssessmentType: "SANC",
                                    AssessmentTypeId: HmViewModel.editableResponseTypesForFactor[k].AssessmentTypeId()
                                }));
                            }


                        }
                    }
                }
                else
                    logger.logError('An error occurred. Please contact your Administrator.', 'Error', system.getModuleId(HmViewModel), true);
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetAllResponseColumnDetails() method in RiskArea&Factor.js';
                logger.logMessage(msg);
            }
        };

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage(((!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name), "", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllResponseColumnDetails() method in RiskArea&Factor.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllResponseColumnDetails() method in RiskArea&Factor.js';
                logger.logMessage(msg);
            }
        };
    }

    //this calls on click over reorder in subfactor
    function OpenRiskSubFactorOrderPopup() {
        try {
            HmViewModel.popUpTitle("Re-Order");
            HmViewModel.addPopUpCss(true);
            $('#frmRiskSubFactorReordermodel').modal('show');
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: OpenRiskSubFactorOrderPopup() method in RiskAreas&Factors.js';
            logger.logMessage(msg);
        }
    }
    //this calls when you click over reorder in factor
    function OpenRiskFactorOrderPopup() {
        try {
            $('#valfactorerror').hide();
            $('#RiskFactorReorderTableDiv').show();
            $('#RiskFactorReorderTable').show();
            $('#SaveFactorSortButton').show();
            HmViewModel.popUpTitle("Re-Order");
            HmViewModel.addPopUpCss(true);
            $('#frmRiskFactorReordermodel').modal('show');
            if (HmViewModel.RiskFactorReorderList().length == 0) {
                $('#valfactorerror').show();
                $('#RiskFactorReorderTableDiv').hide();
                $('#RiskFactorReorderTable').hide();
                $('#SaveFactorSortButton').hide();
                document.getElementById('valfactorerror').innerHTML = "No data is available.";
            }
            $('#modalContent').css({
                'margin-top': '25%'
            });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: OpenRiskAreaPopup() method in RiskAreaAndFactors.js';
            logger.logMessage(msg);
        }
    }


    // for adding a new risk area tab

    function RiskArea(item) {
        try {
            var self = this;
            self.RiskAreaName = $('#riskareaname' + item).val();
            self.RiskAreaNotes = $('#EditRaTextArea' + item).val();
            self.LanguageType = item;
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RiskArea() method in RiskAreaAndFactors.js';
            logger.logMessage(msg);
        }
    };

    function addRiskArea(data) {
        try {

            var selectedassessmetId = "";
            var selectedItem = "";
            var riskAreaObj = "";
            var MappedZATRATList = [];
            HmViewModel.SelectedZATRATList([]);
            HmViewModel.SelectedZATDropDownList().push(HmViewModel.InherentSetupQuantObj().SurveyCategoryId());
            for (var i = 0; i < HmViewModel.SelectedAssessmentType().length; i++) {
                if (i == 0)
                    selectedassessmetId += selectedassessmetId + HmViewModel.SelectedAssessmentType()[i];
                else
                    selectedassessmetId += "|" + HmViewModel.SelectedAssessmentType()[i];
            }
            for (var i = 0; i < HmViewModel.SelectedLanguageType().length; i++) {
                if (i == 0)
                    selectedLanguages = HmViewModel.SelectedLanguageType()[i];
                else
                    selectedLanguages += "|" + HmViewModel.SelectedLanguageType()[i];
            }
            for (var h = 0; h < HmViewModel.SelectedZATDropDownList().length; h++) {
                for (var j = 0; j < HmViewModel.SelectedAssessmentType().length; j++) {
                    for (var k = 0; k < HmViewModel.ZATRATList().length; k++) {
                        if (HmViewModel.ZATRATList()[k].ZAT_UID() == HmViewModel.SelectedZATDropDownList()[h] &&
                            HmViewModel.ZATRATList()[k].RAT_UID() == HmViewModel.SelectedAssessmentType()[j]) {
                            MappedZATRATList.push(new ZATRATModel(HmViewModel.SelectedZATDropDownList()[h], null, HmViewModel.SelectedAssessmentType()[j]));
                        }
                    }
                }
            }
            HmViewModel.SelectedZATRATList(MappedZATRATList);
            $('#valErrorRA').hide();
            for (var j = 0; j < HmViewModel.SelectedLanguageType().length; j++) {
                for (var i = 0; i < HmViewModel.ObjGeneralSettings.LanguageList().length; i++) {
                    if (parseInt(HmViewModel.SelectedLanguageType()[j]) == HmViewModel.ObjGeneralSettings.LanguageList()[i].LANGUAGE_ID._latestValue) {
                        selectedItem = HmViewModel.SelectedLanguageType()[j];
                        riskAreaObj = new RiskArea(selectedItem);
                        //validate language text boxes
                        if (riskAreaObj.RiskAreaName == "") {
                            $('#valErrorRA').show();
                            $('#valErrorRA').text('Risk Area name in ' + HmViewModel.ObjGeneralSettings.LanguageList()[i].LANGUAGENAME() + ' is required.');
                            return;
                        } else {
                            $('#valErrorRA').text('');
                        }

                        HmViewModel.RiskAreaSubList.push(riskAreaObj);
                    }
                }
            }
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            AddRiskAreaAjax = {
                url: "/api/Configuration/AddRiskArea",
                type: "POST",
                data: {
                    RiskAreaId: data.RiskAreaId(), RiskAreaName: data.RiskAreaName(), RiskAreaType: selectedassessmetId,
                    RiskAreaNotes: data.RiskAreaNotes(), IsQualitative: "0", RiskAreaSubList: HmViewModel.RiskAreaSubList(),
                    ZATRATModelObj: HmViewModel.SelectedZATRATList()
                },
                headers: headers,
                async: false
            };
            $.ajax(AddRiskAreaAjax)
                .success(ajaxSuccess)
                .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in addRiskArea() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult != null) {
                    if (jsonResult.Incident_Description != null && jsonResult.Incident_Description.substring(0, 3) == "INC") {
                        logger.logError(jsonResult.Incident_Description + ' - An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(HmViewModel), true);
                    }
                    else if (jsonResult.Flag == 1) {
                        logger.logSuccess(
                            //'Risk Area added successfully.'
                            ((!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('RiskAreaAddSuccess') == -1) ? 'Risk Area added successfully.' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('RiskAreaAddSuccess')].Name())
                            , 'Success', system.getModuleId(HmViewModel), true);
                        HmViewModel.AddAreaFlag(true);
                        GetAllRiskAreas();
                    }
                    else {
                        logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(HmViewModel), true);
                    }
                }
                else if (jsonResult.Flag == 0) {

                    let RiskAreaAlreadyExists = (!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('RiskAreaAlreadyExists') == -1) ? 'already exists. Please enter a different Risk Area.' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('RiskAreaAlreadyExists')].Name();
                    logger.logError(data.RiskAreaName() + " " + RiskAreaAlreadyExists, 'Error', system.getModuleId(HmViewModel), true);

                }
                else {
                    logger.logError(
                        //'Failed to Add Risk Area.'
                        ((!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('RiskAreaAddFail') == -1) ? 'Failed to Add Risk Area.' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('RiskAreaAddFail')].Name())
                        , 'Error', system.getModuleId(HmViewModel), true);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in addRiskArea() method in RiskArea&Factor.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage(((!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name), (!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage') == -1) ? 'Error in Edit Operation' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage')].Name, ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in addRiskArea() method in RiskArea&Factor.js';
                    logger.logMessage(msg);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in addRiskArea() method in RiskAreaAndFactors.js';
                logger.logMessage(msg);
            }
        }

    }

    function addNewDivTab(data) {
        try {
            $('#adddivtabdiv ul').append(
                '<li id="' + data.RiskAreaId() + '"><a id="' + data.RiskAreaId() + '" href="#adddivtabbody">' + data.RiskAreaName() + '</a></li>'
            );
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: addNewDivTab() method in RiskAreaAndFactors.js';
            logger.logMessage(msg);
        }
    }

    function TabClick(event) {
        try {
            HmViewModel.SelectedLanguageSubFactorType([]);
            HmViewModel.SubFactorRiskAreaList([]);
            $("#adddivtabbody").show();
            var ClickedRiskAreaId = event.currentTarget.firstChild.attributes['id'].value;
            HmViewModel.CurrentRiskAreaId('');
            HmViewModel.CurrentRiskAreaId(ClickedRiskAreaId);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: TabClick() method in RiskAreaAndFactors.js';
            logger.logMessage(msg);
        }
    }

    //function riskSubFactorsortordercancel
    function CancelRiskSubFactorSortOrder() {
        try {
            HmViewModel.RiskSubFactorReorderList([]);
            var MappedFactorSortMOdelDup = $.map(HmViewModel.RiskSubFactorReorderListDup(), function (result) {
                return new RiskSubFactorSortModelDup(result);
            });
            HmViewModel.RiskSubFactorReorderList(MappedFactorSortMOdelDup);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: CancelRiskSubFactorSortOrder() method in RiskAreaAndFactors.js';
            logger.logMessage(msg);
        }
    }
    //function riskfactorsortordercancel
    function CancelRiskFactorSortOrder() {
        try {
            HmViewModel.RiskFactorReorderList([]);
            var MappedFactorSortMOdelDup = $.map(HmViewModel.RiskFactorReorderListDup(), function (result) {
                return new RiskFactorSortOrderDupModel(result);
            });
            HmViewModel.RiskFactorReorderList(MappedFactorSortMOdelDup)
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: CancelRiskFactorSortOrder() method in RiskAreaAndFactors.js';
            logger.logMessage(msg);
        }
    }
    //riskareasortordercancel
    function CancelRiskAreaSortOrder() {
        try {
            var MappedControlAreaSortMOdelDup = $.map(HmViewModel.RiskAreaReorderListDup(), function (result) {
                return new RiskAreaSortOrderDupModel(result);
            });
            HmViewModel.RiskAreaReorderList([]);
            HmViewModel.RiskAreaReorderList(MappedControlAreaSortMOdelDup);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: CancelRiskAreaSortOrder() method in RiskAreaAndFactors.js';
            logger.logMessage(msg);
        }
    }
    //riskfactorsortordersave
    function SaveRiskFactorSortOrder() {
        try {
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            $.ajax({
                url: "/api/Configuration/RiskFactorSortOrder",
                headers: headers,
                type: "POST",
                contentType: 'application/json',
                dataType: 'json',
                data: JSON.stringify($.map(HmViewModel.RiskFactorReorderList(), function (item) {
                    return { RiskFactorId: item.RiskFactorId(), SortOrder: item.SortOrder() };
                }))
            })
                .success(ajaxSuccessOverall)
                .fail(ajaxFailOverall);

            function ajaxSuccessOverall(jsonResult, status) {
                try {
                    if (jsonResult != null) {
                        if (jsonResult != "1") {
                            if (isNaN(jsonResult) && jsonResult.substring(0, 3) == "INC") {
                                logger.logError(jsonResult + ' - An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(HmViewModel), true);
                            }
                            else {
                                $('#frmRiskFactorReordermodel').modal('hide');
                                $('body').removeClass('modal-open');
                                $('.modal-backdrop').remove();
                                GetRiskFactors(HmViewModel.CurrentRiskAreaId());
                                logger.logSuccess(
                                    //'Sort Order saved successfully'
                                    ((!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SortOrderSaved') == -1) ? 'Sort Order saved successfully' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SortOrderSaved')].Name())
                                    , 'Success', system.getModuleId(HmViewModel), true);
                            }
                        }
                        else {
                            logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(HmViewModel), true);
                        }
                    }
                    else {
                        logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(HmViewModel), true);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess() method in savesortorder() method in Businessunit.js';
                    logger.logMessage(msg);
                }
            }
            function ajaxFailOverall(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage(((!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name), "Error in edit operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in savesortorder() method in AMLInherentWeightings.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail() method in savesorterorder() method in AMLInherentWeightings.js';
                    logger.logMessage(msg);
                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SaveSortOrder() method in BusinessUnit.js';
            logger.logMessage(msg);
        }
    }

    //risksubfactorsortordersave
    function SaveRiskSubFactorSortOrder() {
        try {
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            $.ajax({
                url: "/api/Configuration/RiskSubFactorSortOrder",
                headers: headers,
                type: "POST",
                contentType: 'application/json',
                dataType: 'json',
                data: JSON.stringify($.map(HmViewModel.RiskSubFactorReorderList(), function (item) {
                    return { RiskSubFactorId: item.RiskSubfactorId(), SortOrder: item.SortOrder() };
                }))
            })
                .success(ajaxSuccessOverall)
                .fail(ajaxFailOverall);

            function ajaxSuccessOverall(jsonResult, status) {
                try {
                    if (jsonResult != null) {
                        if (jsonResult != "1") {
                            if (isNaN(jsonResult) && jsonResult.substring(0, 3) == "INC") {
                                logger.logError(jsonResult + ' - An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(HmViewModel), true);
                            }
                            else {
                                $('#frmRiskSubFactorReordermodel').modal('hide');
                                $('body').removeClass('modal-open');
                                $('.modal-backdrop').remove();
                                GetAllRiskSubFactors(GetAllRiskSubFactorsAjax);
                                logger.logSuccess(
                                    //'Sort Order saved successfully.'
                                    ((!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SortOrderSaved') == -1) ? 'Sort Order saved successfully' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SortOrderSaved')].Name())
                                    , 'Success', system.getModuleId(HmViewModel), true);
                            }
                        }
                        else {
                            logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(HmViewModel), true);
                        }
                    }
                    else {
                        logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(HmViewModel), true);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess() method in savesortorder() method in Businessunit.js';
                    logger.logMessage(msg);
                }
            }
            function ajaxFailOverall(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage(((!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name), (!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage') == -1) ? 'Error in Edit Operation' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage')].Name, ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in savesortorder() method in AMLInherentWeightings.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail() method in savesorterorder() method in AMLInherentWeightings.js';
                    logger.logMessage(msg);
                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SaveRiskSubFactorOrder() method in RiskAreaAndFactors.js';
            logger.logMessage(msg);
        }
    }
    //riskareasortordersave
    function SaveRiskAreaSortOrder() {

        try {
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            $.ajax({
                url: "/api/Configuration/RiskAreaSortOrder?SurveyCategoryId=" + HmViewModel.InherentSetupQuantObj().SurveyCategoryId(),
                headers: headers,
                type: "POST",
                contentType: 'application/json',
                dataType: 'json',
                data: JSON.stringify($.map(HmViewModel.RiskAreaReorderList(), function (item) {
                    return { RiskAreaId: item.RiskAreaId(), SortOrder: item.SortOrder() };
                }))
            })
                .success(ajaxSuccessOverall)
                .fail(ajaxFailOverall);

            function ajaxSuccessOverall(jsonResult, status) {
                try {
                    if (jsonResult != null) {
                        if (jsonResult != "1") {
                            if (isNaN(jsonResult) && jsonResult.substring(0, 3) == "INC") {
                                logger.logError(jsonResult + ' - An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(HmViewModel), true);
                            }
                            else {
                                $('#frmRiskAreaReordermodel').modal('hide');
                                $('body').removeClass('modal-open');
                                $('.modal-backdrop').remove();
                                logger.logSuccess(
                                    //'Sort Order saved successfully.'
                                    ((!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SortOrderSaved') == -1) ? 'Sort Order saved successfully' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SortOrderSaved')].Name())
                                    , 'Success', system.getModuleId(HmViewModel), true);
                                GetAllRiskAreas();
                            }
                        }
                        else {
                            logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(HmViewModel), true);
                        }
                    }
                    else {
                        logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(HmViewModel), true);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess() method in savesortorder() method in Businessunit.js';
                    logger.logMessage(msg);
                }
            }
            function ajaxFailOverall(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage(((!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name), (!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage') == -1) ? 'Error in Edit Operation' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage')].Name, ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in savesortorder() method in AMLInherentWeightings.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail() method in savesorterorder() method in AMLInherentWeightings.js';
                    logger.logMessage(msg);
                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SaveSortOrder() method in BusinessUnit.js';
            logger.logMessage(msg);
        }

    }
    function GetAllRiskAreas() {
        try {
            $.ajax(GetAllRiskAreaAjax)
                .success(ajaxSuccess)
                .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in GetAllRiskAreas() method in RiskAreaAndFactors.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(jsonResult, status) {
            try {
                $('#loadingMainImgDiv').hide();
                $('#error').hide();
                if (jsonResult != null && jsonResult[0].Flag == 0) {
                    $('#loadingMainImgDiv').hide();
                    $('#error').show();
                    logger.logError(
                        //'No Risk Areas have been configured.'
                        ((!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('NoRiskAreasConfigured') == -1) ? 'No Risk Areas have been configured.' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('NoRiskAreasConfigured')].Name())
                        , 'Error', system.getModuleId(HmViewModel), true);
                }
                else if (jsonResult != null && jsonResult[0].RiskAreaId != null) {
                    var currentTabId = "";
                    if ($("#adddivtabdiv").tabs("option", "active") == false) {
                        currentTabId = 0;
                    }
                    else {
                        currentTabId = $("#adddivtabdiv").tabs("option", "active");
                    }
                    $('#adddivtab').empty();
                    HmViewModel.RiskAreaList([]);
                    HmViewModel.RiskAreaReorderListDup([]);
                    HmViewModel.RiskAreaReorderList([]);
                    HmViewModel.RiskAreaSortOrder(0);
                    HmViewModel.RiskAreaSubList([]);


                    var mappedRiskAreaList = $.map(jsonResult, function (result) {
                        var RiskAreaModelObj = new RiskAreaModel(result);
                        addNewDivTab(RiskAreaModelObj);
                        return RiskAreaModelObj;
                    });
                    var mappedRiskAreaReOrderList = $.map(jsonResult, function (result) {
                        var RiskAreaModelObj = new RiskAreaReorderModel(result);
                        return RiskAreaModelObj;
                    });
                    HmViewModel.RiskAreaSortOrder(0);
                    var mappedDupRiskAreaReOrderList = $.map(jsonResult, function (result) {
                        var RiskAreaModelObj = new RiskAreaReorderModel(result);
                        return RiskAreaModelObj;
                    });
                    HmViewModel.RiskAreaReorderListDup(mappedDupRiskAreaReOrderList);
                    HmViewModel.RiskAreaReorderList(mappedRiskAreaReOrderList);

                    HmViewModel.RiskAreaList(mappedRiskAreaList);
                    if (currentTabId >= $('#adddivtab >li').length || HmViewModel.AddAreaFlag() == true)
                        currentTabId = parseInt($('#adddivtab >li').length) - 1;
                    $('#loadingMainImgDiv').hide();

                    $("#adddivtabdiv").tabs();
                    $('#adddivtabdiv').tabs('refresh');
                    $('#adddivtabdiv').tabs({ active: currentTabId });
                    $($('#adddivtabdiv li').get(currentTabId)).trigger('click');
                    scrollableTabs();
                }
                else if (jsonResult[0].RiskAreaId == 0 && jsonResult[0].RiskAreaName == null) {
                    $('#loadingMainImgDiv').hide();
                    $('#error').show();
                    $('#adddivtab').empty();
                    $('#adddivtabbody').empty();
                    HmViewModel.RiskAreaList([]);
                    HmViewModel.RiskAreaReorderListDup([]);
                    HmViewModel.RiskAreaReorderList([]);
                    HmViewModel.RiskAreaSortOrder(0);
                }
                HmViewModel.AddAreaFlag(false);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetAllRiskAreas() method in RiskAreaAndFactors.js';
                logger.logMessage(msg);
            }
        };

        function ajaxFail(error, status) {

            try {
                if (error.status == 401) {
                    app.showMessage(((!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name), (!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage') == -1) ? 'Error in Edit Operation' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage')].Name, ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllRiskAreas() method in RiskAreaAndFactors.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllRiskAreas() method in RiskAreaAndFactors.js';
                logger.logMessage(msg);
            }
        };
    }

    function GetRiskFactors(RiskAreaId) {
        try {
            GetAllRiskFactorAjax = {
                url: "/api/Configuration/GetAllRiskfactorAreaWise",
                type: "GET",
                headers: appsecurity.getSecurityHeaders(),
                async: false,
                data: {
                    "RiskAreaId": RiskAreaId, "SurveyCategoryID": HmViewModel.InherentSetupQuantObj().SurveyCategoryId(),
                    "AssessmentTypes": HmViewModel.InherentSetupQuantObj().AssessmentTypeId(), "ScreenType": null
                }
            };
            GetAllRiskFactor(GetAllRiskFactorAjax);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: GetRiskFactors() method in RiskAreaAndFactors.js';
            logger.logMessage(msg);
        }
    }

    function GetAllRiskFactor(GetAllRiskFactorAjax) {
        try {
            $.ajax(GetAllRiskFactorAjax)
                .success(ajaxSuccess)
                .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source:ajax call in GetAllRiskFactor() method in RiskAreaAndFactors.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult != 'undefined' && jsonResult != null) {
                    if (jsonResult.length != 0) {
                        HmViewModel.SelectedLanguageFactorType([]),
                            HmViewModel.FactorRiskAreaList = {};
                        var mappedRiskFactors = $.map(jsonResult, function (result) {
                            return new RiskFactorModel(result);
                        });
                        HmViewModel.RiskFactorReorderList([]);
                        HmViewModel.RiskFactorReorderListDup([]);
                        HmViewModel.RiskFactorSortOrder(0);
                        var mappedRiskFactorssortOrder = $.map(jsonResult, function (result) {
                            var RiskAreaModelObj = new RiskFactorSortModel(result);
                            return RiskAreaModelObj;
                        });
                        HmViewModel.RiskFactorSortOrder(0);
                        var mappedRiskFactorsSortOrderDup = $.map(jsonResult, function (result) {
                            var RiskAreaModelObjDup = new RiskFactorSortModel(result);
                            return RiskAreaModelObjDup;
                        });
                        HmViewModel.RiskFactorReorderList(mappedRiskFactorssortOrder);
                        HmViewModel.RiskFactorReorderListDup(mappedRiskFactorsSortOrderDup);

                        tableObj = $('#tblRiskFactor').DataTable();
                        tableObj.destroy();
                        $("#tblRiskFactor tbody tr").remove();
                        HmViewModel.RiskFactorList(mappedRiskFactors);
                        ko.applyBindingsToNode($('#tblRiskFactor tbody .details-control'), { click: HmViewModel.trclick }, HmViewModel);
                        RfTableObj = $('#tblRiskFactor').DataTable({
                            responsive: true,
                            stateSave: true,
                            "aoColumnDefs": [{
                                "aTargets": [0],
                                "bVisible": true,
                                "className": "details-control"

                            }, {
                                "aTargets": [1],
                                "bVisible": false,
                                "orderable": false,
                                "className": "d-none"

                            }, {
                                "aTargets": [2],
                                "bVisible": true
                            },
                            {
                                "aTargets": [3],
                                "orderable": true
                            },

                            {
                                "aTargets": [4],
                                "orderable": false,
                                "className": "text-center",
                                "bVisible": HmViewModel.ControlsAccess()
                            }]
                        });
                        $('#tblRiskFactor').DataTable().draw(false);
                    }
                    else {
                        HmViewModel.RiskFactorList([]);
                        HmViewModel.RiskFactorReorderList([]);
                        HmViewModel.RiskFactorReorderListDup([]);
                        HmViewModel.RiskFactorSortOrder(0);
                        tableObj = $('#tblRiskFactor').DataTable();
                        tableObj.destroy();
                        $('#tblRiskFactor tbody tr').remove();
                        RfTableObj = $('#tblRiskFactor').DataTable({
                            responsive: true,
                            stateSave: true,
                            "aoColumnDefs": [{
                                "aTargets": [0],
                                "bVisible": true,
                                "className": "details-control"

                            }, {
                                "aTargets": [1],
                                "bVisible": false,
                                "orderable": false,
                                "className": "d-none"

                            }, {
                                "aTargets": [2],
                                "bVisible": true
                            },
                            {
                                "aTargets": [3],
                                "orderable": true
                            },

                            {
                                "aTargets": [4],
                                "orderable": false,
                                "className": "text-center",
                                "bVisible": HmViewModel.ControlsAccess()
                            }]
                        });
                        $('#tblRiskFactor').DataTable().draw(false);
                    }
                    $('#loadingMainImgDivFactors').hide();
                }
                else {
                    HmViewModel.RiskFactorList([]);
                    HmViewModel.RiskFactorReorderList([]);
                    HmViewModel.RiskFactorReorderListDup([]);
                    HmViewModel.RiskFactorSortOrder(0);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source:ajaxSuccess in GetAllRiskFactor() method in RiskAreaAndFactors.js';
                logger.logMessage(msg);
                $('#loadingMainImgDivFactors').hide();
            }
        }

        function ajaxFail(error, status) {
            try {
                $('#loadingMainImgDiv').hide();
                if (error.status == 401) {
                    app.showMessage(((!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name), (!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage') == -1) ? 'Error in Edit Operation' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage')].Name, ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllRiskFactor() method in RiskAreaAndFactors.js';
                    logger.logMessage(msg);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllRiskFactor() method in RiskAreaAndFactors.js';
                logger.logMessage(msg);
                $('#loadingMainImgDivFactors').hide();
            }
        }
    }
    //this gets triggered on click of up arrow in risk subfactor re order popup
    function UpFunctionalityRiskSubFactor(data, event) {
        try {
            $('#valErrorSubbbbFactor').hide();
            for (var i = 0; i < HmViewModel.RiskSubFactorReorderList().length; i++) {

                if (data.RiskSubfactorId() == HmViewModel.RiskSubFactorReorderList()[i].RiskSubfactorId()) {
                    if (i == 0) {
                        $('#valErrorSubbbbFactor').show();
                        document.getElementById('valErrorSubbbbFactor').innerHTML = "This cannot go further UP";
                    }
                    else {
                        var x = HmViewModel.RiskSubFactorReorderList()[i].RiskSubfactorId();
                        var y = HmViewModel.RiskSubFactorReorderList()[i].RiskSubfactorName();

                        HmViewModel.RiskSubFactorReorderList()[i].RiskSubfactorId(HmViewModel.RiskSubFactorReorderList()[i - 1].RiskSubfactorId());
                        HmViewModel.RiskSubFactorReorderList()[i].RiskSubfactorName(HmViewModel.RiskSubFactorReorderList()[i - 1].RiskSubfactorName());

                        HmViewModel.RiskSubFactorReorderList()[i - 1].RiskSubfactorId(x);
                        HmViewModel.RiskSubFactorReorderList()[i - 1].RiskSubfactorName(y);
                        break;
                    }
                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: UpFunctionalityRiskSubFactor() method in RiskAreaAndFactors.js';
            logger.logMessage(msg);
        }
    }
    //this gets triggered on click of up arrow in risk factor reorder popup
    function UpFunctionalityRiskFactor(data, event) {
        try {
            $('#valfactorerror').hide();
            for (var i = 0; i < HmViewModel.RiskFactorReorderList().length; i++) {

                if (data.RiskFactorId() == HmViewModel.RiskFactorReorderList()[i].RiskFactorId()) {
                    if (i == 0) {
                        $('#valfactorerror').show();
                        document.getElementById('valfactorerror').innerHTML = "This cannot go further UP";
                    }
                    else {
                        var x = HmViewModel.RiskFactorReorderList()[i].RiskFactorId();
                        var y = HmViewModel.RiskFactorReorderList()[i].RiskFactorNameClean();

                        HmViewModel.RiskFactorReorderList()[i].RiskFactorId(HmViewModel.RiskFactorReorderList()[i - 1].RiskFactorId());
                        HmViewModel.RiskFactorReorderList()[i].RiskFactorNameClean(HmViewModel.RiskFactorReorderList()[i - 1].RiskFactorNameClean());

                        HmViewModel.RiskFactorReorderList()[i - 1].RiskFactorId(x);
                        HmViewModel.RiskFactorReorderList()[i - 1].RiskFactorNameClean(y);
                        break;
                    }
                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllRiskFactor() method in RiskAreaAndFactors.js';
            logger.logMessage(msg);
        }
    }
    //this gets triggered on click of up arrow in riskarea reorder pop up
    function UpFunctionalityRiskArea(data, event) {
        try {
            $('#valError').hide();
            for (var i = 0; i < HmViewModel.RiskAreaReorderList().length; i++) {

                if (data.RiskAreaId() == HmViewModel.RiskAreaReorderList()[i].RiskAreaId()) {
                    if (i == 0) {
                        $('#valError').show();
                        document.getElementById('valError').innerHTML = "This cannot go further UP";
                    }
                    else {
                        var x = HmViewModel.RiskAreaReorderList()[i].RiskAreaId();
                        var y = HmViewModel.RiskAreaReorderList()[i].RiskAreaName();

                        HmViewModel.RiskAreaReorderList()[i].RiskAreaId(HmViewModel.RiskAreaReorderList()[i - 1].RiskAreaId());
                        HmViewModel.RiskAreaReorderList()[i].RiskAreaName(HmViewModel.RiskAreaReorderList()[i - 1].RiskAreaName());

                        HmViewModel.RiskAreaReorderList()[i - 1].RiskAreaId(x);
                        HmViewModel.RiskAreaReorderList()[i - 1].RiskAreaName(y);
                        break;
                    }
                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajaxFail in UpFunctionalityRiskArea() method in RiskAreaAndFactors.js';
            logger.logMessage(msg);
        }
    }

    function InputChangedArea(data, event) {
        try {
            $('#valError').hide();
            if (!isNaN(data.SortOrder()) && data.SortOrder() <= HmViewModel.RiskAreaReorderList().length && data.SortOrder() > 0) {


                var riskareacount = HmViewModel.RiskAreaReorderList().length - 1;
                HmViewModel.RiskAreaReorderList.remove(function (item) { return item.RiskAreaId() == data.RiskAreaId() })
                HmViewModel.RiskAreaSortOrder(0);
                var count = data.SortOrder() - 1;
                var counter = 1;
                var MappedRiskAreaModel1 = $.map(HmViewModel.RiskAreaReorderList(), function (result) {
                    if (counter <= count) {
                        counter++;
                        return new RiskAreaReorderModel(result);
                    }

                });
                var ChangedModel = new RiskAreaReorderModel({ SortOrder: data.SortOrder(), RiskAreaName: data.RiskAreaName(), RiskAreaId: data.RiskAreaId() })
                var Model = [];
                if (MappedRiskAreaModel1.length > 0) {
                    for (var i = 0; i < MappedRiskAreaModel1.length; i++) {
                        var NewModel = new RiskAreaReorderModelSortOrder({
                            SortOrder: MappedRiskAreaModel1[i].SortOrder(), RiskAreaName: MappedRiskAreaModel1[i].RiskAreaName(), RiskAreaId: MappedRiskAreaModel1[i].RiskAreaId()
                        });
                        Model.push(NewModel);
                    }
                }
                Model.push(ChangedModel);
                var count = Model.length;
                for (var k = count; k < riskareacount + 1; k++) {
                    var ChangedModel = new RiskAreaReorderModel({
                        SortOrder: HmViewModel.RiskAreaReorderList()[k - 1].SortOrder(), RiskAreaName: HmViewModel.RiskAreaReorderList()[k - 1].RiskAreaName(), RiskAreaId: HmViewModel.RiskAreaReorderList()[k - 1].RiskAreaId()
                    })
                    Model.push(ChangedModel);
                }
                HmViewModel.RiskAreaReorderList([]);
                HmViewModel.RiskAreaReorderList(Model);
            }
            else {
                $('#valError').show();
                $('#valError').html(
                    //"Please enter a valid number"
                    ((!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EnterValidNumber') == -1) ? 'Please enter a valid number' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EnterValidNumber')].Name())
                )
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: InputChangedArea() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    }


    function InputChangedFactor(data, event) {
        try {
            $('#valfactorerror').hide();
            if (!isNaN(data.SortOrder()) && data.SortOrder() <= HmViewModel.RiskFactorReorderList().length && data.SortOrder() > 0) {
                var riskFactorCount = HmViewModel.RiskFactorReorderList().length - 1;
                HmViewModel.RiskFactorReorderList.remove(function (item) { return item.RiskFactorId() == data.RiskFactorId() })
                HmViewModel.RiskFactorSortOrder(0);
                var count = data.SortOrder() - 1;
                var counter = 1;
                var MappedRiskFactorModel1 = $.map(HmViewModel.RiskFactorReorderList(), function (result) {
                    if (counter <= count) {
                        counter++;
                        return new RiskFactorSortModel(result);
                    }

                });

                var ChangedModel = new RiskFactorSortModel({ SortOrder: data.SortOrder(), RiskFactorNameClean: data.RiskFactorNameClean(), RiskAreaId: data.RiskAreaId(), RiskFactorId: data.RiskFactorId() })
                var Model = [];
                if (MappedRiskFactorModel1.length > 0) {
                    for (var i = 0; i < MappedRiskFactorModel1.length; i++) {
                        var NewModel = new RiskFactorReorderModelSortOrder({
                            SortOrder: MappedRiskFactorModel1[i].SortOrder(), RiskAreaId: MappedRiskFactorModel1[i].RiskAreaId(), RiskFactorNameClean: MappedRiskFactorModel1[i].RiskFactorNameClean(), RiskFactorId: MappedRiskFactorModel1[i].RiskFactorId()
                        });
                        Model.push(NewModel);
                    }
                }
                Model.push(ChangedModel);
                var count = Model.length;
                for (var k = count; k < riskFactorCount + 1; k++) {
                    var ChangedModel = new RiskFactorSortModel({
                        SortOrder: HmViewModel.RiskFactorReorderList()[k - 1].SortOrder(), RiskFactorNameClean: HmViewModel.RiskFactorReorderList()[k - 1].RiskFactorNameClean(), RiskFactorId: HmViewModel.RiskFactorReorderList()[k - 1].RiskFactorId(), RiskAreaId: HmViewModel.RiskFactorReorderList()[k - 1].RiskAreaId()
                    })
                    Model.push(ChangedModel);
                }
                HmViewModel.RiskFactorReorderList([]);
                HmViewModel.RiskFactorReorderList(Model);
            }
            else {
                $('#valfactorerror').show();
                $('#valfactorerror').html(
                    //"Please enter a valid number"
                    ((!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EnterValidNumber') == -1) ? 'Please enter a valid number' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EnterValidNumber')].Name())
                )
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: InputChangedFactor() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    }

    function InputChangedSubFactor(data, event) {
        try {
            $('#valErrorSubbbbFactor').hide();
            if (!isNaN(data.SortOrder()) && data.SortOrder() <= HmViewModel.RiskSubFactorReorderList().length && data.SortOrder() > 0) {
                var riskSubFactorCount = HmViewModel.RiskSubFactorReorderList().length - 1;
                HmViewModel.RiskSubFactorReorderList.remove(function (item) { return item.RiskSubfactorId() == data.RiskSubfactorId() })
                HmViewModel.RiskSubFactorSortOrder(0);
                var count = data.SortOrder() - 1;
                var counter = 1;
                var MappedRiskFactorModel1 = $.map(HmViewModel.RiskSubFactorReorderList(), function (result) {
                    if (counter <= count) {
                        counter++;
                        return new RiskSubFactorSortModel(result);
                    }

                });

                var ChangedModel = new RiskSubFactorSortModel({ SortOrder: data.SortOrder(), RiskFactorId: data.RiskFactorId(), RiskSubfactorId: data.RiskSubfactorId(), RiskSubfactorName: data.RiskSubfactorName() })
                var Model = [];
                if (MappedRiskFactorModel1.length > 0) {
                    for (var i = 0; i < MappedRiskFactorModel1.length; i++) {
                        var NewModel = new RiskSubFactorReorderModelSortOrder({
                            SortOrder: MappedRiskFactorModel1[i].SortOrder(), RiskFactorId: MappedRiskFactorModel1[i].RiskFactorId(), RiskSubfactorName: MappedRiskFactorModel1[i].RiskSubfactorName(), RiskSubfactorId: MappedRiskFactorModel1[i].RiskSubfactorId()
                        });
                        Model.push(NewModel);
                    }
                }
                Model.push(ChangedModel);
                var count = Model.length;
                for (var k = count; k < riskSubFactorCount + 1; k++) {
                    var ChangedModel = new RiskSubFactorSortModel({
                        SortOrder: HmViewModel.RiskSubFactorReorderList()[k - 1].SortOrder(), RiskFactorId: HmViewModel.RiskSubFactorReorderList()[k - 1].RiskFactorId(), RiskSubfactorName: HmViewModel.RiskSubFactorReorderList()[k - 1].RiskSubfactorName(), RiskSubfactorId: HmViewModel.RiskSubFactorReorderList()[k - 1].RiskSubfactorId()
                    })
                    Model.push(ChangedModel);
                }
                HmViewModel.RiskSubFactorReorderList([]);
                HmViewModel.RiskSubFactorReorderList(Model);
            }
            else {
                $('#valErrorSubbbbFactor').show();
                $('#valErrorSubbbbFactor').html(
                    //"Please enter a valid number"
                    ((!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EnterValidNumber') == -1) ? 'Please enter a valid number' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EnterValidNumber')].Name())
                )
            }


        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: InputChangedSubFactor() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    }
    //this gets triggered on click of down arrow in riskarea reorder pop up
    function DownFunctionalityRiskArea(data, event) {
        try {
            $('#valError').hide();
            for (var i = 0; i < HmViewModel.RiskAreaReorderList().length; i++) {

                if (data.RiskAreaId() == HmViewModel.RiskAreaReorderList()[i].RiskAreaId()) {
                    if (i == HmViewModel.RiskAreaReorderList().length - 1) {
                        $('#valError').show();
                        document.getElementById('valError').innerHTML = "This cannot go further DOWN";
                    }
                    else {
                        var x = HmViewModel.RiskAreaReorderList()[i].RiskAreaId();
                        var y = HmViewModel.RiskAreaReorderList()[i].RiskAreaName();

                        HmViewModel.RiskAreaReorderList()[i].RiskAreaId(HmViewModel.RiskAreaReorderList()[i + 1].RiskAreaId());
                        HmViewModel.RiskAreaReorderList()[i].RiskAreaName(HmViewModel.RiskAreaReorderList()[i + 1].RiskAreaName());

                        HmViewModel.RiskAreaReorderList()[i + 1].RiskAreaId(x);
                        HmViewModel.RiskAreaReorderList()[i + 1].RiskAreaName(y);
                        break;
                    }
                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajaxFail in DownFunctionalityRiskArea() method in RiskAreaAndFactors.js';
            logger.logMessage(msg);
        }
    }
    //this gets triggered on click of down arrow in risksubfactor reorder pop up
    function DownFunctionalityRiskSubFactor(data, event) {
        try {
            $('#valErrorSubbbbFactor').hide();
            for (var i = 0; i < HmViewModel.RiskSubFactorReorderList().length; i++) {

                if (data.RiskSubfactorId() == HmViewModel.RiskSubFactorReorderList()[i].RiskSubfactorId()) {
                    if (i == HmViewModel.RiskSubFactorReorderList().length - 1) {
                        $('#valErrorSubbbbFactor').show();
                        document.getElementById('valErrorSubbbbFactor').innerHTML = "This cannot go further Down";
                    }
                    else {
                        var x = HmViewModel.RiskSubFactorReorderList()[i].RiskSubfactorId();
                        var y = HmViewModel.RiskSubFactorReorderList()[i].RiskSubfactorName();

                        HmViewModel.RiskSubFactorReorderList()[i].RiskSubfactorId(HmViewModel.RiskSubFactorReorderList()[i + 1].RiskSubfactorId());
                        HmViewModel.RiskSubFactorReorderList()[i].RiskSubfactorName(HmViewModel.RiskSubFactorReorderList()[i + 1].RiskSubfactorName());

                        HmViewModel.RiskSubFactorReorderList()[i + 1].RiskSubfactorId(x);
                        HmViewModel.RiskSubFactorReorderList()[i + 1].RiskSubfactorName(y);
                        break;
                    }
                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: DownFunctionalityRiskSubFactor() method in RiskAreaAndFactors.js';
            logger.logMessage(msg);
        }
    }
    //this gets triggered on click of down arrow in riskfactor reorder pop up
    function DownFunctionalityRiskFactor(data, event) {

        try {
            $('#valfactorerror').hide();
            for (var i = 0; i < HmViewModel.RiskFactorReorderList().length; i++) {

                if (data.RiskFactorId() == HmViewModel.RiskFactorReorderList()[i].RiskFactorId()) {
                    if (i == HmViewModel.RiskFactorReorderList().length - 1) {
                        $('#valfactorerror').show();
                        document.getElementById('valfactorerror').innerHTML = "This cannot go further Down";
                    }
                    else {
                        var x = HmViewModel.RiskFactorReorderList()[i].RiskFactorId();
                        var y = HmViewModel.RiskFactorReorderList()[i].RiskFactorNameClean();

                        HmViewModel.RiskFactorReorderList()[i].RiskFactorId(HmViewModel.RiskFactorReorderList()[i + 1].RiskFactorId());
                        HmViewModel.RiskFactorReorderList()[i].RiskFactorNameClean(HmViewModel.RiskFactorReorderList()[i + 1].RiskFactorNameClean());

                        HmViewModel.RiskFactorReorderList()[i + 1].RiskFactorId(x);
                        HmViewModel.RiskFactorReorderList()[i + 1].RiskFactorNameClean(y);
                        break;
                    }
                }
            }

        } catch (e) {
            var msg = 'Exception: ' + e + ' | Source: DownFunctionalityRiskFactor() method in RiskAreaAndFactors.js';
            logger.logMessage(msg);
        }
    }

    // Add Response Type
    function AddResponseType() {
        try {
            var responseType = HmViewModel.editableResponseTypes().length + 1;
            HmViewModel.editableResponseTypes.push(new QuantitativeResponseColumnsModel({
                ResponseId: 0,
                Rank: responseType,
                ResponseType: "RESPONSE" + responseType,
                description: "",
                calculationapplicability: true,
                currencyapplicability: false,
                weightings: 0,
                response: "",
                Weightedaverageflag: HmViewModel.WeightedAverageType(),
                isGlobalFlag: HmViewModel.isGlobalFlag(),
                SelectedComponentIRiskId: ko.observableArray([])
            }));
            var RiskId = document.getElementsByName("riskscaleoptions");
            $(RiskId).multiselect();
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: AddResponseType() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    }

    //Response type popup save button
    function SaveResponseType(data) {
        try {

            $('#rspError1').hide();
            $('#rspError2').hide();
            SaveQuanResponseDetails(data);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SaveResponseType() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    }

    //deleteResponseButton

    function deleteResponseButton(data) {
        try {
            app.showMessage(
                //'Are you sure you want to Delete this Response Level?'
                ((!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('DeleteResponseLevelConfirm') == -1) ? 'Are you sure you want to Delete this Response Level?' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('DeleteResponseLevelConfirm')].Name())
                + "<br/><br/><b>", 'Delete Request', [(!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ConfirmButton') == -1) ? 'Confirm' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ConfirmButton')].Name, (!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CancelButton') == -1) ? 'Cancel' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CancelButton')].Name], false, { popupIcon: 'title-icon col-md-1 fa fa-trash' })
                .then(function (option) {
                    var confirmText = ((!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ConfirmButton') == -1) ? 'Confirm' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ConfirmButton')].Name()).toString();
                    if (option == confirmText) {
                        deleteResponseItem(data);

                    }
                });
            setTimeout(function () {
                document.getElementById(event.target.id).focus();
            }, 1);
            event.preventDefault;
            event.stopImmediatePropagation;
            event.stopPropagation;
            return false;
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: deleteResponseButton() method in RiskAreasFactors.js';
            logger.logMessage(msg);
        }
    }

    //deleteResponseItem
    function deleteResponseItem(data) {
        try {

            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            deleteQuanResponseType = {
                url: "/api/Configuration/deleteQuanResponseItem",
                type: "POST",
                data: { RESPONSE_ID: data.ResponseId(), RESPONSE_DESCRIPTION: data.description() },
                headers: headers,
                async: false
            };
            $.ajax(deleteQuanResponseType)
                .success(ajaxSuccess)
                .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in deleteResponseItem() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult == "2") {
                    logger.logError(
                        //'The Response cannot be deleted as it is used in the Application.'
                        ((!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('DeleteResponseUsedInApplication') == -1) ? 'The Response cannot be deleted as it is used in the Application.' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('DeleteResponseUsedInApplication')].Name())
                        , 'Error', system.getModuleId(HmViewModel), true);

                }
                else if (jsonResult != null) {
                    if (isNaN(jsonResult) && jsonResult.substring(0, 3) == "INC") {
                        logger.logError(jsonResult + ' - An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(HmViewModel), true);
                    }
                    else
                        OpenConfigureResponseTypePopup();
                }
                else
                    logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(HmViewModel), true);
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in deleteResponseItem() method in RiskArea&Factor.js';
                logger.logMessage(msg);
            }
        };

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage(((!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name), "", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in deleteResponseItem() method in RiskArea&Factor.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in deleteResponseItem() method in RiskArea&Factor.js';
                logger.logMessage(msg);
            }

        }
    }

    function SaveQuanResponseDetails(data) {
        try {
            //var total = 0;
            for (i = 0; i < HmViewModel.editableResponseTypes().length; i++) {
                if (HmViewModel.editableResponseTypes()[i].response() === "") {
                    $('#rspError').show();
                    $('#rspError').text(
                        //'Response Type can not be empty'
                        ((!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ResponseTypeEmptyVal') == -1) ? 'Response Type can not be empty' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ResponseTypeEmptyVal')].Name())
                    );
                    return false;
                }
                if (!HmViewModel.editableResponseTypes()[i].SelectedComponentIRiskId() || HmViewModel.editableResponseTypes()[i].SelectedComponentIRiskId().length == 0) {
                    $('#rspError').show();
                    $('#rspError').text(
                        //'Risk Scales can not be empty'
                        ((!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('RiskScaleEmptyVal') == -1) ? 'Risk Scales can not be empty' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('RiskScaleEmptyVal')].Name())
                    );
                    return false;
                }
                //if (HmViewModel.editableResponseTypes()[i].weightings === null) {
                //    HmViewModel.editableResponseTypes()[i].weightings = 0;
                //}
                //total += parseFloat(HmViewModel.editableResponseTypes()[i].weightings);
            }
            //if (total != 100.00) {
            //    $('#rspError').show();
            //    $('#rspError').text('Response Weightage must sum upto complete 100%');
            //    return false;
            //}
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            $.ajax({
                url: "/api/Configuration/SaveQuanResponseDetails",
                headers: headers,
                type: "POST",
                contentType: 'application/json',
                dataType: 'json',
                data: JSON.stringify($.map(HmViewModel.editableResponseTypes(), function (item) {
                    HmViewModel.ScaleList([]);
                    for (var it = 0; it < item.SelectedComponentIRiskId().length; it++) {

                        HmViewModel.ScaleList.push({
                            ResponseId: item.ResponseId(),
                            Rank: item.Rank(),
                            ResponseType: item.ResponseType(),
                            description: item.description(),
                            calculationapplicability: item.calculationapplicability(),
                            OptionTypeShortName: item.OptionTypeShortName(),
                            weightings: item.weightings(),
                            response: item.response(),
                            Weightedaverageflag: HmViewModel.WeightedAverageType(),
                            SimpleAverageflag: HmViewModel.SimpleAverageType(),
                            isGlobalFlag: HmViewModel.isGlobalFlag(),
                            RiskScale: item.SelectedComponentIRiskId()[it]
                        });

                    }
                    return HmViewModel.ScaleList();

                }))
            })
                .success(ajaxSuccess)
                .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in SaveQuanResponseDetails() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult != null) {
                    if (jsonResult == "1") {
                        $('#frmResponseTypemodel').modal('hide');
                        $('#modalContent').css({
                            'margin-top': '25%'
                        });
                        $('#rspError').hide();
                        $('#rspError').text('');
                        logger.logSuccess(
                            //'Response types saved successfully.'
                            ((!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('Responsetypessaved') == -1) ? 'Response types saved successfully.' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('Responsetypessaved')].Name())
                            , 'Success', system.getModuleId(HmViewModel), true);
                    }
                    else if (isNaN(jsonResult) && jsonResult.substring(0, 3) == "INC") {
                        logger.logError(jsonResult + ' - An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(HmViewModel), true);
                    }
                    else {
                        logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(HmViewModel), true);
                    }
                }
                else
                    logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(HmViewModel), true);
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetAllResponseColumnDetails() method in RiskArea&Factor.js';
                logger.logMessage(msg);
            }
        };

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage(((!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name), "", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllResponseColumnDetails() method in RiskArea&Factor.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllResponseColumnDetails() method in RiskArea&Factor.js';
                logger.logMessage(msg);
            }

        }
    }


    //Response type validate method
    function ValidateResponses(data) {
        try {
            var error = 0;
            var wtSum = 0;
            for (var i = 0; i < HmViewModel.editableResponseType().length; i++) {
                if (HmViewModel.editableResponseType()[i].calculationapplicability() == 1) {
                    if (HmViewModel.editableResponseType()[i].response() == "") {
                        error++;
                    }
                    else if (HmViewModel.editableResponseType()[i].description() == "") {
                        error++;
                    }
                    if (HmViewModel.WeightedAverageType()) {
                        wtSum = wtSum + parseFloat(HmViewModel.editableResponseType()[i].weightings());
                    }
                }

            }
            if (HmViewModel.WeightedAverageType()) {
                if (wtSum != 100) {
                    $('#rspError').html(
                        //'The sum of the weightings should be 100.'
                        ((!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SumWeightings100Val') == -1) ? 'The sum of the weightings should be 100.' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SumWeightings100Val')].Name())
                    );
                    $('#rspError').show();
                    return false;
                }
                else {
                    $('#rspError').html('');
                    $('#rspError').hide();
                    return true;
                }
            }
            if (error > 0) {
                $('#rspError').html(
                    //'Please fill the required fields.'
                    ((!HmViewModel.LocaleCheckFlag() || HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('FillRequiredFields') == -1) ? 'Please fill the required fields.' : HmViewModel.ObjGeneralSettings.LocalizedTextList()[HmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('FillRequiredFields')].Name())
                );
                $('#rspError').show();
                return false;
            }
            else {
                $('#rspError').html('');
                $('#rspError').hide();
                return true;
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SaveResponseType() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    }

    //Average type radio button click
    function Avgtyperdbchanged(data, event) {
        try {
            //Toggle the weighted average flag
            document.getElementById(event.currentTarget.id).checked = true;
            if (event.currentTarget.value == "SimpleAverage") {
                HmViewModel.WeightedAverageType(false);
            }
            else {
                HmViewModel.WeightedAverageType(true);
            }
            return true;

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SaveResponseType() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    }

    function isGlobalFlagChange(data, event) {
        try {
            document.getElementById(event.currentTarget.id).checked = true;
            HmViewModel.isGlobalFlag(!HmViewModel.isGlobalFlag());
            if (HmViewModel.isGlobalFlag()) {

            }
            return true;

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: isGlobalFlagChange() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    }

    //Response applicability checkbox for third response click
    function responsepapplicabilityclick(data, event) {
        try {

            if (data.calculationapplicability3() && $('#WghtdAvg').is(':checked')) {
                $('#rspweightings3').attr('disabled', false);
            }

            else {
                $('#rspweightings3').attr('disabled', true);
            }

            return true;
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: responsepapplicabilityclick() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    }

    function jsTreeModel(item) {
        var self = this;

        self.id = item.AreaLevelId.toString();
        self.text = item.AreaLevelName;
        if (HmViewModel.AreaLeveljstree()[self.id].length > 0) {
            self.nodes = $.map(HmViewModel.AreaLeveljstree()[self.id], function (result) {
                return new jsTreeModel(result);
            });
        }
        self.state = { expanded: false };
        self.dead_node = item.DeadNode;
        self.assessmentTypeList = ko.observableArray(item.AssessmentTypeList);
    }


    function RiskAreaSortOrderDupModel(item) {
        try {
            var self = this;
            self.SortOrder = ko.observable(item.SortOrder());
            self.RiskAreaName = ko.observable(item.RiskAreaName());
            self.RiskAreaId = ko.observable(item.RiskAreaId());
            HmViewModel.RiskAreaSortOrder(HmViewModel.RiskAreaSortOrder() + 1);
        } catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RiskAreaSortOrderDupModel() method in RiskAreaAndFactors.js';
            logger.logMessage(msg);
        }
    }

    function RiskAreaReorderModel(item) {
        var self = this;
        self.SortOrder = ko.observable(HmViewModel.RiskAreaSortOrder() + 1);
        if (item.RiskAreaName.length > 0)
            self.RiskAreaName = ko.observable($('<div/>').html(item.RiskAreaName).text());
        else
            self.RiskAreaName = ko.observable($('<div/>').html(item.RiskAreaName()).text());
        self.RiskAreaId = ko.observable(item.RiskAreaId);
        HmViewModel.RiskAreaSortOrder(HmViewModel.RiskAreaSortOrder() + 1);
    }


    function RiskAreaReorderModelSortOrder(item) {
        try {
            var self = this;
            self.SortOrder = ko.observable(item.SortOrder);
            self.RiskAreaName = ko.observable($('<div/>').html(item.RiskAreaName).text());
            self.RiskAreaId = ko.observable(item.RiskAreaId());
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RiskAreaReorderModelSortOrder() method in RiskAreaAndFactors.js';
            logger.logMessage(msg);
        }
    }
    function RiskFactorReorderModelSortOrder(item) {
        try {
            var self = this;
            self.SortOrder = ko.observable(item.SortOrder);
            self.RiskFactorNameClean = ko.observable($('<div/>').html(item.RiskFactorNameClean).text());
            self.RiskAreaId = ko.observable(item.RiskAreaId());
            self.RiskFactorId = ko.observable(item.RiskFactorId());

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RiskFactorReorderModelSortOrder() method in RiskAreaAndFactors.js';
            logger.logMessage(msg);
        }
    }
    function RiskAreaModel(item) {
        try {
            var self = this;
            self.RiskAreaName = ko.observable($('<div/>').html(item.RiskAreaName).text());
            if (item.AssessmentIdList != undefined && item.AssessmentIdList != null) {
                var MappedAssessments = $.map(item.AssessmentIdList, function (result) {
                    return new AssessmentModel(result);
                });
            }
            self.MappedAssessmentType = ko.observableArray(MappedAssessments);
            self.RiskAreaId = ko.observable(item.RiskAreaId);
            self.RiskAreaType = ko.observable($('<div/>').html(item.RiskAreaType).text());
            self.AMLRank = ko.observable($('<div/>').html(item.AMLRank).text());
            self.SANCRank = ko.observable($('<div/>').html(item.SANCRank).text());
            self.RiskAreaNotes = ko.observable($('<div/>').html(item.RiskAreaNotes).text());
            self.TargetRow = ko.observable();
            self.RiskAreaType = ko.observable($('<div/>').html(item.RiskAreaType).text());
            self.RiskAreaSubList = ko.observableArray(item.RiskAreaSubList);
            self.ZATIdList = ko.observable(item.ZATIdList);
            self.ZATNames = ko.observable(item.ZATNames);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RiskAreaModel() method in RiskAreaAndFactors.js';
            logger.logMessage(msg);
        }
    };

    function AssessmentModel(item) {
        try {
            var self = this;
            if (isNaN(item)) {
                self.ID = item.ID
            }
            else {
                self.ID = item;
            }

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RiskFactorSortOrderDupModel() method in RiskAreaAndFactors.js';
            logger.logMessage(msg);
        }
    }
    function RiskFactorSortOrderDupModel(item) {
        try {
            var self = this;
            self.SortOrder = ko.observable(item.SortOrder());
            self.RiskFactorNameClean = ko.observable(item.RiskFactorNameClean());
            self.RiskFactorId = ko.observable(item.RiskFactorId());
            self.RiskAreaId = ko.observable(item.RiskAreaId());
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RiskFactorSortOrderDupModel() method in RiskAreaAndFactors.js';
            logger.logMessage(msg);
        }
    }

    function RiskFactorSortModel(item) {
        try {
            var self = this;
            self.SortOrder = ko.observable(HmViewModel.RiskFactorSortOrder() + 1);
            if (item.RiskFactorNameClean.length > 0)
                self.RiskFactorNameClean = ko.observable($('<div/>').html(item.RiskFactorNameClean).text());
            else
                self.RiskFactorNameClean = ko.observable($('<div/>').html(item.RiskFactorNameClean()).text());
            self.RiskFactorId = ko.observable(item.RiskFactorId);
            self.RiskAreaId = ko.observable(item.RiskAreaId);
            self.CalculationApplicabilityFlag = ko.observable(item.CalculationApplicabilityFlag);
            HmViewModel.RiskFactorSortOrder(HmViewModel.RiskFactorSortOrder() + 1);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RiskFactorSortModel() method in RiskAreaAndFactors.js';
            logger.logMessage(msg);
        }
    }

    function RiskFactorModel(item) {
        try {
            var self = this;
            self.RiskFactorName = ko.observable($('<div/>').html(item.RiskFactorNameClean).text());
            self.RiskFactorId = ko.observable(item.RiskFactorId);
            self.RiskAreaId = ko.observable(item.RiskAreaId);
            self.CalculationApplicabilityFlag = ko.observable(item.CalculationApplicabilityFlag);
            if (item.AssessmentIdList != undefined && item.AssessmentIdList != null) {
                var MappedAssessments = $.map(item.AssessmentIdList, function (result) {
                    return new AssessmentModel(result);
                });
            }
            self.MappedAssessmentType = ko.observableArray(MappedAssessments);
            self.AMLNumbering = ko.observable($('<div/>').html(item.AMLRank).text());
            self.SANCNumbering = ko.observable($('<div/>').html(item.SANCRank).text());

            self.RiskAreaName = ko.observable($('<div/>').html(item.RiskAreaName).text());
            self.AssessmentType = ko.observable($('<div/>').html(item.AssessmentType).text());
            self.TargetRow = ko.observable();
            self.FactorRiskAreaList = ko.observableArray(item.RiskAreaSubList);
            self.ZATIdList = ko.observable(item.ZATIdList);
            self.ZATNames = ko.observable(item.ZATNames);
            self.QuestionGuideline = ko.observable(item.QuestionGuideline);
            self.ResponseOptionTypeList = $.map(item.ResponseOptionTypeModelObject, function (result) {
                return new ResponseOptionModel(result);
            });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RiskFactorModel() method in RiskAreaAndFactors.js';
            logger.logMessage(msg);
        }
    };
    function ResponseOptionModel(item) {
        try {
            var self = this;

            self.ResponseTypeId = ko.observable(item.ResponseTypeId);
            self.ResponseTypeName = ko.observable(item.ResponseTypeName);
            self.OptionTypeShortName = ko.observable(item.OptionTypeShortName);
            self.AssessmentType = ko.observable(item.AssessmentType);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RiskAreaModel() method in QualitativeSetup.js';
            logger.logMessage(msg);
        }
    }

    function RiskSubFactorSortModelDup(item) {
        try {
            var self = this;
            self.SortOrder = ko.observable(item.SortOrder());
            self.RiskFactorId = ko.observable(item.RiskFactorId());
            self.RiskSubfactorId = ko.observable(item.RiskSubfactorId());
            self.RiskSubfactorName = ko.observable(item.RiskSubfactorName());
        }
        catch (e) {

            var msg = 'Exception: ' + e + ' | Source: RiskSubFactorSortModel() method in RiskAreaAndFactors.js';
            logger.logMessage(msg);
        }
    }
    function RiskSubFactorReorderModelSortOrder(item) {
        try {
            var self = this;
            self.SortOrder = ko.observable(item.SortOrder);
            self.RiskFactorId = ko.observable(item.RiskFactorId);
            self.RiskSubfactorId = ko.observable(item.RiskSubfactorId);
            self.RiskSubfactorName = ko.observable($('<div/>').html(item.RiskSubfactorName).text());
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RiskSubFactorReorderModelSortOrder() method in RiskAreaAndFactors.js';
            logger.logMessage(msg);
        }
    }
    function RiskSubFactorSortModel(item) {
        try {
            var self = this;
            self.SortOrder = ko.observable(HmViewModel.RiskSubFactorSortOrder() + 1);
            self.RiskFactorId = ko.observable(item.RiskFactorId);
            self.RiskSubfactorId = ko.observable(item.RiskSubfactorId);
            if (item.RiskSubfactorName.length > 0)
                self.RiskSubfactorName = ko.observable($('<div/>').html(item.RiskSubfactorName).text());
            else
                self.RiskSubfactorName = ko.observable($('<div/>').html(item.RiskSubfactorName()).text());

            HmViewModel.RiskSubFactorSortOrder(HmViewModel.RiskSubFactorSortOrder() + 1);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RiskScoreModel() method in RiskAreaAndFactors.js';
            logger.logMessage(msg);
        }
    }
    function QuanResponseColumnDetails(item) {
        try {
            var self = this;
            self.ResponseId = ko.observable(item.ResponseId);
            self.SelectedComponentIRiskId = ko.observable($('<div/>').html(item.RiskLevelId).text());
            self.RiskLevelId = ko.observable(item.RiskLevelId);

            self.RiskScale = ko.observable();
            self.ResponseType = ko.observable(item.ResponseType);
            self.calculationapplicability = ko.observable(item.calculationapplicability);
            self.weightings = ko.observable(item.weightings);
            self.response = ko.observable(item.response);
            self.SimpleAverageflag = ko.observable(item.SimpleAverageflag);
            self.AssessmentType = ko.observable(item.AssessmentType);
            self.AssessmentTypeId = ko.observable(item.AssessmentTypeId);
            self.description = ko.observable("");
            self.currencyapplicability = ko.observable(false);
            self.Rank = ko.observable(0);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: QuanResponseColumnDetails() method in RiskAreaAndFactors.js';
            logger.logMessage(msg);
        }
    }
    function QuantitativeResponseColumnsModel(item) {
        try {
            var self = this;
            self.ResponseId = ko.observable(item.ResponseId);
            self.RiskLevelId = ko.observable(item.RiskLevelId);
            if (item.SelectedComponentIRiskId = null) {
                var selectedRiskIds = [];
                var data = item.SelectedComponentIRiskId.toString().split(',');
                for (var j = 0; j < data.length; j++) {
                    if (!isNaN(data[j]))
                        selectedRiskIds.push((data[j].toString().trim()));
                }
            }
            self.SelectedComponentIRiskId = ko.observableArray(selectedRiskIds);
            // self.SelectedComponentIRiskId = ko.observable($('<div/>').html(item.RiskLevelId).text());
            self.Rank = ko.observable(item.Rank);
            self.ResponseType = ko.observable(item.ResponseType);
            self.description = ko.observable(item.description);
            self.calculationapplicability = ko.observable(item.calculationapplicability);
            self.currencyapplicability = ko.observable(item.currencyapplicability);
            self.weightings = ko.observable(item.weightings);
            self.response = ko.observable(item.response);
            self.SimpleAverageflag = ko.observable(item.SimpleAverageflag);
            self.isGlobalFlag = ko.observable(item.isGlobalFlag);
            self.AssessmentType = ko.observable(item.AssessmentType);
            self.AssessmentTypeId = ko.observable(item.AssessmentTypeId);
            self.OptionTypeShortName = ko.observable(item.OptionTypeShortName);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: QuantitativeResponseColumnsModel() method in RiskAreaAndFactors.js';
            logger.logMessage(msg);
        }
    }
    function RiskSubFactorModel(item) {
        try {
            var self = this;
            self.RiskFactorId = ko.observable(item.RiskFactorId);
            self.RiskSubfactorId = ko.observable(item.RiskSubfactorId);
            self.RiskSubfactorName = ko.observable($('<div/>').html(item.RiskSubfactorName).text());
            self.RiskLevel = ko.observable($('<div/>').html(item.RiskLevel).text());
            self.AssessmentType = ko.observable($('<div/>').html(item.AssessmentType).text());
            self.AssessmentTypeId = ko.observable($('<div/>').html(item.AssessmentTypeId).text());
            self.RiskMapping = ko.observable($('<div/>').html(item.RiskMapping).text())
            self.TargetRow = ko.observable(-1);
            self.RiskAreaSubList = ko.observableArray(item.RiskAreaSubList);
            self.QuestionType = ko.observable(item.QuestionType);
            self.QuestionTypeDescription = ko.observable(item.QuestionTypeDescription);
            self.HeaderUID = ko.observable(item.HeaderUID);
            self.QuestionGuideline = ko.observable(item.QuestionGuideline);
            self.CalculationApplicabilityFlag = ko.observable(item.CalculationApplicabilityFlag);

            if (item.CalculationApplicabilityFlag)
                self.ApplicabilityFlag = "Yes";
            else
                self.ApplicabilityFlag = "No";

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RiskSubFactorModel() method in RiskAreaAndFactors.js';
            logger.logMessage(msg);
        }
    };

    function RiskScoreModel(item) {
        try {
            var self = this;
            self.Id = ko.observable(item.Id);
            self.DisplayText = ko.observable($('<div/>').html(item.DisplayText).text());
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RiskScoreModel() method in RiskAreaAndFactors.js';
            logger.logMessage(msg);
        }
    }

    function SurveyModel(item) {
        try {
            var self = this;
            self.SurveyName = ko.observable($('<div/>').html(item.SurveyName).text());
            self.SurveySecondName = ko.observable($('<div/>').html(item.SurveySecondName).text());
            self.surveyType = ko.observable($('<div/>').html(item.surveyType).text());
            self.SurveyStatus = ko.observable(item.SurveyStatus);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SurveyModel() method in RiskAreasFactors.js';
            logger.logMessage(msg);
        }
    }
    function AssessmentListModel(item) {
        try {
            var self = this;
            self.AssessmentId = ko.observable($('<div/>').html(item.AssessmentId).text());
            self.AssessmentName = ko.observable(item.AssessmentName);
            self.AssessmentDisplayName = ko.observable($('<div/>').html(item.AssessmentDisplayName).text());
            self.Description = ko.observable($('<div/>').html(item.Description).text());
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: AssessmentListModel() method in RiskAreasFactors.js';
            logger.logMessage(msg);
        }
    }
    function FilteredAssessmentListModel(item) {
        try {
            var self = this;
            self.AssessmentId = ko.observable($('<div/>').html(item.AssessmentId()).text());
            self.AssessmentName = ko.observable(item.AssessmentName());
            self.AssessmentDisplayName = ko.observable($('<div/>').html(item.AssessmentDisplayName()).text());
            self.Description = ko.observable($('<div/>').html(item.Description()).text());
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: FilteredAssessmentListModel() method in RiskAreasFactors.js';
            logger.logMessage(msg);
        }
    }
    function RiskLevelModel(item) {
        try {
            var self = this;
            self.RiskLevelId = item.RiskLevelId;
            self.RiskLevelName = item.RiskLevelName;
            self.RiskLevelShortText = item.RiskLevelShortText;
            self.ScoringType = item.ScoringType;
            self.LevelCount = item.RiskLevelCount;
            self.AssessmentTypeId = item.AssessmentId;
            self.isQuantitative = item.isQuantitative;
            self.MappedRiskLevels = $.map(item.RiskLevelDetailsModel, function (result) {
                return new InherentRiskLevelModel(result);
            });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RiskLevelModel() method in RiskAreasFactors.js';
            logger.logMessage(msg);
        }
    }
    function InherentRiskLevelModel(item) {
        try {
            var self = this;
            self.RiskLevelId = item.RiskLevelId;
            self.RiskLevelParentId = item.RiskLevelParentId;
            self.RiskLevelcss = item.RiskLevelcss;
            self.RiskLevelComents = item.RiskLevelComents;
            self.RiskLevelDescription = item.RiskLevel + ' - ' + item.RiskLevelDescription;
            self.RiskLevel = item.RiskLevel;
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: InherentRiskLevelModel() method in RiskAreasFactors.js';
            logger.logMessage(msg);
        }
    }

    function ZATRATModel(ZATID, ZATNAME, RATID) {
        try {
            var self = this;
            self.ZAT_UID = ko.observable(ZATID);
            self.ZATName = ko.observable(ZATNAME);
            self.RAT_UID = ko.observable(RATID);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ZATRATModel() method in RiskAreasFactors.js';
            logger.logMessage(msg);
        }
    }

    function RiskSubFactorHeaderModel(item) {
        try {
            var self = this;
            self.HeaderSubFactorId = ko.observable(item.HeaderSubFactorId);
            self.HeaderSubFactorName = ko.observable(item.HeaderSubFactorName);
            self.ApplicableRATId = ko.observable(item.ApplicableRATId);
            self.ApplicableRATNames = ko.observable(item.ApplicableRATIdNames);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RiskSubFactorHeaderModel() method in RiskAreasFactors.js';
            logger.logMessage(msg);
        }
    }


    function GetLanguageName(languageId) {
        if (HmViewModel.ObjGeneralSettings.LanguageList().length == 0) {
            HmViewModel.ObjGeneralSettings.getLanguages();
        }
        for (var i = 0; i < HmViewModel.ObjGeneralSettings.LanguageList().length; i++) {
            if (HmViewModel.ObjGeneralSettings.LanguageList()[i].LANGUAGE_ID().toString() == languageId)
                return HmViewModel.ObjGeneralSettings.LanguageList()[i].LANGUAGENAME();
        }
        return ""; // The object was not found
    }
});

